export default {
  'pages.layouts.userLayout.title': 'CINO AsPiCe 开发系统',
  'pages.layouts.userLayout.subtitle':
    '专业的汽车软件过程改进及能力评估解决方案，助力企业提升软件开发能力，实现卓越品质。',
  'pages.layouts.userLayout.copyright': '版权所有 ©2025 续创信息技术咨询（成都）有限公司',
  'pages.layouts.userLayout.feature.quickStart': '快速上手，轻松合规',
  'pages.layouts.userLayout.feature.aiAssist': '智能AI助力，效率飞跃',
  'pages.layouts.userLayout.feature.teamWork': '团队协作无缝衔接',
  'pages.layouts.userLayout.feature.projectControl': '项目进度，尽在掌控',
  'pages.layouts.userLayout.feature.auditDisplay': '审核展示，一键搞定',
  'pages.layouts.userLayout.feature.traceability': '追溯性保障，精准无误',
  'pages.layouts.userLayout.feature.dataAssets': '数据沉淀，资产传承',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.403.subTitle': '抱歉，您没有访问权限。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // 系统概览页面
  'pages.system.overview.userCount': '用户总数',
  'pages.system.overview.projectCount': '项目总数',
  'pages.system.overview.templateCount': '模板总数',
  'pages.system.overview.documentCount': '工作成果总数',
  'pages.system.overview.latestProjects': '最新项目',
  'pages.system.overview.companyInfo': '企业信息',
  'pages.system.overview.viewAll': '查看全部',
  'pages.system.overview.edit': '编辑',
  'pages.system.overview.projectName': '项目名称',
  'pages.system.overview.memberCount': '成员数',
  'pages.system.overview.documentCountColumn': '工作成果数',
  'pages.system.overview.updateTime': '更新时间',
  'pages.system.overview.companyName': '企业名称',
  'pages.system.overview.companyShortName': '企业简称',
  'pages.system.overview.companyLogo': '企业Logo',
  'pages.system.overview.companyDescription': '企业简介',

  // 用户列表页面
  'pages.system.users.userId': '用户ID',
  'pages.system.users.userName': '姓名',
  'pages.system.users.userEmail': '邮箱',
  'pages.system.users.userDepartment': '单位/部门',
  'pages.system.users.userRole': '权限',
  'pages.system.users.createTime': '创建时间',
  'pages.system.users.projects': '所属项目',
  'pages.system.users.status': '状态',
  'pages.system.users.actions': '操作',
  'pages.system.users.searchPlaceholder': '输入用户ID，姓名或邮箱搜索用户',
  'pages.system.users.search': '搜索',
  'pages.system.users.addUser': '添加用户',
  'pages.system.users.delete': '删除',
  'pages.system.users.confirmDelete': '确认删除',
  'pages.system.users.confirmDeleteContent': '确定要删除用户 {{name}} 吗？',
  'pages.system.users.enableSuccess': '启用成功',
  'pages.system.users.disableSuccess': '禁用成功',
  'pages.system.users.enableFailed': '启用失败',
  'pages.system.users.disableFailed': '禁用失败',
  'pages.system.users.deleteSuccess': '删除成功',
  'pages.system.users.deleteFailed': '删除失败',
  'pages.system.users.addUserSuccess': '添加用户成功',
  'pages.system.users.addUserFailed': '添加用户失败',
  'pages.system.users.addUserModal.title': '添加用户',
  'pages.system.users.addUserModal.email': '邮箱',
  'pages.system.users.addUserModal.emailRequired': '请输入用户邮箱',
  'pages.system.users.addUserModal.emailInvalid': '请输入有效的邮箱地址',
  'pages.system.users.addUserModal.emailPlaceholder': '请输入用户邮箱',
  'pages.system.users.addUserModal.department': '单位/部门',
  'pages.system.users.addUserModal.departmentPlaceholder': '请输入用户的单位/部门',
  'pages.system.users.roles.admin': '管理员',
  'pages.system.users.roles.aspice_specialist': 'ASPICE专员',
  'pages.system.users.roles.user': '普通用户',
  'pages.system.users.grant': '授权',
  'pages.system.users.toSpecialist': '转为 ASPICE 专员',
  'pages.system.users.toUser': '转为普通用户',
  'pages.system.users.confirmRoleChange': '确认权限变更',
  'pages.system.users.confirmToSpecialistContent': '确定要将用户 {{name}} 转为 ASPICE 专员吗？',
  'pages.system.users.confirmToUserContent': '确定要将用户 {{name}} 转为普通用户吗？',
  'pages.system.users.roleChangeSuccess': '权限变更成功',
  'pages.system.users.roleChangeFailed': '权限变更失败',
  'pages.system.users.resetPassword': '重置密码',
  'pages.system.users.resetPasswordModal.title': '重置密码',
  'pages.system.users.resetPasswordModal.confirmContent':
    '确定要重置用户 {{name}} 的密码吗？重置后原密码立即失效。',
  'pages.system.users.resetPasswordModal.mode': '新密码来源',
  'pages.system.users.resetPasswordModal.auto': '自动生成',
  'pages.system.users.resetPasswordModal.manual': '手动指定',
  'pages.system.users.resetPasswordModal.password': '新密码',
  'pages.system.users.resetPasswordModal.passwordRequired': '请输入新密码',
  'pages.system.users.resetPasswordModal.passwordTooShort': '密码长度不能少于 6 位',
  'pages.system.users.resetPasswordModal.passwordPlaceholder': '请输入新密码（至少 6 位）',
  'pages.system.users.resetPasswordSuccess': '密码重置成功',
  'pages.system.users.resetPasswordFailed': '密码重置失败',
  'pages.system.users.resetPasswordResult.content':
    '新密码如下，请复制后告知用户（关闭后不再显示）：',
  'pages.system.users.resetPasswordResult.emailSent': '通知邮件已发送',
  'pages.system.users.resetPasswordResult.emailFailed': '通知邮件发送失败，请线下告知用户',

  // 项目列表页面
  'pages.aspice.projects.projectId': '项目ID',
  'pages.aspice.projects.projectName': '项目名称',
  'pages.aspice.projects.projectManager': '项目经理',
  'pages.aspice.projects.memberCount': '项目人数',
  'pages.aspice.projects.createTime': '创建时间',
  'pages.aspice.projects.documentCount': '工作成果数量',
  'pages.aspice.projects.actions': '操作',
  'pages.aspice.projects.view': '查看',
  'pages.aspice.projects.searchPlaceholder': '输入ID或项目名称搜索',
  'pages.aspice.projects.search': '搜索',
  'pages.aspice.projects.detailModal.title': '项目详情',
  'pages.aspice.projects.detailModal.projectId': '项目ID',
  'pages.aspice.projects.detailModal.projectName': '项目名称',
  'pages.aspice.projects.detailModal.projectDescription': '项目描述',
  'pages.aspice.projects.detailModal.memberCount': '项目人数',
  'pages.aspice.projects.detailModal.documentCount': '工作成果数量',
  'pages.aspice.projects.detailModal.projectManager': '项目经理',
  'pages.aspice.projects.detailModal.managerEmail': '经理邮箱',
  'pages.aspice.projects.detailModal.createTime': '创建时间',
  'pages.aspice.projects.detailModal.updateTime': '更新时间',

  // 系统设置页面
  'pages.system.settings.companyInfo': '企业信息',
  'pages.system.settings.licenseManagement': '授权管理',
  'pages.system.settings.emailSettings': '邮箱设置',
  'pages.system.settings.otherSettings': '其他设置',
  'pages.system.settings.edit': '编辑',
  'pages.system.settings.updateLicense': '更新授权',
  'pages.system.settings.save': '保存',
  'pages.system.settings.cancel': '取消',
  'pages.system.settings.submit': '提交',
  'pages.system.settings.updateSuccess': '更新成功',
  'pages.system.settings.updateFailed': '更新失败',

  // 企业信息
  'pages.system.settings.company.name': '企业名称',
  'pages.system.settings.company.shortName': '企业简称',
  'pages.system.settings.company.shortNameHelp': '将出现在导出文档的名称中',
  'pages.system.settings.company.logo': '企业Logo',
  'pages.system.settings.company.logoHelp': '建议尺寸：200x60px，格式：PNG/JPG，大小：小于2MB',
  'pages.system.settings.company.description': '企业简介',
  'pages.system.settings.company.uploadLogo': '上传Logo',
  'pages.system.settings.company.currentLogo': '当前logo',
  'pages.system.settings.company.notSet': '未设置',

  // 授权管理
  'pages.system.settings.license.version': '授权版本',
  'pages.system.settings.license.customerInfo': '客户信息',
  'pages.system.settings.license.validUntil': '服务有效期',
  'pages.system.settings.license.maxUsers': '最大用户数',
  'pages.system.settings.license.currentUsers': '当前用户数',
  'pages.system.settings.license.daysRemaining': '剩余天数',
  'pages.system.settings.license.status': '授权状态',
  'pages.system.settings.license.valid': '有效',
  'pages.system.settings.license.invalid': '无效',
  'pages.system.settings.license.days': '天',
  'pages.system.settings.license.updateTitle': '更新授权',
  'pages.system.settings.license.licenseKey': '授权码',
  'pages.system.settings.license.licenseKeyPlaceholder': '请输入您获得的授权码对系统授权进行更新',
  'pages.system.settings.license.licenseKeyRequired': '请输入您获得的授权码对系统授权进行更新',
  'pages.system.settings.license.updateSuccessMessage':
    'License更新成功，客户: {{customer}}, 有效期至: {{validUntil}}, 最大用户数: {{maxUsers}}',

  // 邮箱设置
  'pages.system.settings.email.smtpServer': 'SMTP服务器',
  'pages.system.settings.email.port': '端口',
  'pages.system.settings.email.username': '邮箱账号',
  'pages.system.settings.email.password': '密码',

  // AI设置
  'pages.system.settings.ai.enabled': '启用AI功能',
  'pages.system.settings.ai.endpoint': 'API Endpoint',
  'pages.system.settings.ai.apiKey': 'API Key',
  'pages.system.settings.ai.parameters': '请求参数',
  'pages.system.settings.ai.endpointPlaceholder': '例如：https://api.deepseek.com/v1',
  'pages.system.settings.ai.endpointRequired': '请输入API Endpoint',
  'pages.system.settings.ai.apiKeyPlaceholder': '请输入API Key',
  'pages.system.settings.ai.apiKeyRequired': '请输入API Key',
  'pages.system.settings.ai.parametersPlaceholder': '{"temperature": 0.7, "max_tokens": 2048}',
  'pages.system.settings.ai.parametersHelp':
    'JSON格式，例如：{"temperature": 0.7, "max_tokens": 2048}',
  'pages.system.settings.ai.yes': '是',
  'pages.system.settings.ai.no': '否',
  'pages.system.settings.ai.allowPMSelectAllUsers': '允许项目经理选择所有用户',
  'pages.system.settings.ai.allowPMSelectAllUsersHelp':
    '开启后，项目经理在添加成员时可以选择平台上的所有用户；关闭时只能选择已在项目中的用户',
  'pages.system.settings.ai.onlyAspiceSpecialistCreateProject': '只允许 Aspice 专员创建项目',
  'pages.system.settings.ai.onlyAspiceSpecialistCreateProjectHelp':
    '开启后，只有 Aspice 专员可以创建新项目',
  'pages.system.settings.ai.enableKeepOriginalFile': '启用保持原始文件',
  'pages.system.settings.ai.enableKeepOriginalFileHelp':
    '开启后，上传本地文件时可选择保持原始文件格式',

  // 账号信息页面
  'pages.account.settings.title': '账号信息',
  'pages.account.settings.updateProfile': '更新信息',
  'pages.account.settings.changePassword': '修改密码',
  'pages.account.settings.name': '姓名',
  'pages.account.settings.email': '邮箱',
  'pages.account.settings.phone': '手机号',
  'pages.account.settings.department': '部门',
  'pages.account.settings.position': '职位',
  'pages.account.settings.signature': '手写签名',
  'pages.account.settings.noSignature': '暂无签名',
  'pages.account.settings.currentPassword': '当前密码',
  'pages.account.settings.newPassword': '新密码',
  'pages.account.settings.confirmPassword': '确认新密码',
  'pages.account.settings.passwordMismatch': '两次输入的密码不一致',

  // 项目概览页面
  'pages.projectOverview.notJoinedProject': '您未加入任何项目，可以联系项目经理邀请您加入项目。',
  'pages.projectOverview.notJoinedProjectMananger': '如果您是项目经理，可以创建新的项目。',
  'pages.projectOverview.createNewProject': '创建新项目',
  'pages.projectOverview.createNewProjectModal': '创建新项目',
  'pages.projectOverview.projectName': '项目名称',
  'pages.projectOverview.projectNamePlaceholder': '请输入项目名称',
  'pages.projectOverview.projectDescription': '项目描述',
  'pages.projectOverview.projectDescriptionPlaceholder': '请输入项目描述',
  'pages.projectOverview.aspiceVModel': 'ASPICE V 模型',
  'pages.projectOverview.notSelected': '未选择',
  'pages.projectOverview.owner': '负责人',
  'pages.projectOverview.notAssigned': '未分配',
  'pages.projectOverview.workProducts': '工作成果',
  'pages.projectOverview.processConfiguration': '过程配置',
  'pages.projectOverview.createSuccess': '项目创建成功！',
  'pages.projectOverview.createFailed': '创建失败，请重试！',
  'pages.projectOverview.switchSuccess': '已切换到项目：',
  'pages.projectOverview.switchFailed': '项目切换失败，请手动切换项目！',
  'pages.projectOverview.userInfoFailed': '获取用户信息失败，请重新登录！',

  // Project overview statistics
  'pages.projectOverview.stats.totalProcesses': '过程总数',
  'pages.projectOverview.stats.totalProcessesDesc': '项目中的所有过程数量',
  'pages.projectOverview.stats.totalWorkProducts': '工作成果总数',
  'pages.projectOverview.stats.totalWorkProductsDesc': '项目中的所有工作成果数量',
  'pages.projectOverview.stats.publishedWorkProducts': '已发布工作成果',
  'pages.projectOverview.stats.publishedWorkProductsDesc': '已发布的工作成果数量',
  'pages.projectOverview.stats.memberCount': '成员数量',
  'pages.projectOverview.stats.memberCountDesc': '参与项目的成员数量',

  // File Info Table (Work Product Preview)
  'pages.fileInfoTable.fileName': '文件名称',
  'pages.fileInfoTable.version': '版本',
  'pages.fileInfoTable.updateTime': '更新时间',
  'pages.fileInfoTable.actions': '操作',
  'pages.fileInfoTable.downloadFile': '下载文件',
  'pages.fileInfoTable.updateFile': '更新文件',
  'pages.fileInfoTable.fileIdNotExist': '文件ID不存在',
  'pages.fileInfoTable.downloadStarted': '文件下载已开始',
  'pages.fileInfoTable.downloadFailed': '文件下载失败，请重试',
  'pages.fileInfoTable.onlyExcelFiles': '只能上传Excel文件 (.xlsx, .xls)',
  'pages.fileInfoTable.fileSizeLimit': '文件必须小于50MB',
  'pages.fileInfoTable.uploadFailed': '文件上传失败',
  'pages.fileInfoTable.tip':
    '提示：您可以下载文件到本地进行修改，完成后通过"更新文件"按钮上传更新的文件。',

  // Document Editor Header
  'pages.docEditor.header.draft': '草稿',
  'pages.docEditor.header.draftLocked': '草稿锁定',
  'pages.docEditor.header.review': '评审中',
  'pages.docEditor.header.reviewPassed': '评审通过',
  'pages.docEditor.header.auditPassed': '审核通过',
  'pages.docEditor.header.approved': '已批准',
  'pages.docEditor.header.controlled': '已受控',
  'pages.docEditor.header.published': '已发布',
  'pages.docEditor.header.obsolete': '已废弃',
  'pages.docEditor.header.save': '保存',
  'pages.docEditor.header.submitReview': '提交评审',
  'pages.docEditor.header.submitChange': '提交变更',
  'pages.docEditor.header.reviewDocument': '评审文档',
  'pages.docEditor.header.updateReview': '更新评审人',
  'pages.docEditor.header.export': '导出文档',
  'pages.docEditor.header.edit': '编辑',
  'pages.docEditor.header.close': '关闭',
  'pages.docEditor.header.problem': '问题',
  'pages.docEditor.header.compare': '对比',
  'pages.docEditor.compare.title': '文档对比',
  'pages.docEditor.compare.baseDocument': '对比文档',
  'pages.docEditor.compare.currentDocument': '当前文档',
  'pages.docEditor.compare.selectPlaceholder': '请选择文档',
  'pages.docEditor.compare.searchEmpty': '无匹配文档',
  'pages.docEditor.compare.deleted': '删除',
  'pages.docEditor.compare.added': '新增',
  'pages.docEditor.compare.emptyContent': '暂无内容',
  'pages.docEditor.compare.selectToCompare': '请选择左侧文档后开始对比',
  'pages.docEditor.compare.loadFailed': '加载对比文档失败',
  'pages.docEditor.compare.loadListFailed': '加载文档列表失败',
  'pages.docEditor.compare.unsupported': '该格式暂不支持内容对比',
  'pages.docEditor.compare.sheetMissing': '此文档没有该 Sheet',
  'pages.docEditor.compare.formatDiffer': '所选文档与当前文档格式不同，已按文本对比',

  // Excel Table Component
  'pages.excelTable.groupDisplay': '分组显示',
  'pages.excelTable.rowIndex': '#',
  'pages.excelTable.configTrace': '配置追溯',
  'pages.excelTable.addColumn': '添加列',
  'pages.excelTable.deleteColumn': '删除列',
  'pages.excelTable.deleteColumnConfirm': '确定删除列「{{title}}」吗？此操作不可撤销。',
  'pages.excelTable.addRow': '添加行',
  'pages.excelTable.copyRow': '复制当前行',
  'pages.excelTable.insertRow': '插入空白行',
  'pages.excelTable.deleteSelectedRows': '删除所选行',
  'pages.excelTable.deleteSelectedRowsConfirm': '确定删除所选的 {{rows}} 行吗？此操作不可撤销。',
  'pages.excelTable.mergeCells': '合并单元格',
  'pages.excelTable.unmergeCells': '取消合并单元格',
  'pages.excelTable.mergeCellsTip': '拖动或按住 Shift 选中多个单元格后合并',
  'pages.excelTable.unmergeCellsTip': '选中已合并的单元格后取消合并，文字保留在第一个单元格',
  'pages.excelTable.mergeNeedSelection': '请先选中至少两个单元格',
  'pages.excelTable.unmergeNeedSelection': '请选中已合并的单元格',
  'pages.excelTable.unmergeHeaderTip': '选中已合并的表头后取消合并，按跨列数量恢复各列表头',
  'pages.excelTable.mergeHeaderAndBodyDisabled': '表头和内容单元格不能一起合并',
  'pages.excelTable.mergeGroupedDisabled': '请先关闭分组显示',
  'pages.excelTable.mergeChoiceDescription': '选定区域包含不同的内容，请选择您期望的合并方式。',
  'pages.excelTable.mergeKeepFirst': '保留第一个单元格的内容',
  'pages.excelTable.mergeKeepAll': '保留所有单元格的内容',
  'pages.excelTable.mergeChoiceConfirm': '确定',
  'pages.excelTable.fontFamily': '字体',
  'pages.excelTable.fontSize': '字号',
  'pages.excelTable.fontColor': '字体颜色',
  'pages.excelTable.bold': '加粗',
  'pages.excelTable.alignTop': '顶端对齐',
  'pages.excelTable.alignMiddle': '垂直居中',
  'pages.excelTable.alignBottom': '底端对齐',
  'pages.excelTable.alignLeft': '左对齐',
  'pages.excelTable.alignCenter': '水平居中',
  'pages.excelTable.alignRight': '右对齐',
  'pages.excelTable.cellColor': '单元格颜色',
  'pages.excelTable.presetColors': '标准色',
  'pages.excelTable.clearFormat': '清除格式',
  'pages.excelTable.formatNeedSelection': '请先选中要设置格式的单元格',
  'pages.excelTable.deleteHeaderGroup': '删除分组',
  'pages.excelTable.deleteHeaderGroupConfirm':
    '确定删除表格头分组「{{title}}」吗？此操作不可撤销。',
  'pages.excelTable.cancel': '取消',
  'pages.excelTable.noData': '暂无数据',
  'pages.excelTable.configTraceTitle': '配置追溯关系',
  'pages.excelTable.loading': '加载中...',
  'pages.excelTable.noTraceDocuments': '无可用的追溯文档',
  'pages.excelTable.configTraceDescription': '请为每个追溯文档选择对应的列，用于保存追溯关系：',
  'pages.excelTable.selectColumn': '选择列',
  'pages.excelTable.aiGenerateSuccess': 'AI 生成了 {{count}} 行新数据已添加',
  'pages.excelTable.aiParseError': 'AI 生成内容解析失败',
  'pages.excelTable.aiParseErrorContent':
    'AI 生成的内容格式不正确，无法解析为表格数据。请重新生成或修改提示语。',
  'pages.excelTable.aiGenerate': '✨ AI 生成',

  // Loading messages
  'pages.loading.loadingResources': '正在加载资源',
  'pages.loading.initialLoadMessage': '初次加载资源可能需要较多时间 请耐心等待',
  'pages.loading.uploadingFile': '正在上传文件...',
  'pages.loading.gettingSourceContent': '正在获取源文档内容，请稍候...',
  'pages.loading.loadingTemplateContent': '正在加载模板内容...',
  'pages.loading.parsingDocument': '正在解析文档...',
  'pages.loading.loading': '加载中...',
  'pages.loading.loadingReviewInfo': '加载评审信息...',
  'pages.loading.contentGenerating': '请稍候，内容生成中...',

  // 评审任务页面
  'pages.reviewTasks.documentId': '文档 ID',
  'pages.reviewTasks.documentName': '文档名称',
  'pages.reviewTasks.version': '版本',
  'pages.reviewTasks.project': '项目',
  'pages.reviewTasks.process': '过程',
  'pages.reviewTasks.owner': '负责人',
  'pages.reviewTasks.submitTime': '提交评审时间',
  'pages.reviewTasks.yourRole': '您的角色',
  'pages.reviewTasks.status': '状态',
  'pages.reviewTasks.actions': '操作',
  'pages.reviewTasks.searchPlaceholder': '输入文档ID或名称搜索',
  'pages.reviewTasks.search': '搜索',
  'pages.reviewTasks.role.author': '撰写者',
  'pages.reviewTasks.role.reviewer': '评审组',
  'pages.reviewTasks.role.auditor': '审核者',
  'pages.reviewTasks.role.approver': '批准者',
  'pages.reviewTasks.status.notstarted': '未开始',
  'pages.reviewTasks.status.approved': '已通过',
  'pages.reviewTasks.status.rejected': '已拒绝',
  'pages.reviewTasks.status.unknown': '未知状态',
  'pages.reviewTasks.action.approve': '通过',
  'pages.reviewTasks.action.reject': '拒绝',
  'pages.reviewTasks.action.updateReview': '更新评审',
  'pages.reviewTasks.action.viewDocument': '查看文档',
  'pages.reviewTasks.action.viewReviewRecords': '评审记录',
  'pages.reviewTasks.reviewModal.approveTitle': '通过评审',
  'pages.reviewTasks.reviewModal.rejectTitle': '拒绝评审',
  'pages.reviewTasks.reviewModal.reviewResult': '评审结果',
  'pages.reviewTasks.reviewModal.reviewComment': '评审意见',
  'pages.reviewTasks.reviewModal.reviewResultRequired': '请选择评审结果',
  'pages.reviewTasks.reviewModal.reviewCommentRequired': '请填写评审意见',
  'pages.reviewTasks.reviewModal.reviewCommentPlaceholder': '请输入评审意见...',
  'pages.reviewTasks.submitSuccess': '审批提交成功',
  'pages.reviewTasks.submitFailed': '审批提交失败',
  'pages.reviewTasks.operationFailed': '操作失败，请重试',
  'pages.reviewTasks.getRecordsFailed': '获取评审记录失败',
  'pages.reviewTasks.reviewRecordsModal.title': '评审记录',
  'pages.reviewTasks.reviewRecordsModal.close': '关闭',
  'pages.reviewTasks.reviewRecordsModal.loading': '加载中...',
  'pages.reviewTasks.reviewRecordsModal.documentTitle': '文档标题',
  'pages.reviewTasks.reviewRecordsModal.documentCode': '文档 ID',
  'pages.reviewTasks.reviewRecordsModal.reviewersTitle': '评审组',
  'pages.reviewTasks.reviewRecordsModal.auditorTitle': '审核者',
  'pages.reviewTasks.reviewRecordsModal.approverTitle': '批准者',
  'pages.reviewTasks.reviewRecordsModal.reviewer': '评审组成员',
  'pages.reviewTasks.reviewRecordsModal.auditor': '审核者',
  'pages.reviewTasks.reviewRecordsModal.approver': '批准者',
  'pages.reviewTasks.reviewRecordsModal.status': '状态',
  'pages.reviewTasks.reviewRecordsModal.comment': '评审意见',
  'pages.reviewTasks.reviewRecordsModal.reviewTime': '评审时间',

  // ASPICE概览页面
  'pages.aspice.overview.projectCount': '项目总数',
  'pages.aspice.overview.templateCount': '模板总数',
  'pages.aspice.overview.documentCount': '程序文件总数',
  'pages.aspice.overview.roleCount': '角色总数',
  'pages.aspice.overview.recentProjects': '最近更新项目',
  'pages.aspice.overview.recentTemplates': '最近更新模板',
  'pages.aspice.overview.recentDocuments': '最近更新程序文件',
  'pages.aspice.overview.viewAll': '查看全部',
  'pages.aspice.overview.projectManager': '项目经理',
  'pages.aspice.overview.approved': '已批准',
  'pages.aspice.overview.reviewing': '评审中',

  // ASPICE模板页面
  'pages.aspice.templates.process': '过程',
  'pages.aspice.templates.templateName': '模板名称',
  'pages.aspice.templates.version': '版本',
  'pages.aspice.templates.tags': '标签',
  'pages.aspice.templates.workProductType': '工作成果类型',
  'pages.aspice.templates.fileFormat': '文件格式',
  'pages.aspice.templates.updateTime': '更新时间',
  'pages.aspice.templates.actions': '操作',
  'pages.aspice.templates.view': '查看',
  'pages.aspice.templates.update': '更新',
  'pages.aspice.templates.download': '下载',
  'pages.aspice.templates.delete': '删除',
  'pages.aspice.templates.create': '新建模板',
  'pages.aspice.templates.createTemplate': '创建模板',
  'pages.aspice.templates.updateTemplate': '更新模板',
  'pages.aspice.templates.sourceDoc': '源文档',
  'pages.aspice.templates.sourceDocPlaceholder': '请输入文档ID或完整链接',
  'pages.aspice.templates.versionRequired': '请输入版本号',
  'pages.aspice.templates.description': '描述',
  'pages.aspice.templates.tagsLabel': '标签',
  'pages.aspice.templates.saveSuccess': '保存成功',
  'pages.aspice.templates.createSuccess': '创建成功',
  'pages.aspice.templates.updateSuccess': '更新成功',
  'pages.aspice.templates.saveFailed': '保存失败',
  'pages.aspice.templates.createFailed': '创建失败',
  'pages.aspice.templates.updateFailed': '更新失败',
  'pages.aspice.templates.operationFailed': '操作失败',
  'pages.aspice.templates.confirmDelete': '确认删除',
  'pages.aspice.templates.confirmDeleteContent': '确定要删除模板 {{name}} 吗？',
  'pages.aspice.templates.deleteSuccess': '删除成功',
  'pages.aspice.templates.deleteFailed': '删除失败',

  // 新增条目 - 模板页面
  'pages.aspice.templates.allTemplates': '全部模板',
  'pages.aspice.templates.sourceDocRequired': '请输入源文档链接',
  'pages.aspice.templates.sourceDocHelp':
    '请输入工作成果的链接地址或文档ID，系统将自动获取文档内容作为模板。',
  'pages.aspice.templates.templateNameRequired': '请输入模板名称',
  'pages.aspice.templates.templateNamePlaceholder': '请输入模板名称',
  'pages.aspice.templates.versionPlaceholder': '请输入数字格式的版本号，如：0.0',
  'pages.aspice.templates.tagsHelp': '可以选择已有标签或输入新标签，按Enter键确认',
  'pages.aspice.templates.tagsPlaceholder': '请选择或输入标签',
  'pages.aspice.templates.descriptionPlaceholder': '请输入模板简介（可选）',
  'pages.aspice.templates.versionPattern': '版本号只能包含数字和小数点',

  // ASPICE角色页面
  'pages.aspice.roles.roleId': '角色ID',
  'pages.aspice.roles.roleName': '角色名称',
  'pages.aspice.roles.roleDescription': '角色描述',
  'pages.aspice.roles.actions': '操作',
  'pages.aspice.roles.edit': '编辑',
  'pages.aspice.roles.delete': '删除',
  'pages.aspice.roles.createRole': '新建角色',
  'pages.aspice.roles.editRole': '编辑角色',
  'pages.aspice.roles.confirmDelete': '确认删除',
  'pages.aspice.roles.confirmDeleteContent': '确定要删除角色 {{name}} 吗？',
  'pages.aspice.roles.saveSuccess': '保存成功',
  'pages.aspice.roles.createSuccess': '创建成功',
  'pages.aspice.roles.deleteSuccess': '删除成功',
  'pages.aspice.roles.operationFailed': '操作失败',
  'pages.aspice.roles.deleteFailed': '删除失败',

  // ASPICE程序文件页面
  'pages.aspice.processDocs.fileName': '文件名称',
  'pages.aspice.processDocs.processName': '过程名称',
  'pages.aspice.processDocs.version': '版本',
  'pages.aspice.processDocs.status': '状态',
  'pages.aspice.processDocs.updateTime': '更新时间',
  'pages.aspice.processDocs.actions': '操作',
  'pages.aspice.processDocs.view': '查看',
  'pages.aspice.processDocs.download': '下载',
  'pages.aspice.processDocs.edit': '编辑',
  'pages.aspice.processDocs.searchPlaceholder': '输入文件名称搜索',
  'pages.aspice.processDocs.search': '搜索',
  'pages.aspice.processDocs.createDoc': '新建程序文件',
  'pages.aspice.processDocs.createDocModal': '新建程序文件',
  'pages.aspice.processDocs.process': '过程',
  'pages.aspice.processDocs.selectProcess': '请选择过程',
  'pages.aspice.processDocs.fileNameRequired': '请输入文件名称',
  'pages.aspice.processDocs.versionRequired': '请输入版本号',
  'pages.aspice.processDocs.versionPattern': '版本号只能包含数字和小数点',
  'pages.aspice.processDocs.versionPlaceholder': '请输入数字格式的版本号，如：0.0',
  'pages.aspice.processDocs.uploadFile': '上传文件',
  'pages.aspice.processDocs.uploadFileRequired': '请上传文件',
  'pages.aspice.processDocs.uploadFileExtra': '支持 .xlsx, .xls, .docx 格式的文件',
  'pages.aspice.processDocs.selectFile': '选择文件',
  'pages.aspice.processDocs.fileTypeError': '仅支持 .xlsx, .xls, .docx 格式的文件',
  'pages.aspice.processDocs.excelParseSuccess': 'Excel 文件解析成功',
  'pages.aspice.processDocs.wordParseSuccess': 'Word 文件解析成功',
  'pages.aspice.processDocs.projectNotFound': '未找到程序文件项目',
  'pages.aspice.processDocs.uploadFileFirst': '请上传文件',
  'pages.aspice.processDocs.addSuccess': '添加成功',
  'pages.aspice.processDocs.addFailed': '添加失败',
  'pages.aspice.processDocs.getContentFailed': '获取文档内容失败',
  'pages.aspice.processDocs.exportNotSupported': '不支持导出{{format}}格式',
  'pages.aspice.processDocs.exportFailed': '导出失败',
  'pages.aspice.processDocs.status.draft': '草稿',
  'pages.aspice.processDocs.status.draftLocked': '草稿锁定',
  'pages.aspice.processDocs.status.review': '评审中',
  'pages.aspice.processDocs.status.reviewPassed': '评审通过',
  'pages.aspice.processDocs.status.auditPassed': '审核通过',
  'pages.aspice.processDocs.status.approved': '已批准',
  'pages.aspice.processDocs.status.controlled': '已受控',
  'pages.aspice.processDocs.status.published': '已发布',
  'pages.aspice.processDocs.status.obsolete': '已废弃',

  // NoProcess 组件
  'pages.aspice.processDocs.noProcess.pmMessage': '当前项目没有配置过程，请先配置过程',
  'pages.aspice.processDocs.noProcess.userMessage': '当前项目没有配置过程，请联系项目经理配置过程',
  'pages.aspice.processDocs.noProcess.configureProcess': '配置过程',

  // 底部菜单链接
  'pages.layout.processDocsPreview': '程序文件预览',
  'pages.layout.systemManual': '系统使用手册',
  'pages.layout.aspiceSpecialistInterface': '返回总控页面',
  'pages.layout.productLibrary': '产品库',
  'pages.layout.todo': '待办',
  'pages.layout.reviewTasks': '评审任务',

  // 待办中心页面
  'pages.todo.problemHandling': '问题处理',
  'pages.todo.project': '项目',

  // 产品库页面
  'pages.productLibrary.title': '产品库',
  'pages.productLibrary.projectName': '项目名称',
  'pages.productLibrary.documentCount': '工作成果数量',
  'pages.productLibrary.actions': '操作',
  'pages.productLibrary.viewDetails': '查看详情',
  'pages.productLibrary.download': '下载',
  'pages.productLibrary.noDocuments': '该项目产品库中没有文档',
  'pages.productLibrary.preparingExport': '准备导出...',
  'pages.productLibrary.foundDocuments': '找到 {{count}} 个文档，开始导出...',
  'pages.productLibrary.exporting':
    '正在导出 ({{current}}/{{total}}) {{processCode}} - {{title}}...',
  'pages.productLibrary.untitledDocument': '未命名文档',
  'pages.productLibrary.generatingZip': '正在生成压缩包...',
  'pages.productLibrary.exportSuccess': '{{projectName}} 产品库导出成功，共 {{count}} 个文档',
  'pages.productLibrary.exportFailed': '导出失败，请稍后重试',
  'pages.productLibrary.fetchFailed': '获取产品库列表失败',
  'pages.productLibrary.detailModalTitle': '{{projectName}} 产品库列表',
  'pages.productLibrary.processName': '过程名称',
  'pages.productLibrary.documentName': '文档名称',
  'pages.productLibrary.documentVersion': '文档版本',
  'pages.productLibrary.category': '类别',
  'pages.productLibrary.owners': '责任人',
  'pages.productLibrary.addedTime': '纳入产品库时间',

  // 项目信息页面
  'pages.project.info.title': '项目信息',
  'pages.project.info.edit': '编辑',
  'pages.project.info.deleteProject': '删除项目',
  'pages.project.info.projectName': '项目名称',
  'pages.project.info.projectCode': '项目编号',
  'pages.project.info.projectDescription': '项目描述',
  'pages.project.info.projectManager': '项目经理',
  'pages.project.info.createTime': '创建时间',
  'pages.project.info.updateTime': '更新时间',
  'pages.project.info.projectStats': '项目统计',
  'pages.project.info.memberCount': '项目成员',
  'pages.project.info.processCount': '过程数量',
  'pages.project.info.documentCount': '工作成果数量',
  'pages.project.info.memberUnit': '人',
  'pages.project.info.processUnit': '个',
  'pages.project.info.documentUnit': '份',
  'pages.project.info.editModal.title': '编辑项目信息',
  'pages.project.info.editModal.nameRequired': '项目名称是必填项',
  'pages.project.info.editModal.descriptionRequired': '项目描述是必填项',
  'pages.project.info.confirmDelete': '确认删除',
  'pages.project.info.confirmDeleteContent': '确定要删除当前项目吗？此操作不可恢复！',
  'pages.project.info.updateSuccess': '更新成功',
  'pages.project.info.updateFailed': '更新失败',
  'pages.project.info.deleteSuccess': '项目删除成功',
  'pages.project.info.deleteFailed': '项目删除失败',
  'pages.project.info.projectIdNotFound': '项目ID不存在',
  'pages.project.info.fetchFailed': '获取项目信息失败',

  // 过程配置页面
  'pages.project.processes.title': '过程配置',
  'pages.project.processes.processId': '过程ID',
  'pages.project.processes.processName': '过程名称',
  'pages.project.processes.progress': '进度',
  'pages.project.processes.owners': '负责人',
  'pages.project.processes.members': '成员',
  'pages.project.processes.status': '状态',
  'pages.project.processes.actions': '操作',
  'pages.project.processes.notSet': '未设置',
  'pages.project.processes.enabled': '启用',
  'pages.project.processes.disabled': '禁用',
  'pages.project.processes.updateOwners': '更新过程成员',
  'pages.project.processes.updateOwner': '更新过程负责人',
  'pages.project.processes.processOwners': '过程负责人',
  'pages.project.processes.processMembers': '过程成员',
  'pages.project.processes.selectOwners': '请选择过程成员',
  'pages.project.processes.selectOwner': '请选择过程负责人',
  'pages.project.processes.enableSuccess': '启用过程 {{name}} 成功',
  'pages.project.processes.disableSuccess': '禁用过程 {{name}} 成功',
  'pages.project.processes.enableFailed': '启用过程失败',
  'pages.project.processes.disableFailed': '禁用过程失败',
  'pages.project.processes.updateOwnersSuccess': '更新过程成员成功',
  'pages.project.processes.updateOwnersFailed': '更新过程成员失败',
  'pages.project.processes.updateOwnerSuccess': '更新过程负责人成功',
  'pages.project.processes.updateOwnerFailed': '更新过程负责人失败',
  'pages.project.processes.fetchProcessesFailed': '获取过程列表失败',
  'pages.project.processes.fetchMembersFailed': '获取项目成员失败',

  // 团队管理页面
  'pages.project.team.title': '团队管理',
  'pages.project.team.addMember': '添加成员',
  'pages.project.team.joinedMembers': '已加入成员',
  'pages.project.team.invitedMembers': '尚未注册成员',
  'pages.project.team.roleList': '角色列表',
  'pages.project.team.memberName': '姓名',
  'pages.project.team.memberEmail': '邮箱',
  'pages.project.team.memberRoles': '角色',
  'pages.project.team.memberProcesses': '参与过程',
  'pages.project.team.actions': '操作',
  'pages.project.team.update': '更新',
  'pages.project.team.inviteTime': '邀请时间',
  'pages.project.team.invitedBy': '邀请人',
  'pages.project.team.roleId': '角色ID',
  'pages.project.team.roleName': '角色名称',
  'pages.project.team.roleDescription': '角色描述',
  'pages.project.team.addMemberModal.title': '添加成员',
  'pages.project.team.addMemberModal.email': '成员邮箱',
  'pages.project.team.addMemberModal.emailPlaceholder': '请输入成员邮箱',
  'pages.project.team.addMemberModal.emailRequired': '请输入邮箱',
  'pages.project.team.addMemberModal.emailInvalid': '请输入有效的邮箱地址',
  'pages.project.team.addMemberModal.selectUser': '选择用户',
  'pages.project.team.addMemberModal.selectUserPlaceholder': '请选择用户',
  'pages.project.team.addMemberModal.userRequired': '请选择用户',
  'pages.project.team.addMemberModal.roles': '角色',
  'pages.project.team.addMemberModal.selectRoles': '请选择角色',
  'pages.project.team.addMemberModal.rolesRequired': '请选择角色',
  'pages.project.team.addMemberModal.processes': '负责过程',
  'pages.project.team.addMemberModal.selectProcesses': '请选择负责过程',
  'pages.project.team.updateMemberModal.title': '更新成员信息',
  'pages.project.team.deleteMember': '删除成员',
  'pages.project.team.confirmDelete': '确认删除',
  'pages.project.team.confirmDeleteContent': '确定要删除成员 {{name}} 吗？',
  'pages.project.team.addSuccess': '添加成功',
  'pages.project.team.addFailed': '添加成员失败',
  'pages.project.team.updateSuccess': '配置成功',
  'pages.project.team.updateFailed': '配置失败',
  'pages.project.team.deleteSuccess': '删除成功',
  'pages.project.team.deleteFailed': '删除失败',
  'pages.project.team.fetchDataFailed': '获取数据失败',

  // 工作成果页面
  'pages.workProducts.searchPlaceholder': '输入文档ID或名称搜索',
  'pages.workProducts.search': '搜索',
  'pages.workProducts.searchSuccess': '搜索成功',
  'pages.workProducts.aiGenerate': 'AI 生成',
  'pages.workProducts.addPlanning': '创建策划',
  'pages.workProducts.addWorkProduct': '创建工作产品',
  'pages.workProducts.addWorkProductOther': '创建',
  'pages.workProducts.addSecurityAnalysis': '创建安全分析工具',
  'pages.workProducts.baselineList': '基线列表',
  'pages.workProducts.traceabilityList': '追溯性矩阵',
  'pages.workProducts.documentId': '文档 ID',
  'pages.workProducts.documentName': '文档名称',
  'pages.workProducts.version': '版本',
  'pages.workProducts.owner': '负责人',
  'pages.workProducts.status': '状态',
  'pages.workProducts.baseline': '基线',
  'pages.workProducts.updateTime': '更新时间',
  'pages.workProducts.actions': '操作',
  'pages.workProducts.preview': '预览',
  'pages.workProducts.edit': '编辑',
  'pages.workProducts.renameDocument': '重命名文档',
  'pages.workProducts.renameHint': '双击可修改文档名称',
  'pages.workProducts.renameNotAllowed': '仅「草稿」状态且你有编辑权限的文档才能修改名称',
  'pages.workProducts.updateTitleSuccess': '更新文档标题成功',
  'pages.workProducts.updateTitleFailed': '更新文档标题失败',
  'pages.workProducts.documentNameRequired': '请输入文档名称',
  'pages.workProducts.enterDocumentName': '请输入文档名称',
  'pages.workProducts.delete': '删除',
  'pages.workProducts.export': '导出',
  'pages.workProducts.exportWithCount': '导出 ({{count}})',
  'pages.workProducts.selectDocumentsToExport': '请选择需要导出的文档',
  'pages.workProducts.confirmExport': '确认导出',
  'pages.workProducts.confirmExportContent': '已选择 {{count}} 个文档，是否继续导出？',
  'pages.workProducts.documentsNotFound': '未找到选中的文档',
  'pages.workProducts.preparingExport': '准备导出文档...',
  'pages.workProducts.exportingDocument': '正在导出 {{processCode}} - {{title}}...',
  'pages.workProducts.generatingZip': '正在生成压缩包...',
  'pages.workProducts.exportSuccess': '文档导出成功',
  'pages.workProducts.exportFailed': '导出文档失败',
  'pages.workProducts.untitledDocument': '未命名文档',
  'pages.workProducts.updateReview': '更新评审',
  'pages.workProducts.confirmDelete': '确认删除',
  'pages.workProducts.confirmDeleteContent': '确定要删除文档 {{title}} 吗？删除后可在回收站恢复。',
  'pages.workProducts.deleteSuccess': '删除成功',
  'pages.workProducts.deleteFailed': '删除失败',
  'pages.workProducts.projectNotFound': '未找到当前项目',
  'pages.workProducts.getProjectFailed': '获取当前项目失败',
  'pages.workProducts.getProcessesFailed': '获取流程列表失败',
  'pages.workProducts.getBaselinesFailed': '获取基线列表失败',
  'pages.workProducts.getMembersFailed': '获取项目成员失败',
  'pages.workProducts.updateReviewSuccess': '评审人员已更新',
  'pages.workProducts.updateReviewFailed': '更新评审失败',
  'pages.workProducts.documentCategories.planning': '策划类',
  'pages.workProducts.documentCategories.workProduct': '工作产品',
  'pages.workProducts.documentCategories.qualityAssurance': '质量保证',
  'pages.workProducts.documentCategories.other': '其他',
  'pages.workProducts.documentCategories.processDocument': '程序文件',
  'pages.workProducts.documentCategories.securityAnalysis': '安全分析工具',
  'pages.workProducts.documentCategories.simpleChange': '简易变更',
  'pages.simpleChange.upload': '上传变更处理单',
  'pages.simpleChange.uploadSuccess': '文档上传成功',
  'pages.simpleChange.getListFailed': '获取简易变更文档失败',
  'pages.simpleChange.fileTypeError': '只支持上传 .xlsx、.xls、.docx 格式的文件',
  'pages.simpleChange.parsing': '正在解析文件，请稍候',
  'pages.simpleChange.documentChange': '文档变更',
  'pages.simpleChange.change': '变更',
  'pages.simpleChange.changeSuccess': '已生成草稿文档',
  'pages.simpleChange.controlledDocuments': '已受控文档',
  'pages.simpleChange.getControlledFailed': '获取已受控文档失败',
  'pages.simpleChange.contentLoadFailed': '获取文档内容失败',
  'pages.simpleChange.unsupportedPreview': '该文档格式暂不支持预览',
  'pages.workProducts.status.draft': '草稿',
  'pages.workProducts.status.draftLocked': '草稿锁定',
  'pages.workProducts.status.review': '评审中',
  'pages.workProducts.status.reviewPassed': '评审通过',
  'pages.workProducts.status.auditPassed': '审核通过',
  'pages.workProducts.status.approved': '已批准',
  'pages.workProducts.status.controlled': '已受控',
  'pages.workProducts.status.published': '已发布',
  'pages.workProducts.status.obsolete': '已废弃',

  // 变更管理组件
  'pages.workProducts.changeManagement.changeRequests': '变更请求',
  'pages.workProducts.changeManagement.changeRequestSummary': '变更请求清单',
  'pages.workProducts.changeManagement.getProjectFailed': '获取当前项目失败',

  // 配置管理组件
  'pages.workProducts.configManagement.management': '管理库',
  'pages.workProducts.configManagement.controlled': '受控库',
  'pages.workProducts.configManagement.baseline': '基线库',
  'pages.workProducts.configManagement.getProjectFailed': '获取当前项目失败',
  'pages.workProducts.configManagement.getBaselinesFailed': '获取基线列表失败',

  // 创建文档模态框
  'pages.workProducts.createModal.title': '新建工作成果',
  'pages.workProducts.createModal.templateTab': '从模板创建',
  'pages.workProducts.createModal.copyTab': '从现有复制',
  'pages.workProducts.createModal.localTab': '从本地上传',
  'pages.workProducts.createModal.integrateTab': '对接其他系统',
  'pages.workProducts.createModal.selectTemplate': '选择模板',
  'pages.workProducts.createModal.selectTemplatePlaceholder': '请选择模板',
  'pages.workProducts.createModal.version': '版本号',
  'pages.workProducts.createModal.versionRequired': '请输入版本号',
  'pages.workProducts.createModal.versionPattern': '版本号只能包含数字和小数点',
  'pages.workProducts.createModal.versionPlaceholder': '请输入数字格式的版本号，如：0.0',
  'pages.workProducts.createModal.uploadFile': '上传文件',
  'pages.workProducts.createModal.uploadFileRequired': '请上传文件',
  'pages.workProducts.createModal.uploadFileExtra': '支持 .xlsx, .xls, .docx 格式的文件',
  'pages.workProducts.createModal.uploadFileExtraWithPdf':
    '支持 .xlsx, .xls, .docx, .pdf 格式的文件',
  'pages.workProducts.createModal.pdfFileSizeLimit': 'PDF 文件大小不能超过 50MB',
  'pages.workProducts.createModal.uploadFileExtraOriginal':
    '保持原始文件选项仅支持 .xlsx, .xls 格式的文件',
  'pages.workProducts.createModal.selectFile': '选择文件',
  'pages.workProducts.createModal.workProductName': '工作成果名称',
  'pages.workProducts.createModal.workProductNamePlaceholder': '请输入工作成果名称',
  'pages.workProducts.createModal.keepOriginalFile': '保持原始文件',
  'pages.workProducts.createModal.keepOriginalFileDesc': '不转换文件为线上格式，可以下载到本地修改',
  'pages.workProducts.createModal.clearFileInfo': '已清除上传的文件，请重新上传',
  'pages.workProducts.createModal.uploadIntegrateFile': '请上传对接系统导出的数据文件',
  'pages.workProducts.createModal.projectNotFound': '未找到当前项目',
  'pages.workProducts.createModal.systemNames.zentao': '禅道',
  'pages.workProducts.createModal.systemNames.tapd': 'TAPD',
  'pages.workProducts.createModal.systemNames.jira': 'Jira',
  'pages.workProducts.createModal.systemNames.redmine': 'Redmine',
  'pages.workProducts.createModal.aiGeneratingTitle': 'AI 正在生成文档',
  'pages.workProducts.createModal.aiGeneratingDesc': '基于对接系统数据生成工作成果',

  // 创建文档模态框 - 从现有复制
  'pages.workProducts.createModal.selectSourceDoc': '选择源工作成果',
  'pages.workProducts.createModal.selectSourceDocPlaceholder': '请选择源工作成果',
  'pages.workProducts.createModal.newVersion': '新版本号',
  'pages.workProducts.createModal.newVersionRequired': '请输入新版本号',
  'pages.workProducts.createModal.newVersionPlaceholder': '请输入数字格式的版本号，如：0.0',

  // 创建文档模态框 - 对接系统
  'pages.workProducts.createModal.integrate.zentao': '禅道',
  'pages.workProducts.createModal.integrate.tapd': 'TAPD',
  'pages.workProducts.createModal.integrate.jira': 'Jira',
  'pages.workProducts.createModal.integrate.redmine': 'Redmine',
  'pages.workProducts.createModal.integrate.zentaoDesc': '禅道项目管理系统',
  'pages.workProducts.createModal.integrate.tapdDesc': 'TAPD 腾讯敏捷协作平台',
  'pages.workProducts.createModal.integrate.jiraDesc': 'Jira 项目管理工具',
  'pages.workProducts.createModal.integrate.redmineDesc': 'Redmine 项目管理工具',
  'pages.workProducts.createModal.integrate.functionDescription': '功能说明',
  'pages.workProducts.createModal.integrate.functionDescriptionText':
    '支持对接其他的项目管理和缺陷追踪系统的数据，请选择对接的系统，以及其他系统中导出的数据文件（CSV，Excel，Word）。AI 将自动将数据导入到新建的工作成果中。',
  'pages.workProducts.createModal.integrate.selectSystem': '选择对接系统',
  'pages.workProducts.createModal.integrate.selectSystemRequired': '请选择对接系统',
  'pages.workProducts.createModal.integrate.selected': '已选择：{{system}}',
  'pages.workProducts.createModal.integrate.uploadDataFile': '上传数据文件',
  'pages.workProducts.createModal.integrate.uploadDataFileRequired': '请上传数据文件',
  'pages.workProducts.createModal.integrate.uploadDataFileExtra':
    '支持 .csv, .xlsx, .xls, .docx 格式的文件，仅支持上传 1 个文件',
  'pages.workProducts.createModal.integrate.selectFile': '选择文件',
  'pages.workProducts.createModal.integrate.selectSystemFirst': '请先选择对接系统',
  'pages.workProducts.createModal.integrate.fileFormatNotSupported':
    '仅支持 .csv, .xlsx, .xls, .docx 格式的文件',
  'pages.workProducts.createModal.integrate.csvEmpty': 'CSV文件内容为空',
  'pages.workProducts.createModal.integrate.csvNoData': 'CSV文件没有有效数据',
  'pages.workProducts.createModal.integrate.csvParseFailed': 'CSV文件解析失败，请检查文件格式',
  'pages.workProducts.createModal.integrate.csvReadFailed': 'CSV文件读取失败',
  'pages.workProducts.createModal.integrate.systemChanged': '已切换对接系统，请重新上传文件',
  'pages.workProducts.createModal.customDocumentCodePlaceholder': '请填写文档 ID',

  // AI 生成模态框
  'pages.workProducts.aiGenerateModal.title': 'AI 生成',
  'pages.workProducts.aiGenerateModal.cancel': '取消',
  'pages.workProducts.aiGenerateModal.startGenerate': '开始生成',
  'pages.workProducts.aiGenerateModal.systemWillGenerate':
    '系统将为您生成 {{processCode}} {{processName}} 的工作成果。',
  'pages.workProducts.aiGenerateModal.aiWillGenerate': 'AI 将基于以下内容生成工作成果：',
  'pages.workProducts.aiGenerateModal.builtInTemplates': '系统内置模板',
  'pages.workProducts.aiGenerateModal.relatedTraceDocs': '相关追溯文档',
  'pages.workProducts.aiGenerateModal.uploadedRefDocs': '您上传的参考文档（可选）',
  'pages.workProducts.aiGenerateModal.specialRequirements': '您的特殊要求（可选）',
  'pages.workProducts.aiGenerateModal.uploadRefDocs': '上传参考文档（可选）',
  'pages.workProducts.aiGenerateModal.specialRequirementsLabel': '特殊要求（可选）',
  'pages.workProducts.aiGenerateModal.specialRequirementsPlaceholder':
    '请输入您的特殊要求，例如：需要重点关注某个方面，或者需要包含特定的内容等',
  'pages.workProducts.aiGenerateModal.aiGeneratingTitle': 'AI 正在生成文档',
  'pages.workProducts.aiGenerateModal.aiGeneratingDesc':
    '基于您的需求生成 {{processCode}} {{processName}} 文档',
  'pages.workProducts.aiGenerateModal.projectNotFound': '未找到当前项目，请确认您已选择项目',
  'pages.workProducts.aiGenerateModal.generateSuccess': 'AI 生成文档成功',
  'pages.workProducts.aiGenerateModal.generateFailed': 'AI 生成文档失败',
  'pages.workProducts.aiGenerateModal.enterPrompt': '请输入内容要求',
  'pages.workProducts.aiGenerateModal.aiFeatureDev': 'AI 生成功能开发中...',

  // AI 生成中模态框
  'pages.workProducts.aiGeneratingModal.title': 'AI 正在生成文档',
  'pages.workProducts.aiGeneratingModal.description': '基于您的需求生成文档',
  'pages.workProducts.aiGeneratingModal.pleaseWait': '请稍候，文档生成中...',

  // 基线列表
  'pages.workProducts.baselineList.createBaseline': '新建基线',

  // 管理库
  'pages.managementRepository.getProcessListFailed': '获取过程列表失败',
  'pages.managementRepository.getBaselineListFailed': '获取基线列表失败',
  'pages.managementRepository.getDocumentListFailed': '获取文档列表失败',
  'pages.managementRepository.addToBaseline': '纳入基线',
  'pages.managementRepository.selectBaseline': '请选择基线',
  'pages.managementRepository.baselineUpdateSuccess': '文档基线更新成功',
  'pages.managementRepository.baselineUpdateSuccessWithStatus':
    '文档基线更新成功，相关基线状态已变更为草稿状态',
  'pages.managementRepository.baselineUpdateFailed': '文档基线更新失败',
  'pages.managementRepository.notInBaseline': '未纳入基线',
  'pages.managementRepository.statusDraft': '草稿',
  'pages.managementRepository.statusDraftLocked': '草稿锁定',
  'pages.managementRepository.statusReview': '评审中',
  'pages.managementRepository.statusReviewPassed': '评审通过',
  'pages.managementRepository.statusAuditPassed': '审核通过',
  'pages.managementRepository.statusApproved': '已批准',
  'pages.managementRepository.statusControlled': '已受控',
  'pages.managementRepository.statusPublished': '已发布',
  'pages.managementRepository.statusObsolete': '已废弃',
  'pages.managementRepository.documentId': '文档 ID',
  'pages.managementRepository.documentName': '文档名称',
  'pages.managementRepository.version': '版本',
  'pages.managementRepository.process': '过程',
  'pages.managementRepository.status': '状态',
  'pages.managementRepository.baseline': '基线',
  'pages.managementRepository.addToProductLibrary': '纳入产品库',
  'pages.managementRepository.removeFromProductLibrary': '从产品库移除',
  'pages.managementRepository.addToProductLibrarySuccess': '已加入产品库',
  'pages.managementRepository.addToProductLibraryFailed': '加入产品库失败',
  'pages.managementRepository.removeFromProductLibrarySuccess': '已从产品库移除',
  'pages.managementRepository.removeFromProductLibraryFailed': '从产品库移除失败',
  'pages.managementRepository.productLibraryOperationFailed': '操作产品库失败',
  'pages.managementRepository.noPermission': '无操作权限',
  'pages.managementRepository.owner': '责任人',
  'pages.managementRepository.searchPlaceholder': '搜索文档名称或ID',
  'pages.managementRepository.selectProcess': '选择过程',
  'pages.managementRepository.selectBaselineFilter': '选择基线',
  'pages.managementRepository.search': '搜索',
  'pages.managementRepository.updateBaselineTooltip': '更新基线',
  'pages.managementRepository.updateDocumentBaseline': '更新文档基线',
  'pages.managementRepository.removeBaseline': '移出基线',
  'pages.managementRepository.removeBaselineDesc': '选择"移出基线"可将文档从当前基线中移除',
  'pages.managementRepository.duplicateDocumentWarning':
    '相同过程下其他名称重复的文档将会从当前基线中移除',
  'pages.managementRepository.statusWarning': '注意：更新基线将使相关基线状态变更为草稿',

  // Change Request List
  'pages.changeRequestList.typeSystem': '系统',
  'pages.changeRequestList.typeSoftware': '软件',
  'pages.changeRequestList.typeOther': '其他',
  'pages.changeRequestList.statusOpen': '开放中',
  'pages.changeRequestList.statusClosed': '已关闭',
  'pages.changeRequestList.getChangeRequestsFailed': '获取变更请求失败',
  'pages.changeRequestList.getChangeRequestsListFailed': '获取变更请求列表失败',
  'pages.changeRequestList.getBaselineListFailed': '获取基线列表失败',
  'pages.changeRequestList.getProjectMembersFailed': '获取项目成员列表失败',
  'pages.changeRequestList.confirmDelete': '确认删除',
  'pages.changeRequestList.deleteConfirmMessage': '确定要删除变更请求 {{id}} 吗？此操作不可逆。',
  'pages.changeRequestList.confirm': '确认',
  'pages.changeRequestList.cancel': '取消',
  'pages.changeRequestList.deleteSuccess': '删除成功',
  'pages.changeRequestList.deleteFailed': '删除失败',
  'pages.changeRequestList.deleteChangeRequestFailed': '删除变更请求失败',
  'pages.changeRequestList.updateSuccess': '更新成功',
  'pages.changeRequestList.createSuccess': '创建成功',
  'pages.changeRequestList.updateFailed': '更新失败',
  'pages.changeRequestList.createFailed': '创建失败',
  'pages.changeRequestList.submitFailed': '提交失败，请检查表单',
  'pages.changeRequestList.changeNumber': '变更编号',
  'pages.changeRequestList.createTime': '创建时间',
  'pages.changeRequestList.changeSource': '变更来源',
  'pages.changeRequestList.impactAnalysisReport': '影响分析报告',
  'pages.changeRequestList.status': '状态',
  'pages.changeRequestList.actions': '操作',
  'pages.changeRequestList.searchPlaceholder': '请输入变更编号搜索',
  'pages.changeRequestList.view': '查看',
  'pages.changeRequestList.update': '更新',
  'pages.changeRequestList.delete': '删除',
  'pages.changeRequestList.uploadSuccess': '{{filename}} 上传成功',
  'pages.changeRequestList.uploadFailed': '{{filename}} 上传失败: {{error}}',
  'pages.changeRequestList.unknownError': '未知错误',
  'pages.changeRequestList.uploadFailedGeneric': '{{filename}} 上传失败',
  'pages.changeRequestList.fileTypeError': '只支持上传 PDF、Word、Excel 格式的文件！',
  'pages.changeRequestList.uploadFileExtra': '支持 .pdf、.doc、.docx、.xls、.xlsx 格式的文件',
  'pages.changeRequestList.fileSizeError': '文件大小不能超过 10MB！',
  'pages.changeRequestList.createChangeRequest': '新建变更请求',
  'pages.changeRequestList.updateChangeRequest': '更新变更请求',
  'pages.changeRequestList.createChangeRequestTitle': '新建变更请求',
  'pages.changeRequestList.fieldRequired': '{{label}}不能为空',
  'pages.changeRequestList.changeSourceLabel': '变更来源',
  'pages.changeRequestList.changeSourcePlaceholder': '例如: 客户需求, 内部优化',
  'pages.changeRequestList.ownerLabel': '所有人',
  'pages.changeRequestList.ownerPlaceholder': '选择变更请求所有人',
  'pages.changeRequestList.descriptionLabel': '变更描述',
  'pages.changeRequestList.descriptionPlaceholder': '详细描述变更内容和原因',
  'pages.changeRequestList.crTypeLabel': 'CR类型',
  'pages.changeRequestList.crTypePlaceholder': '选择变更请求类型',
  'pages.changeRequestList.affectedSystemBaselineLabel': '受影响的系统基线',
  'pages.changeRequestList.affectedSystemBaselinePlaceholder': '选择受影响的系统基线',
  'pages.changeRequestList.plannedSystemBaselineLabel': '计划发布的系统基线',
  'pages.changeRequestList.plannedSystemBaselinePlaceholder': '选择计划发布的系统基线',
  'pages.changeRequestList.affectedSoftwareBaselineLabel': '受影响的软件基线',
  'pages.changeRequestList.affectedSoftwareBaselinePlaceholder': '选择受影响的软件基线',
  'pages.changeRequestList.plannedSoftwareBaselineLabel': '计划发布的软件基线',
  'pages.changeRequestList.plannedSoftwareBaselinePlaceholder': '选择计划发布的软件基线',
  'pages.changeRequestList.uploadFile': '上传文件',
  'pages.changeRequestList.ccbDecisionLabel': 'CCB决议',
  'pages.changeRequestList.impactAnalysisResultReport': '影响分析结果报告',
  'pages.changeRequestList.viewReport': '查看报告',
  'pages.changeRequestList.ccbDecision': 'CCB决议',
  'pages.changeRequestList.plannedImplementationTime': '计划实施时间',
  'pages.changeRequestList.actualImplementationTime': '实际实施时间',
  'pages.changeRequestList.none': '无',
  'pages.changeRequestList.notSet': '未设置',
  'pages.changeRequestList.notImplemented': '未实施',
  'pages.changeRequestList.impactAnalysisReportLabel': '影响分析报告',
  'pages.changeRequestList.applicationInfo': '申请信息',
  'pages.changeRequestList.changeNumberLabel': '变更编号',
  'pages.changeRequestList.changeNumberPlaceholder': '请输入变更编号',
  'pages.changeRequestList.expectedCompletionDateLabel': '期望完成日期',
  'pages.changeRequestList.applicant': '申请人',
  'pages.changeRequestList.applicationDate': '申请日期',
  'pages.changeRequestList.changeSourceTypeLabel': '变更来源类型',
  'pages.changeRequestList.changeSourceTypePlaceholder': '请选择变更来源类型',
  'pages.changeRequestList.sourceTypeCustomer': '客户需求、反馈',
  'pages.changeRequestList.sourceTypeDefect': '测试、现场故障缺陷',
  'pages.changeRequestList.sourceTypeTech': '技术方案、软硬件适配',
  'pages.changeRequestList.sourceTypeAspice': 'ASPICE 内审、评估整改',
  'pages.changeRequestList.sourceTypeRegulatory': '法规、行业标准更新',
  'pages.changeRequestList.sourceTypeProcess': '内部流程、体系优化',
  'pages.changeRequestList.sourceTypeProject': '项目管理要求调整',
  'pages.changeRequestList.sourceTypeSupplier': '供应商、外部协作变更',
  'pages.changeRequestList.sourceTypeOther': '其他',
  'pages.changeRequestList.changeSourceBasisLabel': '变更来源依据',
  'pages.changeRequestList.changeSourceBasisPlaceholder': '请填写变更来源依据',
  'pages.changeRequestList.changeRequirementLabel': '变更要求描述',
  'pages.changeRequestList.changeRequirementPlaceholder': '请详细描述变更要求',
  'pages.changeRequestList.changeLevelLabel': '变更级别',
  'pages.changeRequestList.levelSafety': '功能安全相关',
  'pages.changeRequestList.levelRegulatory': '法规相关',
  'pages.changeRequestList.levelGeneral': '一般功能相关',
  'pages.changeRequestList.levelOther': '其他',
  'pages.changeRequestList.attachmentLabel': '附件',
  'pages.changeRequestList.relatedProcesses': '涉及过程',
  'pages.changeRequestList.processes': '过程',
  'pages.changeRequestList.selectProcessPlaceholder': '请选择过程',
  'pages.changeRequestList.selectDocumentPlaceholder': '请选择文档',
  'pages.changeRequestList.review': '审核',
  'pages.changeRequestList.verify': '验证',
  'pages.changeRequestList.changeVerification': '变更验证',
  'pages.changeRequestList.completed': '已完成',
  'pages.changeRequestList.partial': '部分完成',
  'pages.changeRequestList.missedItems': '遗漏事项',
  'pages.changeRequestList.verifyModal.title': '变更验证',
  'pages.changeRequestList.verifyModal.resultRequired': '请选择变更验证结果',
  'pages.changeRequestList.verifyModal.missedItemsRequired': '请填写遗漏事项',
  'pages.changeRequestList.verifyModal.missedItemsPlaceholder': '请填写遗漏事项',
  'pages.changeRequestList.verifyModal.success': '验证完成',
  'pages.changeRequestList.verifyModal.failed': '验证失败',
  'pages.changeRequestList.export': '导出',
  'pages.changeRequestList.noDataToExport': '暂无数据可导出',
  'pages.changeRequestList.exportSuccess': '导出成功',
  'pages.changeRequestList.changeRequestDetailsTitle': '变更请求详情',
  'pages.changeRequestList.close': '关闭',
  'pages.changeRequestList.projectName': '项目名称',
  'pages.changeRequestList.changeDescription': '变更描述',

  // 变更审核模态框
  'pages.changeRequestList.reviewModal.title': '变更审核',
  'pages.changeRequestList.reviewModal.change': '是否变更',
  'pages.changeRequestList.reviewModal.noImpact': '不影响',
  'pages.changeRequestList.reviewModal.approveChange': '同意变更',
  'pages.changeRequestList.reviewModal.changeDocuments': '变更文档',
  'pages.changeRequestList.reviewModal.document': '文档',
  'pages.changeRequestList.reviewModal.selectDocument': '请选择文档',
  'pages.changeRequestList.reviewModal.alreadyChanged': '已变更',
  'pages.changeRequestList.reviewModal.changeSummary': '请输入文档变更内容概述',
  'pages.changeRequestList.reviewModal.success': '审核完成',
  'pages.changeRequestList.reviewModal.failed': '审核失败',
  'pages.changeRequestList.reviewModal.getDocumentsFailed': '获取文档列表失败',
  'pages.changeRequestList.reviewModal.missingDocuments':
    '以下过程选择了【同意变更】但未选择文档：',
  'pages.changeRequestList.reviewModal.emptyDescription':
    '{{processCode}} 中文档「{{docName}}」的变更内容概述不能为空',
  'pages.changeRequestList.ccbDecisionPlaceholder': '输入配置控制委员会(CCB)的决议内容',
  'pages.changeRequestList.statusLabel': '状态',
  'pages.changeRequestList.statusPlaceholder': '选择当前状态',
  'pages.changeRequestList.plannedImplementationTimeLabel': '计划实施时间',
  'pages.changeRequestList.actualImplementationTimeLabel': '实际实施时间',

  // Traceability component
  'pages.traceability.noWorkProductTitle': '暂未创建工作产品',
  'pages.traceability.noWorkProductDesc': '当前过程 {{processCode}} 暂未创建工作产品',

  // Template update tip & document tree
  'pages.aspice.templates.updateTip':
    '如需更新模板，请在项目中使用本模板新建工作成果进行编辑，编辑完成后提交评审。等待评审通过，点击新建模板为模板创建新版本。',
  'pages.documentTree.expandAll': '全部展开',
  'pages.documentTree.collapseAll': '全部收起',
  'pages.documentTree.updateChapterNum': '更新章节号',

  // Login license
  'pages.login.license.invalid': '系统License状态异常: {{message}}',
  'pages.login.license.expiring': '系统License将在{{days}}天后过期，请及时续费',

  // Reference Document Uploader
  'pages.referenceUploader.docxFormatRecommended': '建议使用 .docx 格式以获得更好的解析效果',
  'pages.referenceUploader.cannotParseDoc': '无法解析 .doc 格式文件，请转换为 .docx 格式',
  'pages.referenceUploader.unsupportedFormat': '不支持的文件格式',
  'pages.referenceUploader.fileReadFailed': '文件读取失败',
  'pages.referenceUploader.onlySupports': '仅支持 Word (.doc, .docx) 和 Excel (.xls, .xlsx) 格式',
  'pages.referenceUploader.fileSizeLimit': '文件大小不能超过 10MB',
  'pages.referenceUploader.parseSuccess': '{{filename}} 解析成功',
  'pages.referenceUploader.parseFailed': '{{filename}} 解析失败: {{error}}',
  'pages.referenceUploader.unknownError': '未知错误',
  'pages.referenceUploader.documentDeleted': '文档已删除',
  'pages.referenceUploader.noContent': '无内容',
  'pages.referenceUploader.worksheet': '工作表',
  'pages.referenceUploader.parsing': '解析中...',
  'pages.referenceUploader.selectReferenceDoc': '选择参考文档',
  'pages.referenceUploader.supportFormats':
    '支持 Word (.doc, .docx) 和 Excel (.xls, .xlsx) 格式，最大 10MB，最多 {{maxCount}} 个文件',
  'pages.referenceUploader.uploadedDocs': '已上传文档',
  'pages.referenceUploader.preview': '预览',
  'pages.referenceUploader.delete': '删除',
  'pages.referenceUploader.wordDoc': 'Word 文档',
  'pages.referenceUploader.excelWorkbook': 'Excel 工作簿',
  'pages.referenceUploader.worksheets': '个工作表',
  'pages.referenceUploader.close': '关闭',

  // Diagram Modal
  'pages.diagramModal.newTitle': '新建绘图',
  'pages.diagramModal.editTitle': '编辑绘图',
  'pages.diagramModal.importTitle': '导入绘图',
  'pages.diagramModal.save': '保存',
  'pages.diagramModal.cancel': '取消',
  'pages.diagramModal.loading': '正在加载绘图编辑器...',
  'pages.diagramModal.notInitialized': '编辑器尚未初始化完成，请稍候',

  // Create Baseline Modal
  'pages.createBaseline.getBaselineInfoFailed': '获取基线信息失败',
  'pages.createBaseline.updateSuccess': '基线更新成功',
  'pages.createBaseline.updateFailed': '基线更新失败',
  'pages.createBaseline.createFailed': '创建基线失败',
  'pages.createBaseline.createSuccess': '基线创建成功',
  'pages.createBaseline.updateTitle': '更新基线',
  'pages.createBaseline.createTitle': '新建基线',
  'pages.createBaseline.nameLabel': '基线名称',
  'pages.createBaseline.nameRequired': '请输入基线名称',
  'pages.createBaseline.namePlaceholder': '请输入基线名称',
  'pages.createBaseline.descriptionLabel': '基线描述',
  'pages.createBaseline.descriptionPlaceholder': '请输入基线描述（可选）',

  // Baseline List
  'pages.baselineList.getProcessListFailed': '获取过程列表失败',
  'pages.baselineList.getBaselineListFailed': '获取基线列表失败',
  'pages.baselineList.baselineNotFound': '未找到基线信息',
  'pages.baselineList.configItemList': '配置项清单',
  'pages.baselineList.configItemListNotFound': '未找到配置项清单文档',
  'pages.baselineList.getConfigItemListFailed': '获取配置项清单失败',
  'pages.baselineList.preparingExport': '准备导出...',
  'pages.baselineList.gettingBaselineDocs': '正在获取基线文档...',
  'pages.baselineList.noAssociatedDocs': '该基线没有关联的文档',
  'pages.baselineList.foundDocsStartExport': '找到 {{count}} 个文档，开始导出...',
  'pages.baselineList.exportingProcessDoc': '正在导出 {{processCode}} 中的 {{docTitle}}',
  'pages.baselineList.untitledDoc': '未命名文档',
  'pages.baselineList.generatingZip': '正在生成压缩包...',
  'pages.baselineList.exportAllSuccess': '所有工作成果导出成功',
  'pages.baselineList.exportFailed': '导出失败，请重试',
  'pages.baselineList.confirmDelete': '确认删除',
  'pages.baselineList.deleteBaselineWarning':
    '删除基线将解除所有工作产品与该基线的关联，但不会删除工作产品本身。确定要删除这个基线吗？',
  'pages.baselineList.confirm': '确认',
  'pages.baselineList.cancel': '取消',
  'pages.baselineList.deleteSuccess': '基线删除成功',
  'pages.baselineList.deleteFailed': '基线删除失败',
  'pages.baselineList.exportAllConfigItems': '导出所有配置项',
  'pages.baselineList.exportAllWorkProducts': '导出所有工作成果',
  'pages.baselineList.statusDraft': '草稿',
  'pages.baselineList.statusReview': '评审中',
  'pages.baselineList.statusApproved': '已批准',
  'pages.baselineList.statusPublished': '已发布',
  'pages.baselineList.statusObsolete': '已废弃',
  'pages.baselineList.baselineId': '基线ID',
  'pages.baselineList.baselineName': '基线名称',
  'pages.baselineList.baselineDescription': '基线描述',
  'pages.baselineList.status': '状态',
  'pages.baselineList.workProductCount': '工作成果数量',
  'pages.baselineList.createTime': '创建时间',
  'pages.baselineList.actions': '操作',
  'pages.baselineList.configItemListTooltip': '配置项清单',
  'pages.baselineList.updateBaselineTooltip': '更新基线',
  'pages.baselineList.deleteBaselineTooltip': '删除基线',

  // Doc Editor messages
  'pages.docEditor.message.saveSuccess': '保存成功',
  'pages.docEditor.message.saveFail': '保存失败',
  'pages.docEditor.message.saveFailRetry': '保存失败，请稍后重试',
  'pages.docEditor.message.saveLoading': '正在保存...',
  'pages.docEditor.message.documentIdMissing': '文档ID不存在，无法保存',
  'pages.docEditor.message.inputVersionNumber': '请输入新版本号',
  'pages.docEditor.message.inputVersionDescription': '请输入版本描述',
  'pages.docEditor.message.newVersionCreated': '新版本创建成功',
  'pages.docEditor.message.export.noDocInfo': '无法导出文档，文档信息不存在',
  'pages.docEditor.message.untitledDocument': '未命名文档',
  'pages.docEditor.message.fetchReviewStatusFail': '获取评审状态失败',
  'pages.docEditor.message.docInfoMissing': '文档信息不存在',
  'pages.docEditor.message.saveContentForReviewFail': '保存文档内容失败，无法提交评审',
  'pages.docEditor.message.updateMetadataFail': '更新文档元数据失败',
  'pages.docEditor.message.submitReviewSuccess': '文档已提交评审',
  'pages.docEditor.message.submitChangeSuccess': '变更已提交',
  'pages.docEditor.message.submitReviewFail': '提交评审失败',
  'pages.docEditor.message.reviewInfoMissing': '文档或评审信息不存在',
  'pages.docEditor.message.submitReviewResultSuccess': '评审结果已提交',
  'pages.docEditor.message.submitReviewResultFail': '提交评审结果失败',
  'pages.docEditor.message.titleUpdateSuccess': '标题更新成功',
  'pages.docEditor.message.exporting': '正在导出文档，请稍候...',
  'pages.docEditor.message.comparing': '正在准备文档对比，请稍候...',
  'pages.docEditor.message.fileExportSuccess': '文件导出成功',
  'pages.docEditor.message.fileExportFail': '导出文件失败，请重试',
  'pages.docEditor.message.uploadSuccess': '文件上传成功',
  'pages.docEditor.message.revisionUpdateSuccess': '修订记录已更新',
  'pages.docEditor.message.revisionDeleteSuccess': '修订记录已删除',
  'pages.docEditor.message.traceSaveSuccess': '追溯配置已保存',
  'pages.docEditor.message.nodeAddSuccess': '节点添加成功',
  'pages.docEditor.message.nodeDeleteSuccess': '节点删除成功',
  'pages.docEditor.message.nodeAttachmentsDeleteFail': '节点关联附件删除失败，请稍后重试',
  'pages.docEditor.message.copySuccess': '已复制到剪贴板',
  'pages.docEditor.message.nodeUpgradeSuccess': '节点升级成功',
  'pages.docEditor.message.nodeDowngradeSuccess': '节点降级成功',
  'pages.docEditor.message.aiContentAdded': 'AI 生成内容已添加到文档末尾',
  'pages.docEditor.message.aiFeatureDev': 'AI 生成功能开发中...',
  'pages.docEditor.message.aiGenerateFail': 'AI 生成失败',
  'pages.docEditor.message.generateSuccess': '内容生成成功',
  'pages.docEditor.message.updatingNodeCode': '正在更新章节号，请稍候...',
  'pages.docEditor.message.nodeCodeUpdated': '节点编码已更新',
  'pages.docEditor.message.updateChangeRequestFail': '更新变更请求失败',
  'pages.docEditor.message.largeFileLoading': '文件体积较大，正在加载中，请稍候。',

  // Tabs
  'pages.docEditor.tab.testSpec': '测试规范',
  'pages.docEditor.tab.testSummary': '测试汇总',

  // Test Summary component
  'pages.docEditor.testSummary.noResultColumn': '未找到测试结果列，无法生成测试汇总',
  'pages.docEditor.testSummary.statisticsTitle': '测试执行情况统计',
  'pages.docEditor.testSummary.totalCases': '测试用例总数',
  'pages.docEditor.testSummary.passed': '已通过测试',
  'pages.docEditor.testSummary.failed': '未通过测试',
  'pages.docEditor.testSummary.notExecuted': '未执行测试',
  'pages.docEditor.testSummary.resultDistribution': '测试结果分布',
  'pages.docEditor.testSummary.resultDetails': '测试结果详情',

  // Doc Editor Save Modal
  'pages.docEditor.saveModal.title': '保存文档',
  'pages.docEditor.saveModal.saveOption': '保存方式',
  'pages.docEditor.saveModal.saveOptionExtra':
    '选择创建新版本，当前版本文档会更新为【草稿锁定】状态',
  'pages.docEditor.saveModal.saveToCurrent': '保存到当前版本',
  'pages.docEditor.saveModal.newVersion': '创建新版本',
  'pages.docEditor.saveModal.newVersionNumber': '新版本号',
  'pages.docEditor.saveModal.inputNewVersionNumber': '请输入新版本号',
  'pages.docEditor.saveModal.versionDescription': '版本描述',
  'pages.docEditor.saveModal.versionDescriptionExtra': '请简要描述本次版本的主要变更内容',
  'pages.docEditor.saveModal.inputVersionDescription': '请输入版本描述',
  'pages.docEditor.saveModal.revisionDescription': '修订描述',
  'pages.docEditor.saveModal.inputRevisionDescription': '请输入修订描述',

  // Doc Editor Review Modal
  'pages.docEditor.reviewModal.title': '提交评审',
  'pages.docEditor.reviewModal.processTitle': '评审流程说明：',
  'pages.docEditor.reviewModal.processItem1':
    '文档评审分为四个阶段：评审组 → 评审组长 → 审核 → 批准',
  'pages.docEditor.reviewModal.processItem2':
    '评审组全部通过后进入评审组长，组长通过后进入审核，审核者通过后进入批准',
  'pages.docEditor.reviewModal.processItem3':
    '不通过时仅退回负责人会升小版本；退回评审组长或审核者则在原文档上继续',
  'pages.docEditor.reviewModal.reviewerLabel': '评审组',
  'pages.docEditor.reviewModal.reviewLeaderLabel': '评审组长',
  'pages.docEditor.reviewModal.auditorLabel': '审核者',
  'pages.docEditor.reviewModal.approverLabel': '批准者',
  'pages.docEditor.reviewModal.reviewerValidation': '请至少选择一个评审组成员',
  'pages.docEditor.reviewModal.reviewLeaderValidation': '请选择评审组长',
  'pages.docEditor.reviewModal.samePersonValidation': '审核者和批准者不能是同一人',
  'pages.docEditor.reviewModal.approverInReviewersValidation': '批准者不能在评审组范围内',
  'pages.docEditor.reviewModal.auditorInReviewersValidation': '审核者不能在评审组范围内',
  'pages.docEditor.reviewModal.reviewLeaderInReviewersValidation': '评审组长不能在评审组范围内',
  'pages.docEditor.reviewModal.auditorEqualsApproverValidation': '审核者和批准者不能是同一人',
  'pages.docEditor.reviewModal.reviewLeaderEqualsAuditorValidation': '评审组长和审核者不能是同一人',
  'pages.docEditor.reviewModal.reviewLeaderEqualsApproverValidation':
    '评审组长和批准者不能是同一人',
  'pages.docEditor.reviewModal.reviewerExtra': '评审组负责对文档内容进行评审和反馈，可选择多个成员',
  'pages.docEditor.reviewModal.svvOwnerHint': '{{code}} 负责人：{{name}}',
  'pages.docEditor.reviewModal.reviewerPlaceholder': '请选择一个或多个评审组成员',
  'pages.docEditor.reviewModal.reviewLeaderPlaceholder': '请选择评审组长',
  'pages.docEditor.reviewModal.reviewLeaderExtra': '评审组长在评审组全部通过后进行评审',
  'pages.docEditor.reviewModal.auditorPlaceholder': '请选择审核者',
  'pages.docEditor.reviewModal.auditorValidation': '请选择一个审核者',
  'pages.docEditor.reviewModal.auditorExtra': '审核者在评审组全部通过后对文档进行审核',
  'pages.docEditor.reviewModal.approverPlaceholder': '请选择批准者',
  'pages.docEditor.reviewModal.approverValidation': '请选择一个批准者',
  'pages.docEditor.reviewModal.approverExtra': '批准者负责最终确认文档是否可以发布',
  'pages.docEditor.reviewModal.changeSummaryLabel': '实际变更内容',
  'pages.docEditor.reviewModal.changeSummaryValidation': '请输入实际变更内容',

  'pages.docEditor.submitChangeModal.title': '提交变更',
  'pages.docEditor.submitChangeModal.processTitle': '变更流程说明：',
  'pages.docEditor.submitChangeModal.processItem1':
    '简易变更分为四个阶段：项目经理 → CCB 组长 → 验证 → 确认',
  'pages.docEditor.submitChangeModal.processItem2':
    '项目经理确认后进入 CCB 组长，组长通过后进入验证，验证人员通过后进入确认',
  'pages.docEditor.submitChangeModal.processItem3':
    '不通过时仅退回负责人会升小版本；退回 CCB 组长或验证人员则在原文档上继续',
  'pages.docEditor.submitChangeModal.projectManager': '项目经理',
  'pages.docEditor.submitChangeModal.ccbLeader': 'CCB 组长',
  'pages.docEditor.submitChangeModal.verifier': '验证人员',
  'pages.docEditor.submitChangeModal.confirmer': '确认人员',
  'pages.docEditor.submitChangeModal.projectManagerExtra': '当前项目的项目经理，不可修改',
  'pages.docEditor.submitChangeModal.projectManagerRequired': '当前项目未设置项目经理',
  'pages.docEditor.submitChangeModal.ccbLeaderRequired': '请选择 CCB 组长',
  'pages.docEditor.submitChangeModal.verifierRequired': '请选择验证人员',
  'pages.docEditor.submitChangeModal.confirmerRequired': '请选择确认人员',
  'pages.docEditor.submitChangeModal.ccbLeaderPlaceholder': '请选择 CCB 组长',
  'pages.docEditor.submitChangeModal.verifierPlaceholder': '请选择验证人员',
  'pages.docEditor.submitChangeModal.confirmerPlaceholder': '请选择确认人员',
  'pages.docEditor.submitChangeModal.ccbLeaderExtra': 'CCB 组长在项目经理通过后进行评审',
  'pages.docEditor.submitChangeModal.verifierExtra': '验证人员在 CCB 组长通过后进行验证',
  'pages.docEditor.submitChangeModal.confirmerExtra': '确认人员负责最终确认变更是否可以发布',
  'pages.docEditor.submitChangeModal.sameAsProjectManager': '不能与项目经理为同一人',
  'pages.docEditor.submitChangeModal.ccbLeaderEqualsVerifier': 'CCB 组长和验证人员不能是同一人',
  'pages.docEditor.submitChangeModal.ccbLeaderEqualsConfirmer': 'CCB 组长和确认人员不能是同一人',
  'pages.docEditor.submitChangeModal.verifierEqualsConfirmer': '验证人员和确认人员不能是同一人',

  // Update Review modal
  'pages.docEditor.updateReviewModal.title': '更新评审人',
  'pages.docEditor.updateReviewModal.reviewerLabel': '评审组',
  'pages.docEditor.updateReviewModal.reviewLeaderLabel': '评审组长',
  'pages.docEditor.updateReviewModal.auditorLabel': '审核者',
  'pages.docEditor.updateReviewModal.approverLabel': '批准者',
  'pages.docEditor.updateReviewModal.reviewerValidation': '请选择至少一个评审组成员',
  'pages.docEditor.updateReviewModal.reviewLeaderValidation': '请选择评审组长',
  'pages.docEditor.updateReviewModal.auditorValidation': '请选择审核者',
  'pages.docEditor.updateReviewModal.approverValidation': '请选择批准者',
  'pages.docEditor.updateReviewModal.approverInReviewersValidation': '批准者不能同时是评审组成员',
  'pages.docEditor.updateReviewModal.auditorInReviewersValidation': '审核者不能同时是评审组成员',
  'pages.docEditor.updateReviewModal.auditorEqualsApproverValidation': '审核者和批准者不能是同一人',
  'pages.docEditor.updateReviewModal.reviewLeaderInReviewersValidation':
    '评审组长不能同时是评审组成员',
  'pages.docEditor.updateReviewModal.reviewLeaderEqualsAuditorValidation':
    '评审组长和审核者不能是同一人',
  'pages.docEditor.updateReviewModal.reviewLeaderEqualsApproverValidation':
    '评审组长和批准者不能是同一人',
  'pages.docEditor.updateReviewModal.reviewerExtra':
    '可以选择多个评审组成员，全部通过后才能进入评审组长环节',
  'pages.docEditor.updateReviewModal.reviewLeaderExtra': '评审组长将在评审组全部通过后进行评审',
  'pages.docEditor.updateReviewModal.auditorExtra': '审核者将在评审组长通过后进行审核',
  'pages.docEditor.updateReviewModal.approverExtra': '批准者将在审核者通过后进行最终批准',
  'pages.docEditor.updateReviewModal.reviewerPlaceholder': '请选择评审组',
  'pages.docEditor.updateReviewModal.reviewLeaderPlaceholder': '请选择评审组长',
  'pages.docEditor.updateReviewModal.auditorPlaceholder': '请选择审核者',
  'pages.docEditor.updateReviewModal.approverPlaceholder': '请选择批准者',

  // Close Document modal
  'pages.docEditor.closeModal.title': '关闭文档',
  'pages.docEditor.closeModal.confirm': '是否需要保存当前文档？',
  'pages.docEditor.closeModal.saveAndClose': '保存并关闭',
  'pages.docEditor.closeModal.closeDirectly': '直接关闭',

  // ExcelTable Add Column
  'pages.excelTable.addFirstColumn': '添加首列',
  'pages.excelTable.afterColumn': '后面',
  'pages.excelTable.tableEnd': '表格末尾',

  // AI Generator quick prompts
  'pages.excelTable.quickSendTip': 'Ctrl/Cmd + Enter 快速发送',
  'pages.excelTable.quickPromptTitle': '快速选择常用提示语：',
  'pages.excelTable.aiPromptPlaceholder': '请输入表格数据要求...',
  'pages.excelTable.aiPromptDescription': '请输入您的内容要求，AI 为您生成相关数据',
  // Review result modal
  'pages.docEditor.reviewResultModal.title': '评审结果',
  'pages.docEditor.reviewResultModal.yourRole': '您的角色：',
  'pages.docEditor.reviewResultModal.currentStatus': '当前状态：',
  'pages.docEditor.reviewResultModal.approved': '已通过',
  'pages.docEditor.reviewResultModal.rejected': '已拒绝',
  'pages.docEditor.reviewResultModal.pending': '待评审',
  'pages.docEditor.reviewResultModal.reviewResult': '评审结果',
  'pages.docEditor.reviewResultModal.approveOption': '通过',
  'pages.docEditor.reviewResultModal.rejectOption': '不通过',
  'pages.docEditor.reviewResultModal.comment': '评审意见',
  'pages.docEditor.reviewResultModal.commentRequired': '请填写评审意见',

  // Revision history modal
  'pages.docEditor.revisionHistory.title': '版本历史',
  'pages.docEditor.revisionHistory.version': '版本',
  'pages.docEditor.revisionHistory.record': '修订记录',
  'pages.docEditor.revisionHistory.date': '修订日期',
  'pages.docEditor.revisionHistory.author': '作者',
  'pages.docEditor.revisionHistory.reviewer': '审核者',
  'pages.docEditor.revisionHistory.approver': '批准者',
  'pages.docEditor.revisionHistory.inputRecord': '请输入修订记录',

  // Revision records modal
  'pages.docEditor.revisionRecords.title': '修订记录',
  'pages.docEditor.revisionRecords.version': '版本',
  'pages.docEditor.revisionRecords.description': '修订描述',
  'pages.docEditor.revisionRecords.date': '修订日期',
  'pages.docEditor.revisionRecords.author': '负责人',
  'pages.docEditor.revisionRecords.reviewers': '评审组',
  'pages.docEditor.revisionRecords.auditors': '审核者',
  'pages.docEditor.revisionRecords.approvers': '批准者',
  'pages.docEditor.revisionRecords.actions': '操作',
  'pages.docEditor.revisionRecords.confirmDelete': '确定要删除该修订记录吗？',

  // Control Page modal
  'pages.docEditor.controlPage.title': '文档控制页',
  'pages.docEditor.controlPage.docVersion': '文档版本',
  'pages.docEditor.controlPage.docID': '文件编号',
  'pages.docEditor.controlPage.docStatus': '文件状态',
  'pages.docEditor.controlPage.draft': '草稿',
  'pages.docEditor.controlPage.draftLocked': '草稿锁定',
  'pages.docEditor.controlPage.inReview': '评审中',
  'pages.docEditor.controlPage.reviewPassed': '评审通过',
  'pages.docEditor.controlPage.auditPassed': '审核通过',
  'pages.docEditor.controlPage.approved': '已批准',
  'pages.docEditor.controlPage.controlled': '已受控',
  'pages.docEditor.controlPage.released': '发布',
  'pages.docEditor.controlPage.author': '编写',
  'pages.docEditor.controlPage.review': '评审',
  'pages.docEditor.controlPage.audit': '审核',
  'pages.docEditor.controlPage.approve': '批准',
  'pages.docEditor.controlPage.date': '日期',

  // ChangeRequestSummaryList
  'pages.changeRequestSummaryList.getSummariesFailed': '获取变更请求清单失败',
  'pages.changeRequestSummaryList.getSummariesListFailed': '获取变更请求清单列表失败',
  'pages.changeRequestSummaryList.getChangeRequestsFailed': '获取变更请求列表失败',
  'pages.changeRequestSummaryList.parseChangeRequestIdsFailed': '解析变更请求ID列表失败',
  'pages.changeRequestSummaryList.versionExists':
    '版本号 V{{version}} 已存在，请使用新的版本号或更新已有的变更请求清单',
  'pages.changeRequestSummaryList.updateSummaryFailed': '更新变更请求清单失败',
  'pages.changeRequestSummaryList.createSummaryFailed': '创建变更请求清单失败',
  'pages.changeRequestSummaryList.deleteFailed': '删除失败',
  'pages.changeRequestSummaryList.deleteDocumentFailed': '删除文档失败',
  'pages.changeRequestSummaryList.submitFailed': '提交失败，请检查表单',
  'pages.changeRequestSummaryList.updateSummarySuccess': '更新变更请求清单成功',
  'pages.changeRequestSummaryList.createSummarySuccess': '创建变更请求清单成功',
  'pages.changeRequestSummaryList.deleteSuccess': '删除成功',
  'pages.changeRequestSummaryList.version': '版本号',
  'pages.changeRequestSummaryList.status': '状态',
  'pages.changeRequestSummaryList.createTime': '创建时间',
  'pages.changeRequestSummaryList.actions': '操作',
  'pages.changeRequestSummaryList.statusDraft': '草稿',
  'pages.changeRequestSummaryList.statusDraftLocked': '草稿锁定',
  'pages.changeRequestSummaryList.statusReview': '评审中',
  'pages.changeRequestSummaryList.statusApproved': '已批准',
  'pages.changeRequestSummaryList.statusPublished': '已发布',
  'pages.changeRequestSummaryList.statusArchived': '已归档',
  'pages.changeRequestSummaryList.preview': '预览',
  'pages.changeRequestSummaryList.update': '更新',
  'pages.changeRequestSummaryList.delete': '删除',
  'pages.changeRequestSummaryList.createSummary': '新建变更请求清单',
  'pages.changeRequestSummaryList.updateSummaryTitle': '更新变更请求清单',
  'pages.changeRequestSummaryList.createSummaryTitle': '新建变更请求清单',
  'pages.changeRequestSummaryList.confirmDelete': '确认删除',
  'pages.changeRequestSummaryList.deleteConfirmMessage':
    '确定要删除变更请求清单 {{title}} 吗？删除后可在回收站恢复。',
  'pages.changeRequestSummaryList.confirm': '确认',
  'pages.changeRequestSummaryList.cancel': '取消',
  'pages.changeRequestSummaryList.versionLabel': '版本号',
  'pages.changeRequestSummaryList.versionRequired': '请输入版本号',
  'pages.changeRequestSummaryList.versionPattern': '版本号只能包含数字和小数点',
  'pages.changeRequestSummaryList.versionPlaceholder': '请输入数字格式的版本号，如：0.0',
  'pages.changeRequestSummaryList.changeRequestsLabel': '包含的变更请求',
  'pages.changeRequestSummaryList.changeRequestsRequired': '请选择至少一个变更请求',
  'pages.changeRequestSummaryList.changeRequestsPlaceholder': '选择要包含的变更请求',
  'pages.changeRequestSummaryList.fieldRequired': '${{label}}不能为空',
  'pages.changeRequestSummaryList.unnamedChangeRequest': '未命名变更请求',

  // Column configuration modal
  'pages.docEditor.columnConfig.title': '列配置',
  'pages.docEditor.columnConfig.columnTitle': '列标题',
  'pages.docEditor.columnConfig.relatedDoc': '相关文档',
  'pages.docEditor.columnConfig.relatedDataField': '相关数据字段',

  // Edit title modal
  'pages.docEditor.editTitleModal.title': '编辑标题',
  'pages.docEditor.editTitleModal.label': '标题',
  'pages.docEditor.editTitleModal.placeholder': '请输入标题',

  // Configure relation modal
  'pages.docEditor.configureRelation.title': '配置关系',
  'pages.docEditor.configureRelation.requirementTab': '需求',
  'pages.docEditor.configureRelation.requirementDoc': '需求文档',
  'pages.docEditor.configureRelation.requirementID': '需求ID',
  'pages.docEditor.configureRelation.architectureTab': '架构',
  'pages.docEditor.configureRelation.architectureDoc': '架构文档',
  'pages.docEditor.configureRelation.architectureSection': '架构章节',

  // TraceDocPanel组件相关
  'pages.docEditor.traceDocPanel.title': '上游工作产品',
  'pages.docEditor.traceDocPanel.readOnlyHint': '此处仅供查阅',
  'pages.docEditor.traceDocPanel.selectTraceDoc': '选择追溯文档',
  'pages.docEditor.traceDocPanel.noTraceDoc': '无追溯文档',
  'pages.docEditor.traceDocPanel.loadingTraceDocs': '正在加载追溯文档...',
  'pages.docEditor.traceDocPanel.refreshTraceDocs': '刷新追溯文档',
  'pages.docEditor.traceDocPanel.configureTrace': '配置追溯关系',
  'pages.docEditor.traceDocPanel.traceRelationship': '追溯关系',
  'pages.docEditor.traceDocPanel.sourceDocument': '源文档',
  'pages.docEditor.traceDocPanel.targetDocument': '目标文档',
  'pages.docEditor.traceDocPanel.openInNewPage': '在新页面中打开',
  'pages.docEditor.traceDocPanel.columnSettings': '默认列显示设置',
  'pages.docEditor.traceDocPanel.columnSettingsTitle': '默认列显示设置',
  'pages.docEditor.traceDocPanel.selectColumnsForDoc': '为文档 "{{title}}" 选择默认显示的列：',
  'pages.docEditor.traceDocPanel.selectAll': '全选',

  // 用户注册和认证
  'pages.register.passwordMismatch': '两次输入的密码不一致！',
  'pages.register.success': '注册成功！',
  'pages.register.failed': '注册失败！',
  'pages.register.failedRetry': '注册失败，请重试！',
  'pages.register.submit': '注册',
  'pages.register.email': '邮箱',
  'pages.register.emailRequired': '请输入邮箱!',
  'pages.register.emailInvalid': '请输入有效的邮箱地址!',
  'pages.register.name': '姓名',
  'pages.register.nameRequired': '请输入姓名!',
  'pages.register.password': '密码',
  'pages.register.passwordRequired': '请输入密码！',
  'pages.register.passwordMinLength': '密码长度至少6位！',
  'pages.register.confirmPassword': '确认密码',
  'pages.register.confirmPasswordRequired': '请确认密码！',
  'pages.register.backToLogin': '返回登录',

  // 忘记密码
  'pages.forgotPassword.success': '重置密码链接已发送到您的邮箱！',
  'pages.forgotPassword.failed': '发送失败，请重试！',
  'pages.forgotPassword.submit': '发送重置链接',
  'pages.forgotPassword.emailPlaceholder': '请输入注册邮箱',

  // ProcessDocs页面
  'pages.processDocs.fileName': '文件名称',
  'pages.processDocs.processName': '过程名称',
  'pages.processDocs.version': '版本',
  'pages.processDocs.status': '状态',
  'pages.processDocs.updateTime': '更新时间',
  'pages.processDocs.actions': '操作',
  'pages.processDocs.view': '查看',
  'pages.processDocs.search': '搜索',
  'pages.processDocs.searchPlaceholder': '输入文件名称搜索',
  'pages.processDocs.title': '程序文件列表',
  'pages.processDocs.statusDraft': '草稿',
  'pages.processDocs.statusDraftLocked': '草稿锁定',
  'pages.processDocs.statusReview': '评审中',
  'pages.processDocs.statusReviewPassed': '评审通过',
  'pages.processDocs.statusAuditPassed': '审核通过',
  'pages.processDocs.statusApproved': '已批准',
  'pages.processDocs.statusControlled': '已受控',
  'pages.processDocs.statusPublished': '已发布',
  'pages.processDocs.statusObsolete': '已废弃',

  // DocEditor组件
  'pages.docEditor.changeImplementationReport': '变更实施统计报告',
  'pages.docEditor.monthlyChangeStats': '月度变更统计',
  'pages.docEditor.noImage': '无图片',
  'pages.docEditor.noReviewInfo': '没有找到评审信息',
  'pages.docEditor.selectTraceItems': '为当前节点选择要追溯的文档项',
  'pages.docEditor.editRequirementDesc': '编辑需求描述',
  'pages.docEditor.testCaseTotal': '测试用例总数',
  'pages.docEditor.passedTests': '已通过测试',
  'pages.docEditor.failedTests': '未通过测试',
  'pages.docEditor.notExecutedTests': '未执行测试',
  'pages.docEditor.imagePreview': '图片预览',
  'pages.docEditor.traceItemChanged': '此追溯项已更改',
  'pages.docEditor.copy': '复制',
  'pages.docEditor.traceConfigured': '已配置追溯',
  'pages.docEditor.confirmDelete': '确认删除',
  'pages.docEditor.addNewNode': '添加新节点',
  'pages.docEditor.editNodeTitle': '编辑节点标题',
  'pages.docEditor.configureTraceRelation': '配置追溯关系',
  'pages.docEditor.appendTraceItems': '追加追溯',
  'pages.docEditor.appendTraceItemsTip': '把勾选的上游条目引用追加到本章节末尾，适合写完后批量挂',
  'pages.docEditor.insertUpstreamTrace': '插入上游追溯对象',
  'pages.docEditor.insertUpstreamTraceTip':
    '在光标处插入上游过程文档的条目引用，可以插在一句话中间',
  'pages.docEditor.insertUpstreamTraceDisabled':
    '本过程还没有上游追溯文档，请先在项目里配置上游文档',
  'pages.docEditor.insertSelfTrace': '插入本文档追溯对象',
  'pages.docEditor.insertSelfTraceTip':
    '在光标处插入本文档其它章节（段落 / 表格行）的引用，用于文档内部追溯',
  'pages.docEditor.traceDrawerDragTip': '拖动标题栏可移动，拖右下角可调整大小',
  'pages.docEditor.traceDrawerDragHint': '可拖动',
  'pages.docEditor.pleaseSelect': '请选择',
  'pages.docEditor.selfTraceSource.title': '本文档（内部追溯）',
  'pages.docEditor.selfTraceSource.badge': '本文内',
  'pages.docEditor.selfTraceSource.hint':
    '勾选本文档其它章节的段落或表格行，即可在本章节引用它们；取消勾选即从正文移除。',
  'pages.docEditor.selfTraceSource.noColumnHint':
    '{{process}} 过程页的「追溯矩阵」里还没点击「选择追溯项」，下面暂且显示全部 {{count}} 项。先去那里挑出需要被追溯的条目，回来这里就只剩勾过的了。',
  'pages.docEditor.enterNodeTitle': '请输入节点标题',
  'pages.docEditor.selectTraceItemsPlaceholder': '请选择要追溯的项',
  'pages.docEditor.nodeTitle': '节点标题',
  'pages.docEditor.selectTraceItemsLabel': '选择追溯项',

  // DocEditor角色
  'pages.docEditor.role.author': '撰写者',
  'pages.docEditor.role.reviewer': '评审组',
  'pages.docEditor.role.auditor': '审核者',
  'pages.docEditor.role.approver': '批准者',

  // ReviewPanel 评审面板
  'pages.docEditor.reviewPanel.title': '评审报告',
  'pages.docEditor.reviewPanel.changeFlowTitle': '变更流程',
  'pages.docEditor.reviewPanel.projectManagerTitle': '项目经理',
  'pages.docEditor.reviewPanel.ccbLeaderTitle': 'CCB 组长',
  'pages.docEditor.reviewPanel.verifierTitle': '验证人员',
  'pages.docEditor.reviewPanel.confirmerTitle': '确认人员',
  'pages.docEditor.reviewPanel.currentRole': '当前角色：',
  'pages.docEditor.reviewPanel.reviewer': '评审组',
  'pages.docEditor.reviewPanel.auditor': '审核者',
  'pages.docEditor.reviewPanel.approver': '批准者',
  'pages.docEditor.reviewPanel.me': '(我)',
  'pages.docEditor.reviewPanel.statusApproved': '已通过',
  'pages.docEditor.reviewPanel.statusConditional': '有条件通过',
  'pages.docEditor.reviewPanel.statusRejected': '已拒绝',
  'pages.docEditor.reviewPanel.commentIsProblem': '问题',
  'pages.docEditor.reviewPanel.commentNotProblem': '非问题',
  'pages.docEditor.reviewPanel.statusPending': '待评审',
  'pages.docEditor.reviewPanel.statusPendingAudit': '待审核',
  'pages.docEditor.reviewPanel.statusPendingApproval': '待批准',
  'pages.docEditor.reviewPanel.reviewComments': '评审意见：',
  'pages.docEditor.reviewPanel.inputSubject': '请输入主题',
  'pages.docEditor.reviewPanel.inputSubjectRequired': '请输入主题',
  'pages.docEditor.reviewPanel.subject': '主题',
  'pages.docEditor.reviewPanel.severity': '严重度',
  'pages.docEditor.reviewPanel.priority': '优先级',
  'pages.docEditor.reviewPanel.selectSeverity': '请选择严重度',
  'pages.docEditor.reviewPanel.selectPriority': '请选择优先级',
  'pages.docEditor.reviewPanel.severityRequired': '请选择严重度',
  'pages.docEditor.reviewPanel.priorityRequired': '请选择优先级',
  'pages.docEditor.reviewPanel.inputComment': '请输入评审意见',
  'pages.docEditor.reviewPanel.addComment': '添加意见',
  'pages.docEditor.reviewPanel.convertToDraft': '退回发起人',
  'pages.docEditor.reviewPanel.convertToDraftConfirm': '确认转为草稿？',
  'pages.docEditor.reviewPanel.convertToDraftConfirmDesc': '文档将退回草稿状态。',
  'pages.docEditor.reviewPanel.convertToDraftSuccess': '文档已转为草稿',
  'pages.docEditor.reviewPanel.convertToDraftFailed': '转为草稿失败',
  'pages.docEditor.reviewPanel.endReview': '结束评审',
  'pages.docEditor.reviewPanel.endReviewConfirm': '确认结束评审？',
  'pages.docEditor.reviewPanel.endReviewSuccess': '已结束评审',
  'pages.docEditor.reviewPanel.endReviewFailed': '结束评审失败',
  'pages.docEditor.reviewPanel.save': '保存',
  'pages.docEditor.reviewPanel.cancel': '取消',
  'pages.docEditor.reviewPanel.confirmDelete': '确定删除此评审意见？',
  'pages.docEditor.reviewPanel.approve': '通过',
  'pages.docEditor.reviewPanel.reject': '不通过',
  'pages.docEditor.reviewPanel.waitingForReviewers': '等待评审组全部通过后才能审核',
  'pages.docEditor.reviewPanel.waitingForAuditor': '等待审核者通过后才能批准',
  'pages.docEditor.reviewPanel.documentInfo': '文档信息',
  'pages.docEditor.reviewPanel.documentCode': '文档编号：',
  'pages.docEditor.reviewPanel.documentTitle': '文档标题：',
  'pages.docEditor.reviewPanel.version': '版本：',
  'pages.docEditor.reviewPanel.status': '状态：',
  'pages.docEditor.reviewPanel.inputCommentRequired': '请输入评审意见',
  'pages.docEditor.reviewPanel.commentAddSuccess': '评审意见已添加',
  'pages.docEditor.reviewPanel.commentAddFailed': '添加评审意见失败',
  'pages.docEditor.reviewPanel.commentUpdateSuccess': '评审意见已更新',
  'pages.docEditor.reviewPanel.commentUpdateFailed': '更新评审意见失败',
  'pages.docEditor.reviewPanel.commentDeleteSuccess': '评审意见已删除',
  'pages.docEditor.reviewPanel.commentDeleteFailed': '删除评审意见失败',
  'pages.docEditor.reviewPanel.commentRequired': '请输入评审意见',
  'pages.docEditor.reviewPanel.statusUpdateSuccess': '已通过评审',
  'pages.docEditor.reviewPanel.statusRejectSuccess': '已拒绝评审',
  'pages.docEditor.reviewPanel.statusUpdateFailed': '提交评审结果失败',
  'pages.docEditor.reviewPanel.loadCommentsFailed': '加载评审意见失败',
  'pages.docEditor.reviewPanel.reviewersTitle': '评审组',
  'pages.docEditor.reviewPanel.reviewLeaderTitle': '评审组长',
  'pages.docEditor.reviewPanel.auditorTitle': '审核者',
  'pages.docEditor.reviewPanel.approverTitle': '批准者',
  'pages.docEditor.reviewPanel.returnToLabel': '退回目标',
  'pages.docEditor.reviewPanel.returnToOwner': '负责人',
  'pages.docEditor.reviewPanel.returnToReviewLeader': '评审组长',
  'pages.docEditor.reviewPanel.returnToAuditor': '审核者',
  'pages.docEditor.reviewPanel.returnToOwnerSuccess': '已退回负责人并生成新版本 V{{version}}',
  'pages.docEditor.reviewPanel.upgradeSuccess': '已批准当前版本，并生成受控版本 V{{version}}',
  'pages.docEditor.reviewPanel.sourceVersion': '来源版本 V{{version}}',
  'pages.docEditor.reviewPanel.historyTitle': '评审历史',
  'pages.docEditor.reviewPanel.historyEmpty': '暂无评审数据',
  'pages.docEditor.reviewPanel.withdrawReview': '撤回评审',
  'pages.docEditor.reviewPanel.withdrawChange': '撤回变更',
  'pages.docEditor.reviewPanel.withdrawReviewConfirm': '确认撤回评审？',
  'pages.docEditor.reviewPanel.withdrawChangeConfirm': '确认撤回变更？',
  'pages.docEditor.reviewPanel.withdrawReviewDescription':
    '撤回后文档将回到草稿，本次评审意见和由此产生的问题会被删除。',
  'pages.docEditor.reviewPanel.withdrawChangeDescription':
    '撤回后文档将回到草稿，本次变更意见和由此产生的问题会被删除。',
  'pages.docEditor.reviewPanel.withdrawReviewSuccess': '已撤回评审',
  'pages.docEditor.reviewPanel.withdrawChangeSuccess': '已撤回变更',
  'pages.docEditor.reviewPanel.withdrawReviewFailed': '撤回失败',

  // DocEditor 问题面板
  'pages.docEditor.problemPanel.title': '问题',
  'pages.docEditor.problemPanel.create': '创建问题',
  'pages.docEditor.problemPanel.empty': '暂无问题',
  'pages.docEditor.problemPanel.loadAll': '已加载全部问题',
  'pages.docEditor.problemPanel.sourceVersion': '来源版本 V{{version}}',
  'pages.docEditor.problemPanel.sourceVersionLabel': '来源版本',
  'pages.docEditor.problemPanel.detailTitle': '问题详情',
  'pages.docEditor.problemPanel.formTitle': '创建问题',
  'pages.docEditor.problemPanel.subjectRequired': '请输入主题',
  'pages.docEditor.problemPanel.subjectPlaceholder': '请输入主题',
  'pages.docEditor.problemPanel.descriptionRequired': '请输入问题描述',
  'pages.docEditor.problemPanel.descriptionPlaceholder': '请输入问题描述',
  'pages.docEditor.problemPanel.priorityRequired': '请选择优先级',
  'pages.docEditor.problemPanel.severityRequired': '请选择严重度',
  'pages.docEditor.problemPanel.processDocument': '过程和文档',
  'pages.docEditor.problemPanel.processDocumentRequired': '请选择过程和文档',
  'pages.docEditor.problemPanel.processDocumentPlaceholder': '请选择过程和文档',
  'pages.docEditor.problemPanel.createSuccess': '创建成功',
  'pages.docEditor.problemPanel.createFailed': '创建失败',
  'pages.docEditor.problemPanel.edit': '编辑',
  'pages.docEditor.problemPanel.editTitle': '编辑问题',
  'pages.docEditor.problemPanel.editSuccess': '编辑成功',
  'pages.docEditor.problemPanel.editFailed': '编辑失败',
  'pages.docEditor.problemPanel.loadDetailFailed': '加载问题详情失败',
  'pages.docEditor.problemPanel.loadOptionsFailed': '获取过程和文档列表失败',
  'pages.docEditor.problemPanel.assignTitle': '分配问题',
  'pages.docEditor.problemPanel.assign': '分配',
  'pages.docEditor.problemPanel.handlerRequired': '请选择经办人',
  'pages.docEditor.problemPanel.handlerPlaceholder': '请选择经办人',
  'pages.docEditor.problemPanel.remarkPlaceholder': '请输入备注',
  'pages.docEditor.problemPanel.assignSuccess': '分配成功',
  'pages.docEditor.problemPanel.assignFailed': '分配失败',
  'pages.docEditor.problemPanel.loadHandlersFailed': '获取经办人列表失败',
  'pages.docEditor.problemPanel.activity': '活动',
  'pages.docEditor.problemPanel.historyEmpty': '暂无活动',
  'pages.docEditor.problemPanel.historyChangeField': '{{field}}：',
  'pages.docEditor.problemPanel.noModification': '无需修改',
  'pages.docEditor.problemPanel.noModificationTitle': '无需修改',
  'pages.docEditor.problemPanel.startProcessing': '开始处理',
  'pages.docEditor.problemPanel.startProcessingTitle': '开始处理',
  'pages.docEditor.problemPanel.submitReview': '提交检视',
  'pages.docEditor.problemPanel.submitReviewTitle': '提交检视',
  'pages.docEditor.problemPanel.reviewPass': '检视通过',
  'pages.docEditor.problemPanel.reviewFail': '检视不通过',
  'pages.docEditor.problemPanel.reviewFailTitle': '检视不通过',
  'pages.docEditor.problemPanel.closeProblem': '问题关闭',
  'pages.docEditor.problemPanel.pass': '通过',
  'pages.docEditor.problemPanel.reject': '不通过',
  'pages.docEditor.problemPanel.rejectTitle': '不通过',
  'pages.docEditor.problemPanel.reopen': '重开',
  'pages.docEditor.problemPanel.reopenTitle': '重开',
  'pages.docEditor.problemPanel.isProblemRequired': '请选择是否是问题',
  'pages.docEditor.problemPanel.plannedCompletionDateRequired': '请选择计划完成日期',
  'pages.docEditor.problemPanel.plannedCompletionDatePlaceholder': '请选择计划完成日期',
  'pages.docEditor.problemPanel.rootCauseRequired': '请输入根本原因',
  'pages.docEditor.problemPanel.rootCausePlaceholder': '请输入根本原因',
  'pages.docEditor.problemPanel.temporaryActionRequired': '请输入临时措施',
  'pages.docEditor.problemPanel.temporaryActionPlaceholder': '请输入临时措施',
  'pages.docEditor.problemPanel.solutionRequired': '请输入解决方案',
  'pages.docEditor.problemPanel.solutionPlaceholder': '请输入解决方案',
  'pages.docEditor.problemPanel.workHoursRequired': '请输入工时',
  'pages.docEditor.problemPanel.workHoursPlaceholder': '请输入工时',
  'pages.docEditor.problemPanel.resolutionDocumentPlaceholder': '请选择解决版本',
  'pages.docEditor.problemPanel.remarkRequired': '请输入备注',
  'pages.docEditor.problemPanel.confirmReviewPass': '确认检视通过？',
  'pages.docEditor.problemPanel.confirmClose': '确认关闭该问题？',
  'pages.docEditor.problemPanel.delete': '删除',
  'pages.docEditor.problemPanel.confirmDelete': '确认删除该问题？',
  'pages.docEditor.problemPanel.deleteSuccess': '删除成功',
  'pages.docEditor.problemPanel.deleteFailed': '删除失败',
  'pages.docEditor.problemPanel.actionSuccess': '操作成功',
  'pages.docEditor.problemPanel.actionFailed': '操作失败',
  'pages.docEditor.problemPanel.relatedCasePlaceholder': '请输入关联用例',
  'pages.docEditor.problemPanel.similarProblemPlaceholder': '点击选择链接的问题',
  'pages.docEditor.problemPanel.selectSimilarProblem': '选择链接的问题',
  'pages.docEditor.problemPanel.similarProblemRequired': '请选择一条问题',
  'pages.docEditor.problemPanel.loadSimilarProblemsFailed': '获取问题列表失败',
  'pages.docEditor.problemPanel.uploadAttachment': '选择文件',
  'pages.docEditor.problemPanel.downloadAttachmentFailed': '附件下载失败',

  // DocEditor评审结果弹窗
  'pages.docEditor.reviewResultModal.noComment': '无评审意见',

  // DocEditor文档树操作
  'pages.docEditor.addSameLevel': '新增同级',
  'pages.docEditor.addChildLevel': '新增下级',
  'pages.docEditor.upgradeNode': '升级节点',
  'pages.docEditor.downgradeNode': '降级节点',
  'pages.docEditor.delete': '删除',
  'pages.docEditor.unknown': '未知',
  'pages.docEditor.aiGeneratedContent': '基于您的要求"{{prompt}}"，AI 生成的内容将在此显示。',

  // ExcelTable错误消息
  'pages.excelTable.readFileFailed': '读取文件失败',
  'pages.excelTable.noValidSheets': 'Excel文件中没有有效的工作表',
  'pages.excelTable.noValidData': '未找到有效的表格数据',
  'pages.excelTable.importFailed': '导入Excel失败，请检查文件格式',
  'pages.excelTable.getTraceDataFailed': '获取追溯数据失败',

  // DocumentTree 组件
  'pages.documentTree.confirmDeleteTitle': '确认删除',
  'pages.documentTree.confirmDeleteContent': '确定要删除该节点及其所有子节点吗？此操作不可恢复。',
  'pages.documentTree.addNewNodeTitle': '添加新节点',
  'pages.documentTree.nodeTitle': '节点标题',
  'pages.documentTree.nodeTitleRequired': '请输入节点标题',
  'pages.documentTree.nodeTitlePlaceholder': '请输入节点标题',
  'pages.documentTree.addAsChildNode': '新节点将添加为当前节点的子节点',
  'pages.documentTree.addAsSiblingNode': '新节点将添加在当前节点后面',
  'pages.documentTree.editNodeTitleTitle': '编辑节点标题',
  'pages.documentTree.configureTraceTitle': '配置追溯关系',
  'pages.documentTree.configureTraceDescription': '为当前节点选择要追溯的文档项',
  'pages.documentTree.nodeLabel': '节点',
  'pages.documentTree.selectTraceItems': '选择追溯项',
  'pages.documentTree.selectTraceItemsPlaceholder': '请选择要追溯的项',
  'pages.documentTree.loading': '加载中...',
  'pages.documentTree.return': '返回',
  'pages.documentTree.saveAndClose': '保存并关闭',

  // Notifications 通知页面
  'pages.notifications.deleteRead': '删除已读',
  'pages.notifications.confirmDeleteTitle': '确认删除',
  'pages.notifications.confirmDeleteContent': '将永久删除所有已读消息，且不可恢复。是否继续？',
  'pages.notifications.deleteReadMessages': '删除已读消息',
  'pages.notifications.cancel': '取消',
  'pages.notifications.deleteSuccess': '删除成功',
  'pages.notifications.deleteFailed': '删除失败',
  'pages.notifications.getListFailed': '获取通知列表失败',
  'pages.notifications.markedAsRead': '已标记为已读',
  'pages.notifications.markReadFailed': '标记已读失败',
  'pages.notifications.markAsRead': '标记已读',
  'pages.notifications.read': '已读',
  'pages.notifications.unread': '未读',
  'pages.notifications.total': '共 {{total}} 条',

  // 问题解决
  'pages.problemResolution.index': '序号',
  'pages.problemResolution.code': '问题编号',
  'pages.problemResolution.comments': '意见',
  'pages.problemResolution.commentsEmpty': '暂无意见',
  'pages.problemResolution.commentPlaceholder': '请输入意见',
  'pages.problemResolution.commentRequired': '请输入意见内容',
  'pages.problemResolution.commentAddSuccess': '意见已添加',
  'pages.problemResolution.commentAddFailed': '添加意见失败',
  'pages.problemResolution.process': '过程',
  'pages.problemResolution.document': '文档',
  'pages.problemResolution.subject': '主题',
  'pages.problemResolution.description': '问题描述',
  'pages.problemResolution.reporter': '报告人',
  'pages.problemResolution.discoverySource': '问题来源',
  'pages.problemResolution.createdAt': '创建日期',
  'pages.problemResolution.updatedAt': '更新日期',
  'pages.problemResolution.severity': '严重度',
  'pages.problemResolution.priority': '优先级',
  'pages.problemResolution.rootCause': '根本原因',
  'pages.problemResolution.status': '状态',
  'pages.problemResolution.currentHandler': '当前处理人',
  'pages.problemResolution.svv1Owner': '验证人员',
  'pages.problemResolution.verifiedAt': '验证日期',
  'pages.problemResolution.svv2Owner': '确认人员',
  'pages.problemResolution.confirmedAt': '确认日期',
  'pages.problemResolution.owner': '负责人',
  'pages.problemResolution.handler': '经办人',
  'pages.problemResolution.isProblem': '是否是问题',
  'pages.problemResolution.isProblemYes': '是',
  'pages.problemResolution.isProblemNo': '否',
  'pages.problemResolution.temporaryAction': '临时措施',
  'pages.problemResolution.solution': '解决方案',
  'pages.problemResolution.plannedCompletionDate': '计划完成日期',
  'pages.problemResolution.actualCompletionDate': '实际完成日期',
  'pages.problemResolution.workHours': '工时',
  'pages.problemResolution.resolutionDocument': '解决版本',
  'pages.problemResolution.publishedAt': '发布日期',
  'pages.problemResolution.remark': '备注',
  'pages.problemResolution.relatedCase': '关联用例',
  'pages.problemResolution.similarProblem': '链接的问题',
  'pages.problemResolution.attachment': '附件',
  'pages.problemResolution.searchPlaceholder': '输入主题或问题描述搜索',
  'pages.problemResolution.actions': '操作',
  'pages.problemResolution.delete': '删除',
  'pages.problemResolution.confirmDelete': '确认删除',
  'pages.problemResolution.confirmDeleteContent': '确定要删除该问题吗？',
  'pages.problemResolution.deleteSuccess': '删除成功',
  'pages.problemResolution.deleteFailed': '删除失败',
  'pages.problemResolution.createTitle': '创建问题',
  'pages.problemResolution.createSuccess': '创建成功',
  'pages.problemResolution.createFailed': '创建失败',
  'pages.problemResolution.subjectRequired': '请输入主题',
  'pages.problemResolution.subjectPlaceholder': '请输入主题',
  'pages.problemResolution.descriptionRequired': '请输入问题描述',
  'pages.problemResolution.descriptionPlaceholder': '请输入问题描述',
  'pages.problemResolution.severityRequired': '请选择严重度',
  'pages.problemResolution.priorityRequired': '请选择优先级',
  'pages.problemResolution.processDocument': '过程和文档',
  'pages.problemResolution.processDocumentRequired': '请选择过程和文档',
  'pages.problemResolution.processDocumentPlaceholder': '请选择过程和文档',
  'pages.problemResolution.discoverySourceRequired': '请选择问题来源',
  'pages.problemResolution.remarkPlaceholder': '请输入备注',
  'pages.problemResolution.loadOptionsFailed': '获取过程和文档列表失败',
  'pages.problemResolution.export': '导出',
  'pages.problemResolution.exportWithCount': '导出 ({{count}})',
  'pages.problemResolution.exportEmpty': '请选择需要导出的问题',
  'pages.problemResolution.exportSuccess': '导出成功',
  'pages.problemResolution.exportFailed': '导出失败',
  'pages.problemResolution.exportFileName': '问题清单',

  // 质量保证检查
  'pages.qualityAssurance.index': '序号',
  'pages.qualityAssurance.criteria': '评价标准',
  'pages.qualityAssurance.hasDeviation': '偏差',
  'pages.qualityAssurance.hasDeviationYes': '有',
  'pages.qualityAssurance.hasDeviationNo': '无',
  'pages.qualityAssurance.subject': '主题',
  'pages.qualityAssurance.description': '问题描述',
  'pages.qualityAssurance.severity': '严重度',
  'pages.qualityAssurance.priority': '优先级',
  'pages.qualityAssurance.status': '状态',
  'pages.qualityAssurance.document': '文档',
  'pages.qualityAssurance.addFinding': 'QA发现问题',
  'pages.qualityAssurance.createTitle': 'QA发现问题',
  'pages.qualityAssurance.editTitle': '编辑QA问题',
  'pages.qualityAssurance.createSuccess': '创建成功',
  'pages.qualityAssurance.createFailed': '创建失败',
  'pages.qualityAssurance.edit': '编辑',
  'pages.qualityAssurance.editSuccess': '编辑成功',
  'pages.qualityAssurance.editFailed': '编辑失败',
  'pages.qualityAssurance.criteriaRequired': '请输入评价标准',
  'pages.qualityAssurance.criteriaPlaceholder': '请输入评价标准',
  'pages.qualityAssurance.hasDeviationRequired': '请选择是否有偏差',
  'pages.qualityAssurance.subjectRequired': '请输入主题',
  'pages.qualityAssurance.subjectPlaceholder': '请输入主题',
  'pages.qualityAssurance.descriptionRequired': '请输入问题描述',
  'pages.qualityAssurance.descriptionPlaceholder': '请输入问题描述',
  'pages.qualityAssurance.severityRequired': '请选择严重度',
  'pages.qualityAssurance.priorityRequired': '请选择优先级',
  'pages.qualityAssurance.documentRequired': '请选择文档',
  'pages.qualityAssurance.selectDocument': '请选择当前过程下的工作产品或策划类文档',
  'pages.qualityAssurance.getDocumentsFailed': '获取文档列表失败',
  'pages.qualityAssurance.searchPlaceholder': '输入评价标准、主题或问题描述搜索',
  'pages.qualityAssurance.actions': '操作',
  'pages.qualityAssurance.delete': '删除',
  'pages.qualityAssurance.confirmDelete': '确认删除',
  'pages.qualityAssurance.confirmDeleteContent': '确定要删除该检查项吗？',
  'pages.qualityAssurance.deleteSuccess': '删除成功',
  'pages.qualityAssurance.deleteFailed': '删除失败',

  // 质量保证 - 检查表执行
  'pages.qualityAssurance.tabExecution': '检查表执行',
  'pages.qualityAssurance.tabFindings': '问题清单',
  'pages.qualityAssurance.tabArchive': '外部检查表',
  'pages.qualityAssurance.tabQaRecord': 'QA记录',
  'pages.qualityAssurance.tabNonconformity': 'QA不符合项列表',
  'pages.qaNonconformity.add': '添加不符合项',
  'pages.qaNonconformity.addTitle': '添加不符合项',
  'pages.qaNonconformity.editTitle': '编辑不符合项',
  'pages.qaNonconformity.addSuccess': '不符合项已添加',
  'pages.qaNonconformity.saveSuccess': '不符合项已保存',
  'pages.qaNonconformity.saveFailed': '保存失败',
  'pages.qaNonconformity.deleteSuccess': '不符合项已删除',
  'pages.qaNonconformity.deleteFailed': '删除失败',
  'pages.qaNonconformity.deleteConfirm': '确认删除这条不符合项？',
  'pages.qaNonconformity.deleteConfirmContent': '删除后不可恢复。',
  'pages.qaNonconformity.edit': '编辑',
  'pages.qaNonconformity.delete': '删除',
  'pages.qaNonconformity.save': '保存',
  'pages.qaNonconformity.cancel': '取消',
  'pages.qaNonconformity.actions': '操作',
  'pages.qaNonconformity.yes': '是',
  'pages.qaNonconformity.no': '否',
  'pages.qaNonconformity.code': '不符合项编号',
  'pages.qaNonconformity.codeRequired': '请填写不符合项编号',
  'pages.qaNonconformity.stage': '阶段',
  'pages.qaNonconformity.description': '不符合项描述',
  'pages.qaNonconformity.descriptionRequired': '请填写不符合项描述',
  'pages.qaNonconformity.auditType': '审核类型',
  'pages.qaNonconformity.auditTypeRequired': '请选择审核类型',
  'pages.qaNonconformity.auditType_PROCESS_AUDIT': '过程审核',
  'pages.qaNonconformity.auditType_WORK_PRODUCT_AUDIT': '工作产品审核',
  'pages.qaNonconformity.submitter': '提交人',
  'pages.qaNonconformity.submitDate': '提交日期',
  'pages.qaNonconformity.severity': '严重度',
  'pages.qaNonconformity.stageProduct': '阶段过程/标准工作产品',
  'pages.qaNonconformity.problemSource': '问题来源',
  'pages.qaNonconformity.cause': '产生原因',
  'pages.qaNonconformity.correctiveAction': '纠正措施',
  'pages.qaNonconformity.submittedToQm': '是否提交质量管理部',
  'pages.qaNonconformity.submittedToTop': '是否提交最高管理者',
  'pages.qaNonconformity.planResolveDate': '计划解决时间',
  'pages.qaNonconformity.actualResolveDate': '实际解决时间',
  'pages.qaNonconformity.resolver': '解决人',
  'pages.qaNonconformity.verifyAction': '验证纠正措施',
  'pages.qaNonconformity.verifyDate': '实施验证时间',
  'pages.qaNonconformity.verifier': '验证人',

  // 质量保证 - 外部检查表归档（原件原封不动上传，仅保真预览与下载；不进执行口径）
  'pages.qualityAssurance.archiveHint':
    '外部检查表由用户线下自行维护，系统只做原件归档与预览，不参与执行统计、AI 预检与问题台账',
  'pages.qualityAssurance.archiveUpload': '上传外部检查表',
  'pages.qualityAssurance.archiveUploadTitle': '上传外部检查表原件',
  'pages.qualityAssurance.archiveName': '检查表名称',
  'pages.qualityAssurance.archiveNamePlaceholder': '留空则取文件名',
  'pages.qualityAssurance.archiveVersionPlaceholder': '如：V2.1',
  'pages.qualityAssurance.archiveRemark': '备注',
  'pages.qualityAssurance.archiveRemarkPlaceholder': '如：线下已实施，结论见末列',
  'pages.qualityAssurance.archiveHasRecord': '含检查记录',
  'pages.qualityAssurance.archiveHasRecordHint': '仅作标注，不会导入问题台账',
  'pages.qualityAssurance.archivePickFile': '选择文件',
  'pages.qualityAssurance.archiveFileHint':
    '支持 xlsx / xls / csv / docx / pdf / 图片 / html / txt；原件原封不动保存，可在线预览或下载',
  'pages.qualityAssurance.archiveFileRequired': '请先选择文件',
  'pages.qualityAssurance.archiveMultiHint': '可一次选择多个文件，每份单独生成一条归档记录',
  'pages.qualityAssurance.archiveTitleBatchHint': '批量上传时忽略此标题，每份按原文件名命名',
  'pages.qualityAssurance.archiveFileTitleListHint':
    '以下每份文件都会单独生成一条记录，记录名称已按文件名预填，版本号可逐份填写：',
  'pages.qualityAssurance.archiveFileVersionPlaceholder': '版本号',
  'pages.qualityAssurance.uploadBatchSuccess': '已上传 {{count}} 份',
  'pages.qualityAssurance.qaReviewStage': '审核阶段',
  'pages.qualityAssurance.qaReviewStagePlaceholder': '如：立项 / 策划 / 设计 / 验证',
  'pages.qualityAssurance.qaReviewTypePlaceholder': '如：过程审核 / 工作产品审核 / 客户审核',
  'pages.qualityAssurance.filterTitlePlaceholder': '按名称 / 文件名筛选',
  'pages.qualityAssurance.filterVersionPlaceholder': '按版本筛选',
  'pages.qualityAssurance.filterStagePlaceholder': '按审核阶段筛选',
  'pages.qualityAssurance.filterUploaderPlaceholder': '按上传人筛选',
  'pages.qualityAssurance.filterTimePlaceholder': '按上传时间筛选（如 2026-10）',
  'pages.qualityAssurance.filterReset': '重置',
  'pages.qualityAssurance.filterClearAll': '清空全部筛选',
  'pages.qualityAssurance.filterResult': '筛选出 {{filtered}} 条 / 共 {{total}} 条',
  'pages.qualityAssurance.archiveEmpty': '尚未上传外部检查表',
  'pages.qualityAssurance.archiveEmptyDesc':
    '可将线下自己那份固定检查表（含或不含记录）原样上传，在线预览或下载归档。',
  'pages.qualityAssurance.archiveFilterEmpty': '没有符合筛选条件的外部检查表',
  'pages.qualityAssurance.archiveFilterEmptyDesc': '调整或清空表头筛选条件后再看。',
  'pages.qualityAssurance.archiveLoadFailed': '加载外部检查表失败',
  'pages.qualityAssurance.archiveUploadSuccess': '外部检查表已上传',
  'pages.qualityAssurance.archiveUploadFailed': '外部检查表上传失败',
  'pages.qualityAssurance.archiveDeleteConfirm': '确认删除该外部检查表？',
  'pages.qualityAssurance.archiveDeleteConfirmContent': '将同时删除已上传的原件，删除后不可恢复。',
  'pages.qualityAssurance.archiveDeleteSuccess': '已删除外部检查表',
  'pages.qualityAssurance.archiveDeleteFailed': '删除失败',
  'pages.qualityAssurance.archivePreview': '预览',
  'pages.qualityAssurance.archiveDownload': '下载',
  'pages.qualityAssurance.archiveDelete': '删除',
  // 批量删除（两个归档夹共用同一套文案：只删所选、跨分类混选由服务端整批拒绝）
  'pages.qualityAssurance.batchDelete': '批量删除',
  'pages.qualityAssurance.batchSelected': '已选 {{count}} 项',
  'pages.qualityAssurance.batchDeleteConfirmTitle': '确认删除 {{count}} 个归档件？',
  'pages.qualityAssurance.batchDeleteConfirmContent':
    '将同时删除已上传的原件文件，删除后不可恢复。',
  'pages.qualityAssurance.batchDeleteMore': '等 {{count}} 个',
  'pages.qualityAssurance.batchDeleteSuccess': '已删除 {{count}} 个归档件',
  'pages.qualityAssurance.batchDeleteFailed': '批量删除失败',
  'pages.qualityAssurance.archiveColumnTitle': '名称',
  'pages.qualityAssurance.archiveColumnVersion': '版本',
  'pages.qualityAssurance.archiveColumnRecord': '含记录',
  'pages.qualityAssurance.archiveColumnSize': '大小',
  'pages.qualityAssurance.archiveColumnUploader': '上传人',
  'pages.qualityAssurance.archiveColumnTime': '上传时间',
  'pages.qualityAssurance.archiveColumnActions': '操作',
  'pages.qualityAssurance.archiveRecordYes': '含记录',
  'pages.qualityAssurance.archiveRecordNo': '无记录',
  'pages.qualityAssurance.archivePreviewTitle': '预览：{{name}}',
  'pages.qualityAssurance.archivePreviewLoading': '正在加载原件…',
  'pages.qualityAssurance.archivePreviewFailed': '预览加载失败',
  'pages.qualityAssurance.archivePreviewUnsupported': '该格式暂不支持在线预览，请下载后查看',
  'pages.qualityAssurance.archiveSheet': '工作表',
  'pages.qualityAssurance.archivePreviewHint': '原件为只读展示，不会被修改；如需更换请重新上传',

  // 质量保证 - QA记录（公司 QA 人员审核各过程时留下的记录；与外部检查表同构，仅措辞不同）
  'pages.qualityAssurance.qaRecordHint':
    'QA记录由公司 QA 人员审核各个过程时产出，系统只做原件归档与预览，不参与执行统计、AI 预检与问题台账',
  'pages.qualityAssurance.qaRecordUpload': '上传QA记录',
  'pages.qualityAssurance.qaRecordUploadTitle': '上传QA记录原件',
  'pages.qualityAssurance.qaRecordName': '记录名称',
  'pages.qualityAssurance.qaRecordColumnTitle': '记录名称',
  'pages.qualityAssurance.qaRecordRemarkPlaceholder': '如：2026-10 审核 SYS.2 的观察项与偏差',
  'pages.qualityAssurance.qaRecordEmpty': '尚未上传QA记录',
  'pages.qualityAssurance.qaRecordEmptyDesc':
    '可将本过程的 QA 审核记录（巡检、评审、观察项等）原样上传，在线预览或下载归档。',
  'pages.qualityAssurance.qaRecordFilterEmpty': '没有符合筛选条件的QA记录',
  'pages.qualityAssurance.qaRecordFilterEmptyDesc': '调整或清空表头筛选条件后再看。',
  'pages.qualityAssurance.qaRecordLoadFailed': '加载QA记录失败',
  'pages.qualityAssurance.qaRecordUploadSuccess': 'QA记录已上传',
  'pages.qualityAssurance.qaRecordUploadFailed': 'QA记录上传失败',
  'pages.qualityAssurance.qaRecordDeleteConfirm': '确认删除该QA记录？',
  'pages.qualityAssurance.qaRecordDeleteConfirmContent': '将同时删除已上传的原件，删除后不可恢复。',
  'pages.qualityAssurance.qaRecordDeleteSuccess': '已删除QA记录',
  'pages.qualityAssurance.checklistUpload': '上传检查表',
  'pages.qualityAssurance.checklistUpdate': '更新检查表',
  'pages.qualityAssurance.checklistDelete': '删除检查表',
  'pages.qualityAssurance.checklistEmptyTitle': '尚未上传质量检查表',
  'pages.qualityAssurance.checklistEmptyDesc': '上传本过程的质量检查表后，可逐条检查并记录结果。',
  'pages.qualityAssurance.checklistMeta': '{{name}}（{{count}} 条）',
  'pages.qualityAssurance.checklistVersion': '版本',
  'pages.qualityAssurance.checklistSource': '来源文件',
  'pages.qualityAssurance.checklistProgress': '已检查 {{checked}}/{{total}}',
  'pages.qualityAssurance.checklistNonconform': '不符合 {{count}}',
  'pages.qualityAssurance.checklistRechecked': '已复检 {{count}} 条',
  'pages.qualityAssurance.checklistGroupChecklist': '检查表（只读参照）',
  'pages.qualityAssurance.checklistGroupRecord': '检查记录',
  'pages.qualityAssurance.checklistSeq': '序号',
  'pages.qualityAssurance.checklistClause': '条款',
  'pages.qualityAssurance.checklistItemText': '检查条目',
  'pages.qualityAssurance.checklistDocument': '检查文档',
  'pages.qualityAssurance.checklistVerdict': '检查结果',
  'pages.qualityAssurance.checklistEvidence': '证据/说明',
  'pages.qualityAssurance.verdictConform': '符合',
  'pages.qualityAssurance.verdictNonconform': '不符合',
  'pages.qualityAssurance.verdictNotApplicable': '不适用',
  'pages.qualityAssurance.verdictPending': '未检查',
  'pages.qualityAssurance.recordAction': '记录',
  'pages.qualityAssurance.recordEditAction': '修改',
  'pages.qualityAssurance.recordRecheckAction': '复检',
  'pages.qualityAssurance.recordRound': '第 {{n}} 轮',
  'pages.qualityAssurance.recordCurrentRound': '当前',
  'pages.qualityAssurance.recordRoundTitle': '第 {{n}} 轮检查记录',
  'pages.qualityAssurance.recordTitle': '记录检查结果',
  'pages.qualityAssurance.recordEditTitle': '修改检查结果',
  'pages.qualityAssurance.recordClear': '清除结果',
  'pages.qualityAssurance.recordClearConfirm': '确认清除第 {{n}} 轮检查记录？',
  'pages.qualityAssurance.recordClearContent':
    '仅删除该轮记录；该轮派生的问题会一并删除，同一条目的其他轮次不受影响。',
  'pages.qualityAssurance.recordClearSuccess': '已清除检查结果',
  'pages.qualityAssurance.recordSuccess': '检查结果已保存',
  'pages.qualityAssurance.recordFailed': '检查结果保存失败',
  'pages.qualityAssurance.verdictRequired': '请选择检查结果',
  'pages.qualityAssurance.recordEvidencePlaceholder': '记录判断依据或证据位置',
  'pages.qualityAssurance.recordHint': '仅 SUP.1 过程负责人或成员可上传检查表并记录检查结果',
  'pages.qualityAssurance.checklistLoadFailed': '加载检查表失败',
  'pages.qualityAssurance.uploadTitle': '上传质量检查表',
  'pages.qualityAssurance.uploadName': '检查表名称',
  'pages.qualityAssurance.uploadNamePlaceholder': '如：SYS.2 质量检查表',
  'pages.qualityAssurance.uploadVersionPlaceholder': '如：1.0',
  'pages.qualityAssurance.uploadPasteTab': '粘贴条目',
  'pages.qualityAssurance.uploadFileTab': '上传文件',
  'pages.qualityAssurance.uploadPastePlaceholder':
    '每行一条检查条目；可从 Excel 直接复制「条款 + 检查条目」两列粘贴，或用「条款|条目」写法',
  'pages.qualityAssurance.uploadPickFile': '选择文件',
  'pages.qualityAssurance.uploadFileHint':
    '支持 .xlsx / .csv / .txt，自动识别条款号与条目文本，表头行会被跳过',
  'pages.qualityAssurance.uploadFileParsed': '已解析 {{count}} 条',
  'pages.qualityAssurance.uploadFileParseFailed': '文件解析失败，请检查文件内容',
  'pages.qualityAssurance.uploadPreview': '条目预览（可删除、可编辑）',
  'pages.qualityAssurance.uploadPreviewEmpty': '请先粘贴条目或选择文件',
  'pages.qualityAssurance.uploadRemoveRow': '移除',
  'pages.qualityAssurance.uploadAddRow': '新增一行',
  'pages.qualityAssurance.uploadSuccess': '检查表已保存',
  'pages.qualityAssurance.uploadFailed': '检查表保存失败',
  'pages.qualityAssurance.deleteChecklistConfirm': '确认删除整套检查表？',
  'pages.qualityAssurance.deleteChecklistConfirmContent':
    '已记录的检查结果会保留在问题清单中，但会解除与检查条目的绑定。',
  'pages.qualityAssurance.deleteChecklistSuccess': '检查表已删除',

  // 质量保证 - AI 预检（P2）
  'pages.qualityAssurance.aiPrecheck': 'AI 预检',
  'pages.qualityAssurance.aiPrecheckTitle': 'AI 预检：文档 vs 检查表',
  'pages.qualityAssurance.aiPrecheckNotice':
    'AI 只负责挑出可疑项，不会判定「符合」；结论与原文证据都请人工核对后自行判定。',
  'pages.qualityAssurance.aiPrecheckDocument': '被检查文档',
  'pages.qualityAssurance.aiPrecheckSelectDocument': '请选择本过程的工作产品或策划类文档',
  'pages.qualityAssurance.aiPrecheckScope': '预检范围',
  'pages.qualityAssurance.aiPrecheckScopeAll': '全部条目',
  'pages.qualityAssurance.aiPrecheckScopePending': '仅未判定条目',
  'pages.qualityAssurance.aiPrecheckRun': '开始预检',
  'pages.qualityAssurance.aiPrecheckRerun': '重新预检',
  'pages.qualityAssurance.aiPrecheckRunning': '正在分批预检，请稍候…',
  'pages.qualityAssurance.aiPrecheckResultCount': 'AI 提出 {{count}} 处疑点',
  'pages.qualityAssurance.aiPrecheckTruncated': '文档过长，已按前部内容预检',
  'pages.qualityAssurance.aiPrecheckEmpty':
    'AI 未提出疑点。这只表示没有发现可报告的问题，不等于判定「符合」。',
  'pages.qualityAssurance.aiPrecheckEvidenceLabel': '原文证据',
  'pages.qualityAssurance.aiPrecheckEvidenceEmpty': '未给出原文证据',
  'pages.qualityAssurance.aiPrecheckReasonLabel': '疑点说明',
  'pages.qualityAssurance.aiPrecheckApply': '写入建议',
  'pages.qualityAssurance.aiPrecheckApplyCount': '写入建议（{{count}}）',
  'pages.qualityAssurance.aiPrecheckApplied': '已写入 {{count}} 条 AI 建议',
  'pages.qualityAssurance.aiPrecheckApplyHint':
    '写入后只是「建议」：检查结果仍为空，等人工核对后判定。',
  'pages.qualityAssurance.aiPrecheckFailed': 'AI 预检失败',
  'pages.qualityAssurance.aiPrecheckNoSelection': '请至少勾选一条疑点',
  'pages.qualityAssurance.aiPrecheckSummary': 'AI 疑点 {{count}}',
  'pages.qualityAssurance.aiVerdictSuspect': '疑似不满足',
  'pages.qualityAssurance.aiVerdictUncertain': '无法判断',
  'pages.qualityAssurance.aiIgnore': '忽略 AI 建议',
  'pages.qualityAssurance.aiIgnoreConfirm': '确认忽略该条目的 AI 建议？',
  'pages.qualityAssurance.aiIgnoreContent': '只清除 AI 建议，人工判定不受影响。',
  'pages.qualityAssurance.aiIgnored': '已忽略 AI 建议',
  'pages.qualityAssurance.recordAiNotice': 'AI 预检提示：{{verdict}}',
  'pages.qualityAssurance.recordAiEvidenceHint': '已带入 AI 原文证据，请核对后再采用',
  'pages.qualityAssurance.recordAiKeepHint': 'AI 建议会作为追溯记录保留，不影响本次判定。',

  // 质量保证 - 质量报告（SUP.1 原「其他」页签改造）
  'pages.qualityReport.tab': '质量报告',
  'pages.qualityReport.title': '质量保证报告',
  'pages.qualityReport.project': '项目',
  'pages.qualityReport.generatedAt': '生成时间',
  'pages.qualityReport.generatedBy': '生成人',
  'pages.qualityReport.scope': '统计范围',
  'pages.qualityReport.scopeValue': '{{total}} 个已开启过程',
  'pages.qualityReport.refresh': '刷新',
  'pages.qualityReport.export': '导出报告',
  'pages.qualityReport.exportWord': '导出 Word 报告',
  'pages.qualityReport.exportExcel': '导出 Excel',
  'pages.qualityReport.empty': '暂无质量报告数据',
  'pages.qualityReport.exportSuccess': '报告已导出',
  'pages.qualityReport.exportFailed': '报告导出失败',
  'pages.qualityReport.detailLoadFailed': '加载过程检查明细失败',
  'pages.qualityReport.filePrefix': '质量保证报告',

  // 质量报告 - 指标卡
  'pages.qualityReport.kpiTitle': '指标',
  'pages.qualityReport.kpiValue': '数值',
  'pages.qualityReport.kpiCoverage': '过程覆盖率',
  'pages.qualityReport.coveredRatio': '{{covered}}/{{total}} 过程',
  'pages.qualityReport.kpiItems': '检查条目',
  'pages.qualityReport.unitItems': '条',
  'pages.qualityReport.kpiCompletion': '检查完成率',
  'pages.qualityReport.kpiNonconform': '不符合项',
  'pages.qualityReport.kpiNonconformRate': '不符合率 {{rate}}%',
  'pages.qualityReport.kpiProblemClose': '问题关闭率',
  'pages.qualityReport.kpiOverdue': '逾期问题',
  'pages.qualityReport.kpiOverdueHint': '需关注',
  'pages.qualityReport.kpiRechecked': '已复检条目',
  'pages.qualityReport.kpiAiSuspect': 'AI 疑点',

  // 质量报告 - 图表
  'pages.qualityReport.chartCompletion': '各过程检查完成率',
  'pages.qualityReport.chartVerdict': '检查结论分布',
  'pages.qualityReport.chartSeverity': '不符合项严重度分布',

  // 质量报告 - 检查结论
  'pages.qualityReport.verdictConform': '符合',
  'pages.qualityReport.verdictNonconform': '不符合',
  'pages.qualityReport.verdictNotApplicable': '不适用',
  'pages.qualityReport.verdictPending': '待检查',

  // 质量报告 - 过程汇总表
  'pages.qualityReport.sectionProcesses': '各过程检查执行汇总',
  'pages.qualityReport.detailHint': '点击某一行可查看该过程的检查明细',
  'pages.qualityReport.colProcess': '过程',
  'pages.qualityReport.colOwner': '负责人',
  'pages.qualityReport.colChecklist': '检查表',
  'pages.qualityReport.noChecklist': '未上传检查表',
  'pages.qualityReport.colItems': '条目',
  'pages.qualityReport.colChecked': '已检查',
  'pages.qualityReport.colCompletion': '完成率',
  'pages.qualityReport.colConform': '符合',
  'pages.qualityReport.colNonconform': '不符合',
  'pages.qualityReport.colNotApplicable': '不适用',
  'pages.qualityReport.colPending': '待检查',
  'pages.qualityReport.colNonconformRate': '不符合率',
  'pages.qualityReport.colProblemOpen': '未关闭问题',
  'pages.qualityReport.colProblemOverdue': '逾期问题',
  'pages.qualityReport.colArchive': '外部检查表',
  'pages.qualityReport.totalRow': '合计',

  // 质量报告 - 问题明细
  'pages.qualityReport.problemTitle': '不符合项 / 问题明细',
  'pages.qualityReport.problemEmpty': '暂无不符合项',
  'pages.qualityReport.filterProcess': '按过程筛选',
  'pages.qualityReport.filterStatus': '按状态筛选',
  'pages.qualityReport.colCode': '编号',
  'pages.qualityReport.colDocument': '文档',
  'pages.qualityReport.colSubject': '主题',
  'pages.qualityReport.colDescription': '问题描述',
  'pages.qualityReport.colSeverity': '严重度',
  'pages.qualityReport.colPriority': '优先级',
  'pages.qualityReport.colStatus': '状态',
  'pages.qualityReport.colCreatedAt': '发现时间',
  'pages.qualityReport.colPlanned': '计划完成',
  'pages.qualityReport.overdueYes': '逾期',

  // 质量报告 - 过程明细抽屉
  'pages.qualityReport.detailTitle': '{{process}} · 检查明细',
  'pages.qualityReport.detailSummary': '条目 {{total}} · 已检查 {{checked}} · 完成率 {{rate}}%',
  'pages.qualityReport.detailEmpty': '该过程尚未上传质量检查表',
  'pages.qualityReport.detailColSeq': '序号',
  'pages.qualityReport.detailColClause': '条款',
  'pages.qualityReport.detailColText': '检查条目',
  'pages.qualityReport.detailColVerdict': '检查结果',
  'pages.qualityReport.detailColEvidence': '证据',
  'pages.qualityReport.detailColProblem': '派生问题',

  // 质量报告 - 导出工作表
  'pages.qualityReport.colVersion': '版本',
  'pages.qualityReport.colFile': '文件名',
  'pages.qualityReport.sheetOverview': '概览',
  'pages.qualityReport.sheetProcesses': '过程汇总',
  'pages.qualityReport.sheetProblems': '问题明细',
  'pages.qualityReport.sheetArchives': '外部检查表',

  // 回收站
  'pages.recycleBin.documentsTab': '文档',
  'pages.recycleBin.attachmentsTab': '附件',
  'pages.recycleBin.documentTitle': '文档名称',
  'pages.recycleBin.documentCode': '文档 ID',
  'pages.recycleBin.version': '版本',
  'pages.recycleBin.process': '过程',
  'pages.recycleBin.fileName': '附件名称',
  'pages.recycleBin.deletedBy': '删除人',
  'pages.recycleBin.deletedAt': '删除时间',
  'pages.recycleBin.actions': '操作',
  'pages.recycleBin.restore': '恢复',
  'pages.recycleBin.purge': '彻底删除',
  'pages.recycleBin.cancel': '取消',
  'pages.recycleBin.search': '搜索',
  'pages.recycleBin.searchDocuments': '搜索文档名称或文档 ID',
  'pages.recycleBin.searchAttachments': '搜索附件名称',
  'pages.recycleBin.restoreSuccess': '恢复成功',
  'pages.recycleBin.restoreFailed': '恢复失败',
  'pages.recycleBin.purgeSuccess': '已彻底删除',
  'pages.recycleBin.purgeFailed': '彻底删除失败',
  'pages.recycleBin.loadFailed': '获取回收站列表失败',
  'pages.recycleBin.confirmPurge': '确认彻底删除',
  'pages.recycleBin.confirmPurgeDocument': '确定要彻底删除文档 {{title}} 吗？此操作不可恢复。',
  'pages.recycleBin.confirmPurgeAttachment': '确定要彻底删除附件 {{name}} 吗？此操作不可恢复。',
  'pages.docEditor.confirmDeleteAttachment': '确认删除附件',
  'pages.docEditor.confirmDeleteAttachmentContent':
    '确定要删除附件「{{name}}」吗？删除后可在回收站恢复。',

  // ---- HARA：危害分析与风险评估 ----
  'pages.workProducts.hara': 'HARA 危害分析',

  'pages.hara.tabItem': 'Item 定义',
  'pages.hara.tabFunctions': '功能清单',
  'pages.hara.tabFailureModes': '失效模式',
  'pages.hara.tabScenarios': '运行场景',
  'pages.hara.tabHazards': 'HARA 主表',
  'pages.hara.tabGoals': '安全目标',

  'pages.hara.statHazard': '危害事件',
  'pages.hara.statGoal': '安全目标',
  'pages.hara.statMaxAsil': '最高 ASIL',
  'pages.hara.asilDistribution': 'ASIL 分布',

  'pages.hara.save': '保存',
  'pages.hara.cancel': '取消',
  'pages.hara.delete': '删除',
  'pages.hara.export': '导出 Excel',
  'pages.hara.reload': '重新加载',
  'pages.hara.reset': '清空',
  'pages.hara.resetConfirm': '确定清空全部 HARA 数据？此操作不可恢复。',
  'pages.hara.unsaved': '有未保存的修改',
  'pages.hara.saved': '已保存',
  'pages.hara.saveFailed': '保存失败',
  'pages.hara.loadFailed': '加载 HARA 数据失败',
  'pages.hara.required': '必填',

  'pages.hara.colIndex': '序号',
  'pages.hara.colCode': '编号',
  'pages.hara.colName': '名称',
  'pages.hara.colDescription': '说明',
  // 各表正文列各有其名：功能清单 / 失效模式 / FSR 各用专用键，运行场景仍用「说明」。
  // 共用 colDescription 会让改一处多张表一起变，所以这里分开。
  'pages.hara.functionDescription': '功能描述',
  'pages.hara.failureModeName': '失效模式',
  'pages.hara.colRemark': '备注',
  'pages.hara.colAction': '操作',
  'pages.hara.dimensionCount': '共 {{count}} 条',
  'pages.hara.emptyDimension': '还没有条目，点上方按钮新增，或直接在表格里粘贴',
  'pages.hara.sheetHint': '点击单元格编辑 · Enter 下移 · Tab 右移 · Ctrl+V 批量粘贴',
  'pages.hara.deleteUsedTitle': '该条目已被危害主表引用',
  'pages.hara.deleteUsedContent':
    '有 {{count}} 条危害事件引用了它，删除后这些引用会变成失效项。确定删除？',
  'pages.hara.hazardDeleteConfirmTitle': '删除这条危害事件？',
  'pages.hara.hazardDeleteConfirmContent':
    '「{{label}}」删除后无法撤销，安全目标将在下次保存时按剩余危害重算。',
  'pages.hara.hazardDeleteConfirmContentNoLabel':
    '删除后无法撤销，安全目标将在下次保存时按剩余危害重算。',
  'pages.hara.pasteDone': '已粘贴 {{count}} 个单元格',
  'pages.hara.pasteBadExposure': '有 {{count}} 个暴露概率不是 E0-E4，已忽略',

  'pages.hara.batchImport': '批量导入',
  'pages.hara.importSourcePaste': '粘贴文本',
  'pages.hara.importSourceFile': '上传文件',
  'pages.hara.importPasteHint': '从 Excel 复制多行后粘贴到这里（首行可以是表头）',
  'pages.hara.importFileHint': '点击或拖拽上传 xlsx / csv 文件，只读取第一个工作表',
  'pages.hara.importHasHeader': '首行是表头',
  'pages.hara.importParsedRows': '解析到 {{count}} 行',
  'pages.hara.importMapping': '列对应',
  'pages.hara.importColumn': '第 {{n}} 列',
  'pages.hara.importIgnore': '不导入',
  'pages.hara.importPreview': '预览',
  'pages.hara.importPreviewTruncated': '仅显示前 50 行',
  'pages.hara.importWillAdd': '将导入 {{count}} 条',
  'pages.hara.importNoRows': '没有可导入的行，检查列对应是否正确',
  'pages.hara.importModeAppend': '追加到现有条目后',
  'pages.hara.importModeReplace': '替换全部现有条目',
  'pages.hara.importConfirm': '导入',
  'pages.hara.importDone': '已导入 {{count}} 条',
  'pages.hara.importReadFailed': '文件读取失败',
  'pages.hara.importIssueEmptyName': '有 {{count}} 行缺少名称，导入后在下拉里选不到，建议补上',
  'pages.hara.importIssueDuplicate': '有 {{count}} 行与现有条目或彼此重名',
  'pages.hara.importIssueExposure': '有 {{count}} 个暴露概率不是 E0-E4，已忽略',
  'pages.hara.importIssueNote': '提示只作提醒，不会阻止导入；确认无误后点「导入」',
  'pages.hara.importWaiting': '粘贴内容或上传文件后，这里会显示列对应与预览',

  'pages.hara.addFunction': '新增功能',
  'pages.hara.addFailureMode': '新增失效模式',
  'pages.hara.addScenario': '新增场景',
  'pages.hara.addHazard': '新增危害事件',
  'pages.hara.hazardCount': '共 {{count}} 条危害事件',
  'pages.hara.hazardFnDerived': '功能由所选失效模式派生，不可手改',
  'pages.hara.hazardFnNeedFm': '先选失效模式',
  'pages.hara.hazardFnNoFunction': '该失效模式未归属功能',
  'pages.hara.hazardFnMismatch': '存储的功能引用与失效模式的归属不一致，多半是失效模式选错了',
  'pages.hara.hazardFnMismatchDetail': '存储 {{stored}} / 应为 {{derived}}',
  'pages.hara.hazardFnResyncHint':
    '把行内存储的功能引用改成该失效模式的归属（只改危害行，不会反向改失效模式）',
  'pages.hara.hazardFnResync': '修正功能引用（{{count}} 条）',
  'pages.hara.hazardFnResynced': '已修正 {{count}} 条功能引用',
  'pages.hara.locateInCross': '危害识别表',
  'pages.hara.locateInCrossNeedRefs': '先选好失效模式与运行场景，才能在危害识别表中定位',
  'pages.hara.crossJumpHint': '点击跳回主表对应行（ASIL / S-E-C 在主表里改）',
  'pages.hara.emptyHazard': '还没有危害事件',
  'pages.hara.emptyGoals': '还没有安全目标：主表里评出 QM 以外的 ASIL 后会自动生成',

  'pages.hara.colFailureCategory': '失效类别',
  'pages.hara.failureCategoryHint': '如：非预期激活',
  'pages.hara.langHint': 'zh',
  'pages.hara.categoryMigrated':
    '有 {{count}} 条失效模式的类别已按 FMEA 七类重新归类，下次保存后生效',
  'pages.hara.droppedBlankRows': '已跳过 {{count}} 条没有内容的空行（没有保存它们）',
  'pages.hara.conflictTitle': '数据已被其他页面更新',
  'pages.hara.conflictContent':
    '服务端这份 HARA 在你打开页面之后又被保存过。为避免覆盖别人的修改，请先重新加载最新数据，再重做本次改动。',
  'pages.hara.conflictReload': '重新加载最新数据',
  'pages.hara.conflictKeep': '保留我的改动',
  'pages.hara.resetConfirmContent':
    '功能 {{functions}} 条、失效模式 {{modes}} 条、危害事件 {{hazards}} 条会被全部删除。清空前的版本会自动留档，需要找回请让管理员从后台历史里恢复。',
  'pages.hara.fmGroup.omission': 'FM1 功能未提供 Omission',
  'pages.hara.fmGroup.commission': 'FM2 非预期执行 Commission',
  'pages.hara.fmGroup.timing': 'FM3 时序不正确 Timing',
  'pages.hara.fmGroup.value': 'FM4 输出值不正确 Value',
  'pages.hara.cat.no_function': '功能丧失',
  'pages.hara.cat.no_function.desc': '完全无法操作或突然失效，需要时一点功能都没有提供',
  'pages.hara.cat.no_function.example': '无法施加驻车夹紧力',
  'pages.hara.cat.degraded': '功能退化',
  'pages.hara.cat.degraded.desc': '功能仍在提供，但性能随时间逐步损失',
  'pages.hara.cat.degraded.example': '长下坡持续制动后夹紧力逐步衰减',
  'pages.hara.cat.intermittent': '功能间歇',
  'pages.hara.cat.intermittent.desc': '操作时有时无，随机地开始、停止、再开始',
  'pages.hara.cat.intermittent.example': '驻车夹紧力时有时无，反复自行夹紧与释放',
  'pages.hara.cat.partial': '部分功能丧失',
  'pages.hara.cat.partial.desc': '功能被部分实现，性能低于需求',
  'pages.hara.cat.partial.example': '仅单侧执行器夹紧，夹紧力约为设计值的一半',
  'pages.hara.cat.unintended': '非预期功能',
  'pages.hara.cat.unintended.desc':
    '不需要该功能时它出现：错误的时间操作、意外的作用方向、左右不等的性能，以及激活后卡滞不退',
  'pages.hara.cat.unintended.example': '高速行驶中非预期夹紧；释放指令反而导致夹紧',
  'pages.hara.cat.out_of_range': '功能超范围',
  'pages.hara.cat.out_of_range.desc': '输出的幅值超出可接受的上限或下限',
  'pages.hara.cat.out_of_range.example': '夹紧力超过上限导致后轮抱死；低于下限导致坡道溜车',
  'pages.hara.cat.delayed': '功能延迟',
  'pages.hara.cat.delayed.desc':
    '在非预期的时间间隔后才发生：响应过晚、响应过早、提前退出都归这一类',
  'pages.hara.cat.delayed.example': '收到释放指令 500 ms 后才动作；车辆未停稳即提前释放',
  'pages.hara.colCondition': '运行条件',
  'pages.hara.conditionHint': '如：高速行驶、雨天、满载',
  'pages.hara.colRoadType': '道路类型',
  'pages.hara.roadTypeHint': '如：高速公路、城市道路、地库坡道',
  'pages.hara.colTrafficDensity': '交通密度',
  'pages.hara.trafficDensityHint': '如：稀疏、正常、拥堵',
  'pages.hara.colWeather': '天气·光照',
  'pages.hara.weatherHint': '如：白天晴、夜间、雨、雾',
  'pages.hara.colEgoState': '自车·驾驶员状态',
  'pages.hara.egoStateHint': '如：高速匀速；注意力集中',
  'pages.hara.colOperatingMode': '运行模式',
  'pages.hara.operatingModeHint': '如：行驶、驻车、坡道起步、故障降级',
  'pages.hara.colExposureBasis': '定级依据',
  'pages.hara.exposureBasisHint': '按 ISO 26262-3 Annex B 选口径',
  'pages.hara.colSeverityBasis': 'S 判据锚点',
  'pages.hara.colExposureBasisHazard': 'E 定级依据',
  'pages.hara.colControllabilityBasis': 'C 判据锚点',
  'pages.hara.colTargetMarket': '目标市场',
  'pages.hara.targetMarketHint': '如：中国、欧盟',
  'pages.hara.colSource': '来源依据',
  'pages.hara.sourceHint': '如：车队数据、事故统计、专家假设',
  'pages.hara.colExposureHint': '建议暴露概率',
  'pages.hara.exposureSuggest': '建议 {{level}}',
  'pages.hara.exposureBasis.duration_gt10': '时长 >10%',
  'pages.hara.exposureBasis.duration_1to10': '时长 1%–10%',
  'pages.hara.exposureBasis.duration_lt1': '时长 <1%',
  'pages.hara.exposureBasis.frequency_almostEvery': '频次 几乎每次',
  'pages.hara.exposureBasis.frequency_monthly': '频次 ≥1 次/月',
  'pages.hara.exposureBasis.frequency_fewPerYear': '频次 数次/年',
  'pages.hara.exposureBasis.frequency_lessThanYearly': '频次 <1 次/年',
  'pages.hara.groupIdentity': '场景标识',
  'pages.hara.groupElements': '场景要素（运行条件 / 运行模式）',
  'pages.hara.groupExposure': '暴露定级',
  'pages.hara.groupTrace': '溯源',
  'pages.hara.viewBasic': '精简视图',
  'pages.hara.viewFull': '完整视图',
  'pages.hara.viewToggleHint': '精简视图只看核心字段；完整视图展开场景要素与定级依据',
  'pages.hara.pasteBadBasis': '有 {{count}} 个定级依据不在 Annex B 档位内，已忽略',
  'pages.hara.importIssueBasis': '有 {{count}} 个定级依据不在 Annex B 档位内，已忽略',
  'pages.hara.fillElements': '按描述补全要素',
  'pages.hara.fillElementsHint':
    '按名称/说明/运行条件里的描述，用受控词表自动补全空的要素列。只补空格，已有值不动。',
  'pages.hara.undoFillElements': '撤销补全',
  'pages.hara.tableEmptyActionHint': '表内还没有条目：先「新增」「批量导入」，或点「AI 生成场景」',
  'pages.hara.fillElementsDone': '已补全 {{cells}} 个单元格，涉及 {{rows}} 条场景（记得保存）',
  'pages.hara.fillElementsNone': '没有可补的要素：描述里认不出新值，或各列都已经填好了',
  'pages.hara.fillElementsUndone': '已撤销补全',
  'pages.hara.elementsGapCount': '{{count}} 条要素不全',
  'pages.hara.elementsGapList': '以下场景还有要素未填（点「按描述补全要素」可自动补）',

  // ---- HARA：运行场景的 AI（生成 / 合规体检，ISO 26262-3 6.4.2） ----
  'pages.hara.aiScenGenerate': 'AI 生成场景',
  'pages.hara.aiScenReview': 'AI 合规体检',
  'pages.hara.aiScenTitleGenerate': 'AI 生成运行场景',
  'pages.hara.aiScenTitleReview': 'AI 场景合规体检',
  'pages.hara.aiScenContext': '依据 Item 定义生成 · 当前已有 {{count}} 条场景',
  'pages.hara.aiScenNoE':
    'AI 不会给出暴露等级 E：按 ISO 26262-3 Annex B，E 必须基于目标市场代表性数据（出现频次或时长占比）评定，这份数据不在 Item 定义里。请由工程师依据目标市场数据判定并签字。',
  'pages.hara.aiScenRequirements': '补充要求，可留空（留空即按 Item 定义与通用知识生成）',
  'pages.hara.aiScenRequirementsReview': '补充要求，可留空（例如：重点看可预见误用和系统间交互）',
  'pages.hara.aiScenSubmitGenerate': '生成候选场景',
  'pages.hara.aiScenSubmitReview': '开始体检',
  'pages.hara.aiScenRerun': '重新生成',
  'pages.hara.aiScenFindings': '体检意见',
  'pages.hara.aiScenNoFindings': '没有发现问题',
  'pages.hara.aiScenCandidates': '候选场景（勾选后添加到清单末尾）',
  'pages.hara.aiScenExcluded': 'AI 判定不在本 Item 范围内',
  'pages.hara.aiScenBasis': '依据 Item 定义',
  'pages.hara.aiScenAdd': '添加勾选的 {{count}} 条',
  'pages.hara.aiScenAdded': '已添加 {{count}} 条场景，记得保存',
  'pages.hara.aiScenNothingAdded': '没有新增场景：勾选的都已在清单里',
  'pages.hara.aiScenSkipped': '跳过 {{count}} 条（清单里已有同名场景）',
  'pages.hara.aiScenEmpty': 'AI 没有给出可用结果，补充要求后重试',
  'pages.hara.aiScenFailed': 'AI 调用失败，请稍后重试',
  'pages.hara.aiScenNoItems': '没有生成候选场景',
  'pages.hara.aiScenReviewNote':
    '以上只是意见，不会改动你的场景清单；需要新增场景请回到「AI 生成运行场景」。',
  'pages.hara.aiScenType.missing_misuse': '缺误用场景',
  'pages.hara.aiScenType.missing_interaction': '缺系统交互',
  'pages.hara.aiScenType.mode_uncovered': '运行模式未覆盖',
  'pages.hara.aiScenType.missing_elements': '要素缺失',
  'pages.hara.aiScenType.missing_exposure_basis': '缺定级依据',
  'pages.hara.aiScenType.exposure_without_market': '有无市场数据',
  'pages.hara.aiScenType.duplicate': '重复',
  'pages.hara.aiScenType.granularity': '粒度',
  'pages.hara.aiScenType.other': '其他',

  // ---- HARA：按功能做失效分析（引导词） ----
  'pages.hara.functionSearch': '搜索编号或名称',
  'pages.hara.allFailureModes': '全部失效模式',
  'pages.hara.unassignedFailureModes': '未归属功能',
  'pages.hara.failureCoverageHint': '已分析 {{done}}/{{total}} 个功能',
  'pages.hara.categoryCoverage': '已覆盖 {{done}}/{{total}} 个引导词',
  'pages.hara.guideView': '引导视图',
  'pages.hara.sheetView': '清单视图',
  'pages.hara.guideViewHint':
    '逐个引导词过一遍，确认不适用也要标记——评审会问「这一格是忘了还是判断过」',
  'pages.hara.failureDerive': '按类别生成草稿',
  'pages.hara.guideKeyboardHint':
    '写完按回车跳到下一个待分析类别，Tab 跳到下一条；判断不适用请点左侧方框并填理由',
  'pages.hara.focusNext': '定位到下一个待分析',
  'pages.hara.checkNaTip': '点一下标为不适用（需填理由）',
  'pages.hara.checkNaUndoTip': '点一下恢复适用',
  'pages.hara.checkNaDisabledTip': '该类别已有失效模式，先删除条目才能标为不适用',
  'pages.hara.naReasonTitle': '标为「不适用」',
  'pages.hara.naReasonHint': '理由会写进导出的失效分析矩阵，评审据此判断「是忘了还是判断过」',
  'pages.hara.naReasonPlaceholder': '如：纯开关量输出，不存在幅值超范围',
  'pages.hara.copyFromPrev': '套用上一功能',
  'pages.hara.copyFromPrevTip': '把 {{code}} 已写的失效模式整套复制过来，再改成这个功能的具体失效',
  'pages.hara.copyFromPrevNone': '没有可复制的上一个功能',
  'pages.hara.copyFromPrevDone': '已复制 {{count}} 条，跳过本功能已分析的 {{skipped}} 个类别',
  'pages.hara.copyFromPrevNothing': '{{code}} 的失效模式这里都已分析，无需复制',
  'pages.hara.nextUnfinished': '下一个未分析',
  'pages.hara.nextUnfinishedTip': '跳到下一个还没做完的功能',
  'pages.hara.nextUnfinishedNone': '所有功能都已分析完',
  'pages.hara.allCategoriesDone': '{{code}} 的 {{total}} 个失效类别已全部处理',
  'pages.hara.confirm': '确定',
  'pages.hara.failureDeriveTip':
    '对尚未分析的引导词各生成一条失效模式草稿，已分析和已排除的会自动跳过',
  'pages.hara.failureDeriveDone': '已生成 {{count}} 条草稿，跳过已处理/已排除的 {{skipped}} 个类别',
  'pages.hara.failureDeriveNothing': '{{total}} 个引导词都已处理，无需再生成',
  'pages.hara.failureAnalyzed': '已分析 {{count}} 条',
  'pages.hara.failurePending': '待分析',
  'pages.hara.failureNa': '不适用',
  'pages.hara.failureNaMark': '标为不适用',
  'pages.hara.failureNaUndo': '恢复适用',
  'pages.hara.failureExample': '示例',
  'pages.hara.failureModeNameHint': '整车级可观察的失效，如：无法施加夹紧力',
  'pages.hara.expandAll': '全部展开',
  'pages.hara.collapseAll': '全部收起',
  'pages.hara.unassignedHint':
    '这些失效模式还没有所属功能（多为历史数据），归入功能后才会纳入引导词覆盖统计',
  'pages.hara.pickFunction': '归入功能…',
  'pages.hara.emptyFunctionsForFailure': '先在「功能清单」里录入功能，再回来逐个做失效分析',
  'pages.hara.sheetFailureMatrix': '失效分析矩阵',
  'pages.hara.colUnclassified': '未归类',
  'pages.hara.sheetExcludedHazards': '已判无危害',
  'pages.hara.colExcludeReason': '判定理由',

  'pages.hara.colHazardId': '危害编号',
  'pages.hara.dimFunction': '功能',
  'pages.hara.dimFailureMode': '失效模式',
  'pages.hara.dimScenario': '运行场景',
  'pages.hara.colHazard': '危害描述',
  'pages.hara.hazardHint': '该失效在此场景下造成的整车级危害',
  'pages.hara.colHazardGroup': '危害归类',
  'pages.hara.hazardGroupHint': '同一归类的危害事件会合并成一个安全目标，并取最高 ASIL',
  'pages.hara.hazardGroupPlaceholder': '如：非预期制动',
  'pages.hara.colSafeState': '安全状态',
  'pages.hara.goalSafeStateHint':
    '必填。每条安全目标都要指明「如何进入或维持安全状态」（ISO 26262-3:2018 7.4.2.5）。',
  'pages.hara.goalSafeStatePlaceholder': '如：切断驱动扭矩并进入受控停车',
  'pages.hara.goalSafeStateLegacy': '沿用主表旧值，建议复核后重写',
  'pages.hara.goalFttiHint':
    '选填。仅当该时间间隔影响 ASIL 判定时才需要写在这里（ISO 26262-3:2018 6.4.4.3 NOTE）；正式确定位置是功能安全概念的 7.4.2.3 / 7.4.2.4。',
  'pages.hara.goalFttiPlaceholder': '如：100 ms',
  'pages.hara.coverageTitle': '覆盖性检查（ISO 26262-3:2018 6.4.6.1）',
  'pages.hara.coverageUncovered':
    '有 {{count}} 条已评出 ASIL 的危害事件未归入任何安全目标：{{ids}}',
  'pages.hara.coverageMissingSafeState': '有 {{count}} 条安全目标还没有安全状态：{{ids}}',
  'pages.hara.colSourceHazards': '来源危害事件',

  'pages.hara.crossOpen': '完善危害识别表',
  'pages.hara.crossTitle': '危害识别表',
  'pages.hara.crossSubtitle': '失效模式 × 运行场景',
  'pages.hara.crossMissing': '未判定组合 {{missing}} / {{total}} 格',
  'pages.hara.crossComplete': '{{total}} 格组合已全部判定',
  'pages.hara.crossOrphan': '孤立引用 {{count}} 条',
  'pages.hara.crossSummary':
    '共 {{total}} 格组合：已判定 {{done}}（有危害 {{hazard}} / 无危害 {{excluded}}），未判定 {{missing}}',
  'pages.hara.crossColFunction': '功能',
  'pages.hara.crossColFailureMode': '失效模式',
  'pages.hara.crossCellNone': '未判定',
  'pages.hara.crossNotReady': '先在「失效模式」和「运行场景」里录入带编号的条目，才能做危害识别',
  'pages.hara.crossTip':
    '行 = 失效模式，列 = 运行场景。点空格可直接生成危害事件，或判定「不构成危害」（理由可留空）—— 让缺口能被一条条关掉。',
  'pages.hara.crossTipReadOnly':
    '行 = 失效模式，列 = 运行场景。空格代表这个组合还没分析过 —— 评审最容易追问的就是这些格子。',
  'pages.hara.crossCreate': '生成危害事件',
  'pages.hara.crossExclude': '判定无危害',
  'pages.hara.crossExcludeUndo': '撤销判定',
  'pages.hara.crossExcludedShort': '无危害',
  'pages.hara.crossExcludeNoReason': '（未填理由）',
  'pages.hara.crossExcludeTitle': '判定「不构成危害」',
  'pages.hara.crossExcludeReasonLabel': '理由（可空）',
  'pages.hara.crossExcludeReasonHint':
    '例如：该场景下失效不会造成人员伤害。评审会问「这一格是忘了还是判断过」，写一句更稳妥。',
  'pages.hara.crossOnlyOpen': '只看未判定',
  'pages.hara.crossFilterFunction': '按功能筛选',
  'pages.hara.crossGroupProgress': '该功能下已判定 / 总组合数（点上方箭头折叠）',
  'pages.hara.crossCollapsedHint': '已折叠 {{count}} 个失效模式',
  'pages.hara.crossNoMode': '未填运行模式',
  'pages.hara.crossAdviceTag': '建议分析',
  'pages.hara.crossAdviceSameFm': '同一失效模式在其他场景已判定出危害',
  'pages.hara.crossAdviceSameSc': '同一场景下其他失效模式已判定出危害',
  'pages.hara.crossFocusHint': '点场景列表头可只看这一列',
  'pages.hara.crossUnfilled': '未填',
  'pages.hara.crossScenarioElements': '要素 {{filled}} / {{total}}',
  'pages.hara.crossScenarioGap': '缺「{{fields}}」—— 要素没填全就逐格判定，等于用不完整的前提定级',
  'pages.hara.crossCardNoDesc': '（该失效模式未写描述）',
  'pages.hara.crossCardNoElements': '要素未填',
  'pages.hara.crossCardHazardLabel': '该失效在该场景下造成的整车级危害',
  'pages.hara.crossCardHazardHint': '例如：湿滑路面制动距离延长，可能与前车碰撞。',
  'pages.hara.crossCardGradeHint': 'S / E / C 生成后在主表里判定，这里只描述危害本身。',
  'pages.hara.crossCardRefHint': '生成只预填功能 / 失效模式 / 场景三条引用',
  'pages.hara.crossFocusTag': '聚焦中',
  'pages.hara.crossPrevScenario': '上一个场景',
  'pages.hara.crossNextScenario': '下一个场景',
  'pages.hara.crossScenarioPos': '第 {{index}} / {{total}} 个场景',
  'pages.hara.crossScenarioProgress': '已判 {{done}} / {{total}} 格',
  'pages.hara.crossShowAllScenarios': '显示全部场景',
  'pages.hara.exposureHintApply': '该场景给出的建议值，点击采纳（当前 E 由你判定）',

  'pages.hara.aiTriage': 'AI 分诊',
  'pages.hara.aiTriageCollapse': '收起分诊',
  'pages.hara.aiTriageTitle': 'AI 格子分诊',
  'pages.hara.aiTriageHint': '从还没判定的组合里挑出最值得先看的，只排序、不判定',
  'pages.hara.aiTriageScopeFocus': '当前聚焦场景',
  'pages.hara.aiTriageScopeFunction': '指定功能',
  'pages.hara.aiTriageScopeAll': '全部未判定',
  'pages.hara.aiTriagePickFunction': '选择功能',
  'pages.hara.aiTriageRequirements': '补充要求，可留空（如：重点关注误用与系统交互场景）',
  'pages.hara.aiTriageScopeInfo': '本范围 {{combos}} 格，其中未判定 {{open}} 格',
  'pages.hara.aiTriageNothingOpen': '这个范围里已经全部判定完了',
  'pages.hara.aiTriageRun': '开始分诊',
  'pages.hara.aiTriageRerun': '重新分诊',
  'pages.hara.aiTriageNote':
    'AI 只做识别与排序，不会给出 S / E / C 或 ASIL（暴露定级必须基于目标市场代表性数据）；结论也不会自动写进表格。',
  'pages.hara.aiTriageNoResult': 'AI 没有指出需要优先分析的组合，补充要求后重试',
  'pages.hara.aiTriageNoCandidates': '当前范围里没有可参与分诊的失效模式或运行场景',
  'pages.hara.aiTriageFailed': 'AI 调用失败，请稍后重试',
  'pages.hara.aiTriageCount': 'AI 建议优先分析 {{count}} 格，最值得先看的排前面',
  'pages.hara.aiTriageVerdictHazard': '很可能构成危害',
  'pages.hara.aiTriageVerdictUncertain': '存疑待判',
  'pages.hara.aiTriageDraftLabel': '描述草稿',
  'pages.hara.aiTriageGoJudge': '去判定',
  'pages.hara.aiHazardDraft': 'AI 起草描述',
  'pages.hara.aiHazardDraftHint':
    '按失效模式与场景条件起草一句整车级危害描述（不含定级），可自由修改；不会自动填入任何字段',
  'pages.hara.aiHazardDraftFailed': 'AI 起草失败，请稍后重试',

  /*
    S / E / C 判据全文 —— 前端唯一真源。
    与后端 app/utils/hara.py 的 SEVERITY_CRITERIA / EXPOSURE_CRITERIA /
    CONTROLLABILITY_CRITERIA **逐字一致**（由 hara_criteria_check.py 锁死）。
    刻意不带「S1」这类前缀：等级由界面自己拼，摘要由括号前那段派生
    （见 utils/hara/criteria.ts），不需要另存一份短文案。
  */
  'pages.hara.criteria.severity.S0': '无伤害（无人员伤害）',
  'pages.hara.criteria.severity.S1': '轻度和中度伤害（如擦伤、轻微骨折，通常可完全恢复）',
  'pages.hara.criteria.severity.S2': '严重和危及生命的伤害（有存活可能，如重度脑震荡、失去肢体）',
  'pages.hara.criteria.severity.S3': '危及生命和致命伤害（存活不确定，如致命伤）',
  'pages.hara.criteria.exposure.E0': '极不可能（该场景在车辆生命周期内几乎不出现）',
  'pages.hara.criteria.exposure.E1': '非常低的概率（少数特定工况下偶尔出现）',
  'pages.hara.criteria.exposure.E2': '低概率（每年可能出现数次）',
  'pages.hara.criteria.exposure.E3': '中等概率（每月可能出现）',
  'pages.hara.criteria.exposure.E4': '高概率（几乎每次运行都会出现）',
  'pages.hara.criteria.controllability.C0': '一般可控（绝大多数驾驶员可轻松避免危害）',
  'pages.hara.criteria.controllability.C1': '简单可控（多数驾驶员可采取措施避免危害）',
  'pages.hara.criteria.controllability.C2': '通常可控（多数驾驶员能采取措施，但需一定注意力）',
  'pages.hara.criteria.controllability.C3': '难以控制或不可控（驾驶员基本无法避免危害）',

  'pages.hara.criteriaOpen': 'S / E / C 判据表',
  'pages.hara.criteriaOpenHint': 'S / E / C 等级定义与表 4 判据（ISO 26262-3 6.4.3）',
  'pages.hara.criteriaOpenFromMatrix': '查看 S / E / C 完整判据 →',
  'pages.hara.criteriaDrawerTitle': 'S / E / C 判据表',
  'pages.hara.criteriaDrawerIntro':
    '危害事件分类：严重度 S、暴露概率 E、可控性 C 见 ISO 26262-3 6.4.3；暴露等级 E 的定级依据见 Annex B；ASIL 判定见表 4。本页只作对照，不代替工程师判定。',
  'pages.hara.criteriaTitle.severity': '严重度 S',
  'pages.hara.criteriaTitle.exposure': '暴露概率 E',
  'pages.hara.criteriaTitle.controllability': '可控性 C',
  'pages.hara.criteriaTitleAsil': 'ASIL 判定（S × E × C）',
  'pages.hara.criteriaClauseSeverity': 'ISO 26262-3 6.4.3 —— 按可能造成的人员伤害严重程度分档',
  'pages.hara.criteriaClauseExposure':
    'ISO 26262-3 6.4.3 / 6.4.3.5 —— 按目标市场中该工况的出现频次或时长占比分档（档位见 Annex B）',
  'pages.hara.criteriaClauseControllability':
    'ISO 26262-3 6.4.3 —— 按典型驾驶员在反应时间内能否避免危害分档',
  'pages.hara.criteriaClauseAsil': 'ISO 26262-3:2018 表 4',
  'pages.hara.criteriaColLevel': '等级',
  'pages.hara.criteriaColText': '判据',
  'pages.hara.criteriaExposureBasisNote':
    'E 不能只填一个档位：按 Annex B，必须落在下面某个时长或频次口径上，并在主表 E 列记下依据。',
  'pages.hara.criteriaBasisColBasis': '定级依据（口径）',
  'pages.hara.criteriaBasisColLevel': '对应 E',
  'pages.hara.exposureBasisKindDuration': '按持续时间占比',
  'pages.hara.exposureBasisKindFrequency': '按出现频次',
  'pages.hara.exposureBasisFilled': '依据 · {{text}}',
  'pages.hara.exposureBasisMissing': '缺定级依据',
  'pages.hara.exposureBasisClear': '清除依据',
  'pages.hara.missingExposureBasis':
    '有 {{count}} 条未写暴露定级依据：按 ISO 26262-3 Annex B，E 必须落在时长或频次口径上并留痕',
  'pages.hara.anchorHint': '写清为什么是这一级（自由填写，评审据此回溯）',
  'pages.hara.anchorPlaceholder': '如：可能撞到行人，导致致命伤',
  'pages.hara.anchorSuggest': '常用短语（点一下填入）',
  'pages.hara.anchorCriteriaRef': '当前判据：{{text}}',
  'pages.hara.anchorFilled': '依据 · {{text}}',
  'pages.hara.anchorEmpty': '＋判据锚点',
  'pages.hara.anchorEmptyShort': '未填判据',
  'pages.hara.anchor.severity.vru': '可能涉及行人或骑行者',
  'pages.hara.anchor.severity.unrestrained': '乘员未受约束',
  'pages.hara.anchor.severity.highEnergy': '高能量碰撞（高速或大质量差）',
  'pages.hara.anchor.severity.secondary': '可能引发二次碰撞',
  'pages.hara.anchor.severity.noHarm': '仅车辆受损，无人员伤害',
  'pages.hara.anchor.controllability.blind': '无预警，驾驶员来不及反应',
  'pages.hara.anchor.controllability.sightBlocked': '视线受阻，难以察觉',
  'pages.hara.anchor.controllability.counterIntuitive': '违反驾驶员直觉，易误操作',
  'pages.hara.anchor.controllability.expert': '需专业操作或专用工具',
  'pages.hara.anchor.controllability.clear': '提示明显且反应时间充足',
  'pages.hara.asilMatrixTitle': 'S × E × C → ASIL（ISO 26262-3 表 4）',
  'pages.hara.asilMatrixCurrent': '当前',
  'pages.hara.asilMatrixCaption': '当前：{{s}} + {{e}} + {{c}} → {{asil}}',

  'pages.hara.override': '覆盖',
  'pages.hara.overrideTitle': '人工覆盖 ASIL',
  'pages.hara.overrideComputed': '按 ISO 26262-3 表 4 计算：',
  'pages.hara.overridePick': '选择覆盖后的 ASIL',
  'pages.hara.overrideReasonHint': '必须写明理由，评审一定会问为什么这条要人工判定',
  'pages.hara.missingOverrideReason': '有 {{count}} 条人工覆盖了 ASIL 但未填写理由，评审时会被追问',
  'pages.hara.asilComputed': '计算 ASIL',
  'pages.hara.asilOverride': '人工覆盖',
  'pages.hara.asilMismatch': '有 {{count}} 条 ASIL 与后端判定不一致，已按 ISO 26262-3 表 4 校正',

  'pages.hara.itemDefinition': 'Item 定义',
  'pages.hara.itemName': 'Item 名称',
  'pages.hara.itemNameHint': '如：电子驻车制动系统 EPB',
  'pages.hara.aiFill': 'AI 填写',
  'pages.hara.aiFillHint': '填好名称后点击，AI 会按通用知识补全下方四项',
  'pages.hara.aiFillNote':
    '依据 Item 名称，按通用知识填写下方四项（功能与构成 / 边界与接口 / 运行模式 / 法规约束）；结果不会自动保存，需人工核对后再保存。',
  'pages.hara.aiFillReadOnly': '只读模式下不可用',
  'pages.hara.aiFillNeedName': '请先填写 Item 名称，AI 依据名称补全',
  'pages.hara.aiFillOverwriteTitle': '覆盖已有内容？',
  'pages.hara.aiFillOverwrite':
    '下方四项中已有 {{count}} 项填了内容，AI 生成结果会覆盖它们（Item 名称保持不变）。确定继续？',
  'pages.hara.aiFillOverwriteOk': '覆盖并生成',
  'pages.hara.aiFillDone': '已按通用知识填写 {{count}} 项，请逐条核对后再保存',
  'pages.hara.aiFillEmpty': 'AI 没有返回可填写的内容，请换个说法再试',
  'pages.hara.aiFnGenerate': 'AI 生成',
  'pages.hara.aiFnReview': 'AI 查缺',
  'pages.hara.aiFnTitleGenerate': 'AI 生成功能清单',
  'pages.hara.aiFnTitleReview': 'AI 查缺',
  'pages.hara.aiFnContext': '依据 Item 定义生成 · 当前已有 {{count}} 条功能',
  'pages.hara.aiFnRequirements': '补充要求，可留空（留空即按 Item 定义与通用知识生成）',
  'pages.hara.aiFnRequirementsReview': '补充要求，可留空（例如：只关注坡道和高速场景）',
  'pages.hara.aiFnSubmitGenerate': '生成候选',
  'pages.hara.aiFnSubmitReview': '开始查缺',
  'pages.hara.aiFnRerun': '重新生成',
  'pages.hara.aiFnFindings': '审查意见',
  'pages.hara.aiFnNoFindings': '没有发现问题',
  'pages.hara.aiFnReviewNote':
    '以上只是意见，不会改动你的清单；需要新增条目请回到「AI 生成功能清单」。',
  'pages.hara.aiFnCandidates': '候选功能（勾选后添加到清单末尾）',
  'pages.hara.aiFnExcluded': 'AI 判定不在本 Item 范围内',
  'pages.hara.aiFnDup': '已有 {{code}}',
  'pages.hara.aiFnBasis': '依据',
  'pages.hara.aiFnDescPlaceholder': '一句话说明',
  'pages.hara.aiFnAdd': '添加勾选的 {{count}} 条',
  'pages.hara.aiFnAdded': '已添加 {{count}} 条，记得保存',
  'pages.hara.aiFnNothingAdded': '没有新增条目：勾选的都已在清单里',
  'pages.hara.aiFnSkipped': '跳过 {{count}} 条（清单里已有同名功能）',
  'pages.hara.aiFnNoItem':
    '请先在 Item 定义页填写「功能与构成 / 边界与接口 / 运行模式 / 法规约束」中至少一项',
  'pages.hara.aiFnEmpty': 'AI 没有给出可用结果，补充要求后重试',
  'pages.hara.aiFnFailed': 'AI 调用失败，请稍后重试',
  'pages.hara.aiFnType.missing': '缺项',
  'pages.hara.aiFnType.granularity': '粒度',
  'pages.hara.aiFnType.out_of_scope': '越界',
  'pages.hara.aiFnType.duplicate': '重复',
  'pages.hara.aiFnType.other': '其他',
  'pages.hara.aiFillFailed': 'AI 填写失败，请稍后重试',
  'pages.hara.aiDisabled': 'AI 功能未启用，请联系管理员在系统设置中开启',
  'pages.hara.aiNotConfigured': 'AI 服务配置不完整，请检查系统设置',
  'pages.hara.itemDescription': 'Item 的功能与构成',
  'pages.hara.itemDescriptionHint': '具备哪些功能、由哪些部件构成、在整车中承担什么职责',
  'pages.hara.itemBoundaries': '边界与接口',
  'pages.hara.itemBoundariesHint': '与哪些外部系统交互、边界划在哪里（含不属于本 Item 的部分）',
  'pages.hara.itemOperatingModes': '运行模式',
  'pages.hara.itemOperatingModesHint': '如驻车、行驶、坡道起步、故障降级等',
  'pages.hara.legalConstraints': '法规约束',
  'pages.hara.legalConstraintsHint': '适用的法规、国家标准与企业内部规范',
  'pages.hara.content': '内容',
  'pages.hara.project': '项目',
  'pages.hara.process': '过程',
  'pages.hara.sheetOverview': '概览',

  'pages.hara.goalId': '安全目标',
  'pages.hara.goalDescHint':
    'ISO 26262-3:2018 6.4.4.1：安全目标是整车的顶层安全要求，应表述为「避免什么」的功能目标，不要写成技术方案（如「通过 CAN 关闭扭矩」）。',
  'pages.hara.goalDescPlaceholder': '如：避免非预期的驱动扭矩输出',
  'pages.hara.goalDescAuto': '系统按危害归类自动生成，请按功能目标改写',
  'pages.hara.goalUncovered': '未覆盖',
  'pages.hara.goalUncoveredHint':
    '该危害事件已评出 ASIL，却没有归入任何安全目标（ISO 26262-3:2018 6.4.6.1 d 要求危害事件覆盖完整）',
  // ---- HARA → 生成工作产品文档 ----
  'pages.hara.docTitle': 'HARA 危害分析与风险评估报告',
  'pages.hara.generatedAt': '生成时间',
  'pages.hara.docGeneratedNote':
    '本文档由 HARA 面板生成，是生成时刻的数据快照；HARA 数据变更不会自动同步到这里，需重新生成。',
  'pages.hara.publishDoc': '生成工作产品',
  'pages.hara.refreshDoc': '刷新工作产品',
  'pages.hara.publishDirty': '请先保存修改，再生成工作产品文档',
  'pages.hara.publishEmpty': '还没有危害事件，无需生成工作产品文档',
  'pages.hara.publishCreated': '已生成工作产品文档 {{version}}',
  'pages.hara.publishUpdated': '已刷新工作产品文档 {{version}}',
  'pages.hara.publishUpgraded': '文档已升版至 {{version}}（原版本已保留）',
  'pages.hara.publishFailed': '生成工作产品文档失败',
  'pages.hara.publishVersionDesc': '由 HARA 面板重新生成',
  'pages.hara.publishRevisionDesc': '由 HARA 面板同步生成',
  'pages.hara.publishVersionFailed': '创建文档新版本失败',
  'pages.hara.publishedDoc': '对应工作产品文档',
  'pages.hara.versionPrefix': '版本',
  'pages.hara.publishedAt': '生成于 {{at}}',
  'pages.hara.publishedStale': '此后 HARA 数据又有变更，文档已落后，建议刷新',
  'pages.hara.notPublished':
    '尚未生成工作产品文档。生成后会挂到本过程的工作产品下，具备版本、评审、基线、导出等全套能力。',
  'pages.hara.statTitle': '统计概览',
  'pages.hara.staleShort': '已落后',
  'pages.hara.noDoc': '未生成文档',
  'pages.hara.allSaved': '已保存，无待保存修改',
  'pages.hara.publishFirstTip':
    '生成后挂到本过程的工作产品下，具备版本、评审、基线、导出等全套能力',
  'pages.hara.publishRefreshTip':
    '把当前数据重新渲染进已有文档：仍是草稿则原地覆盖，已评审或已发布则升新版本',

  // ---------------------------------------------------------------- 功能安全概念（FSC）
  'pages.workProducts.fsc': '功能安全概念',

  'pages.fsc.tabGoals': '安全目标',
  'pages.fsc.tabRequirements': '功能安全需求',
  'pages.fsc.tabArchitecture': '初步架构',
  'pages.fsc.tabAllocation': '需求分配矩阵',
  'pages.fsc.tabConsistency': '一致性与追溯',
  'pages.fsc.tabExternal': '外部措施',

  'pages.fsc.goalId': '安全目标',
  'pages.fsc.hazardGroup': '危害归类',
  'pages.fsc.colAsil': 'ASIL',
  'pages.fsc.safeState': '安全状态',
  'pages.fsc.safeStateLegacy': '该值来自旧版 HARA 主表字段，建议在安全目标页复核后重新填写',
  'pages.fsc.needReview': '待复核',
  'pages.fsc.missing': '未填写',
  'pages.fsc.ftti': 'FTTI',
  'pages.fsc.colRequirementCount': '已派生需求',
  'pages.fsc.emptyGoalsFromHara':
    'HARA 里还没有安全目标：主表评出 QM 以外的 ASIL 后会自动聚合出安全目标',
  'pages.fsc.emptyGoalsNoHara': '还没有 HARA 数据：请先完成「HARA 危害分析」，安全目标是它的输入',
  'pages.fsc.safeStateMissingTitle': '有 {{count}} 个安全目标还没定义安全状态或 FTTI',
  'pages.fsc.safeStateMissingDesc':
    '安全状态（ISO 26262-3 7.4.2.5）与 FTTI（7.4.2.3）是功能安全概念的输入，缺失会让下面的需求分解失去依据。录入入口在「HARA 危害分析 → 安全目标」，本页只做只读引用。',
  'pages.fsc.goalsReadOnlyNote':
    '本页只读：安全目标由 HARA 危害事件聚合而来，安全状态与 FTTI 在 HARA 的安全目标页录入，这里刻意不提供第二个编辑入口。',

  'pages.fsc.allGoals': '全部安全目标',
  'pages.fsc.onlyUnconfirmed': '只看待确认',
  'pages.fsc.reqCount': '共 {{total}} 条，当前显示 {{shown}} 条',
  'pages.fsc.reqGoal': '安全目标',
  'pages.fsc.reqStrategy': '派生策略',
  'pages.fsc.strategyClause': 'ISO 26262-3:2018 7.4.2.3 {{code}})',
  'pages.fsc.strategyUnset': '未标注策略',
  'pages.fsc.asilPartA': 'a 可调，b 跟随',
  'pages.fsc.asilFollowHint': '由同组子需求 a 推导，原等级 {{from}} 不变',
  'pages.fsc.asilDecomposedParentHint': '已分解：等级由两条子需求承载，本行不再直接分配',
  'pages.fsc.asilInheritHint': '继承所属安全目标，只读；要降级请用「ASIL 分解」',
  'pages.fsc.asilPartnerMissing': 'ASIL {{asil}} 不能作为 {{original}} 的分解分量',
  'pages.fsc.decomposePartA': '子需求 {{id}}a 的 ASIL（另一条自动配对）',
  'pages.fsc.decomposePreview': '结果：{{id}}a = {{a}}({{from}}) ／ {{id}}b = {{b}}({{from}})',
  'pages.fsc.cellAsilReadonly': '分配等级（跟随需求）',
  'pages.fsc.cellAsilFollow': '等于需求等级；要降级请回需求页做 ASIL 分解',
  'pages.fsc.verification.review': '评审',
  'pages.fsc.verification.walkthrough': '走查',
  'pages.fsc.verification.inspection': '检查',
  'pages.fsc.verification.analysis': '分析',
  'pages.fsc.verification.simulation': '仿真',
  'pages.fsc.verification.bench': '台架测试',
  'pages.fsc.verification.vehicle': '实车测试',
  'pages.fsc.verification.safetyAnalysis': '安全分析（FMEA / FTA）',
  'pages.fsc.reqId': '需求编号',
  'pages.fsc.reqDescription': '需求描述',
  'pages.fsc.refinedBadge': '已在本页细化，与 HARA 派生值不同',
  'pages.fsc.refinedFromHara': '沿用 HARA 侧的细化',
  'pages.fsc.reqNote':
    '功能安全需求由 HARA 的安全目标导出（ISO 26262-3:2018 7.4.2.1），定稿在本页。左侧安全目标单元格按目标纵向合并，组内一行一条需求，编号顺序就是行顺序。点该格右下角的「+ FSR」按 7.4.2.3 的策略勾选生成（每个目标至少一条，7.4.2.2）；「派生策略」是这条需求走的那一条（a~i，原文 if applicable，不是固定四条）。ASIL 继承安全目标，要降级就在该行 ASIL 值旁点「分解」，拆成两条子需求。',

  'pages.fsc.reqVerification': '验证方法',
  'pages.fsc.reqVerificationPlaceholder': '如：评审 + 测试',
  'pages.fsc.reqStatus': '状态',
  'pages.fsc.reqConfirmHint': '确认表示这条需求在本版功能安全概念里已定稿，可以进评审',
  'pages.fsc.confirmed': '已确认',
  'pages.fsc.unconfirmed': '待确认',
  'pages.fsc.notAllocated': '未分配',
  'pages.fsc.noVerification': '缺验证',
  'pages.fsc.actions': '操作',
  'pages.fsc.resetOverride': '还原',
  'pages.fsc.resetOverrideHint':
    '删掉本页的细化。若 HARA 侧还留着旧的细化，会回落到那份只读基线，而不是原始派生措辞',

  'pages.fsc.elementType.SYSTEM': '系统',
  'pages.fsc.elementType.HARDWARE': '硬件',
  'pages.fsc.elementType.SOFTWARE': '软件',
  'pages.fsc.elementType.MECHANICAL': '机械',
  'pages.fsc.elementType.EXTERNAL': '外部措施',
  'pages.fsc.elementType.OTHER_TECH': '其他技术',
  'pages.fsc.externalOwner.DRIVER': '驾驶员',
  'pages.fsc.externalOwner.OTHER_SYSTEM': '其他系统',
  'pages.fsc.externalOwner.INFRASTRUCTURE': '基础设施',
  'pages.fsc.externalOwner.PROCESS': '生产与售后过程',

  'pages.fsc.allocatedCountShort': '{{count}} 条',
  'pages.fsc.newElementName': '新要素',
  'pages.fsc.architectureTree': '初步架构',
  'pages.fsc.addElementMenu': '要素',
  'pages.fsc.insertRootElement': '新建根要素',
  'pages.fsc.insertRootElementHint': '在根下新增（系统 / 外部措施）',
  'pages.fsc.insertSiblingElement': '新建同级要素',
  'pages.fsc.insertSiblingElementHint': '挂在同一个父下，紧跟在选中项之后',
  'pages.fsc.insertChildElement': '新建下级要素',
  'pages.fsc.insertChildElementHint': '成为选中项的最后一个子要素',
  'pages.fsc.insertParentElement': '插入上级要素',
  'pages.fsc.insertParentElementHint': '新插一层父，把选中项（连同其下级）包起来',
  'pages.fsc.dragTip':
    '拖动要素可以改层级：放到另一个要素上成为它的下级（连带其下级一起走），放到空白处升为根。',
  'pages.fsc.dragMoving': '正在拖动「{{name}}」',
  'pages.fsc.dragSubtree': '（含 {{count}} 个下级，会一起跟着走）',
  'pages.fsc.dragTargetHint': '放到要素上成为它的下级，放到空白处升为根',
  'pages.fsc.dragBlockedCycle': '不能放到自己的下级上：那样会把要素拖成环',
  'pages.fsc.dragBlockedSelf': '不能放到自身上',
  'pages.fsc.dragBlockedNoop': '它已经是这个要素的下级了',
  'pages.fsc.emptyElements': '还没有架构要素：至少要有承载需求的相关项要素',
  'pages.fsc.elementProperties': '要素属性',
  'pages.fsc.removeElement': '删除要素',
  'pages.fsc.elementName': '名称',
  'pages.fsc.elementTypeLabel': '类型',
  'pages.fsc.elementAsilCapability': 'ASIL 能力',
  'pages.fsc.elementAsilCapabilityHint': '分配高于这个等级的需求时，会在一致性检查里报能力缺口',
  'pages.fsc.elementDcTarget': '诊断覆盖目标',
  'pages.fsc.elementDcTargetPlaceholder': '如：高（≥90%）',
  'pages.fsc.elementDescription': '说明',
  'pages.fsc.elementUsage': '已承载 {{count}} 条需求',
  'pages.fsc.selectElement': '请在左侧选择一个要素',
  'pages.fsc.elementCode': '要素编号',
  'pages.fsc.elementCodeHint':
    '编号由层级生成：AE-001 的下级是 AE-001-001。改层级时会重编号，并同步需求分配与框图。',
  'pages.fsc.renameTitle': '移动到「{{target}}」下需要重编号',
  'pages.fsc.renameTitleRoot': '升为根要素需要重编号',
  'pages.fsc.renameSubtreeHint':
    '「{{source}}」连同 {{count}} 个下级一起移动，编号按新位置重发；旧号作废后不再使用。',
  'pages.fsc.renameImpact':
    '同时更新：{{alloc}} 条需求分配、{{nodes}} 个框图节点、{{edges}} 条连线。',
  'pages.fsc.renameConfirm': '确认重编号并移动',
  'pages.fsc.renameCancel': '取消',

  'pages.fsc.cellDegradedHint':
    '这条分配记的等级（{{asil}}）低于需求当前的 {{target}}：重新保存一次即按需求等级归一。要真正降级请回需求页做 ASIL 分解。',

  'pages.fsc.cellNote': '备注',
  'pages.fsc.removeAllocation': '取消这条分配',
  'pages.fsc.decompose': 'ASIL 分解',
  'pages.fsc.decomposeTitle': 'ASIL 分解 —— {{id}}',
  'pages.fsc.cancelDecompose': '取消分解',
  'pages.fsc.cancel': '取消',
  'pages.fsc.applyDecompose': '应用分解',
  'pages.fsc.decomposeAlertTitle': 'ISO 26262-9:2018 5.4.5：安全目标不可分解，只分解需求',
  'pages.fsc.decomposeAlertDesc':
    '分解会生成两条真实子需求（如 FSR-002a / FSR-002b），保留原等级标注 B(D)。两条子需求必须落在两个相互独立的架构要素上，并在安全案例里用 DFA 证明其独立性。',
  'pages.fsc.decomposeElements': '两个独立要素（顺序对应 a / b）',

  'pages.fsc.decomposeElementsPlaceholder': '选择两个要素',
  'pages.fsc.decomposeReason': '分解理由（评审必看）',
  'pages.fsc.decomposeReasonShort': '分解理由',
  'pages.fsc.decomposeBy': '分解人',
  'pages.fsc.decomposeApplyNote':
    '生成后：子需求 a 的等级是你选的那一段，b 按 ISO 26262-9:2018 5.4.5 自动配对（原等级标注如 C(D) 保持不变）；两条各带一条分配，父需求不再直接分配。',

  'pages.fsc.noRequirementsForMatrix':
    '还没有功能安全需求：请先到「功能安全需求」页，按安全目标生成 FSR（7.4.2.2 每个目标至少一条）',
  'pages.fsc.noElementsForMatrix':
    '还没有架构要素：请先在「初步架构」里建立承载需求的相关项要素与外部措施',
  'pages.fsc.matrixHint':
    '点格子分配需求：等级只读跟随需求，要降级请回「功能安全需求」页做 ASIL 分解。分解出的 FSR-xxxa / FSR-xxxb 紧跟在父需求下面，各自分配、各自显示结果；已分解的父需求不再直接分配（格子显示「—」）。',
  'pages.fsc.matrixColFsr': 'FSR',
  'pages.fsc.matrixChildOf': '分解自 {{id}}',

  'pages.fsc.reqTotal': '共 {{total}} 条需求（含分解子需求）',
  'pages.fsc.goalCovered': 'FSR {{count}} 条',
  'pages.fsc.goalUncovered': '缺 FSR',
  'pages.fsc.goalSafeStateLabel': '安全状态',
  'pages.fsc.goalNoRequirementHint':
    '每个安全目标至少应有一条功能安全要求（ISO 26262-3:2018 7.4.2.2）。这个安全目标还没有任何功能安全要求。',
  'pages.fsc.addFsr': '+ FSR',
  'pages.fsc.decomposeShort': '分解',
  'pages.fsc.colAllocation': '分配',
  'pages.fsc.columnId': '编号',
  'pages.fsc.allocOpenHint': '点这里选承载要素（初步架构，ISO 26262-3:2018 7.4.2.8）',
  'pages.fsc.allocDecomposedHint': '已分解：功能由两条子需求承载，父需求本身不分配',
  'pages.fsc.archViewTree': '要素树',
  'pages.fsc.archViewDiagram': '功能框图',
  'pages.fsc.archOrderHint':
    '要素树定「有哪些、各承载几条需求」，功能框图定「信号怎么走」——先树后图。',
  'pages.fsc.aiDraftTitle': 'AI 起草架构',
  'pages.fsc.aiDraftSubtitle':
    '这是草稿，不会落库；勾选后合并进当前架构，再点页面上的「保存」才生效。',
  'pages.fsc.aiDraftSource': '来源：FSR {{count}} 条',
  'pages.fsc.aiDraftElementsOnly': '只出要素，不分配',
  'pages.fsc.aiDraftAllowReuse': '允许复用已有要素',
  'pages.fsc.aiDraftToggleHint': '改完开关点「重新起草」',
  'pages.fsc.aiDraftCandidates': '候选要素 {{count}}',
  'pages.fsc.aiDraftElementCountHint': '层级最多 3 层',
  'pages.fsc.aiDraftAllocations': '候选分配（只补空）',
  'pages.fsc.aiDraftAllocationHint': '只读，分错了合并后去矩阵改',
  'pages.fsc.aiDraftNew': '＋新建',
  'pages.fsc.aiDraftReuse': '＝复用 {{id}}',
  'pages.fsc.aiDraftUnlinked': '无需求依据',
  'pages.fsc.aiDraftAllocated': '已有',
  'pages.fsc.aiDraftUnassigned': '未分配',
  'pages.fsc.aiDraftNoAllocation': '本次只出要素，没有分配',
  'pages.fsc.aiDraftRedraft': '重新起草',
  'pages.fsc.aiDraftCancel': '取消',
  'pages.fsc.aiDraftAccept': '接受所选 {{count}} 项',
  'pages.fsc.aiDraftRetry': '重试',
  'pages.fsc.aiDraftRunning': '正在读需求并起草架构，通常十几秒…',
  'pages.fsc.aiDraftEmpty': 'AI 没有给出可用的要素，换个开关组合重新起草试试',
  'pages.fsc.aiDraftFailed': '起草失败',
  'pages.fsc.aiDraftNotes': '整体思路：',
  'pages.fsc.aiDraftIssueCount': '清洗时修正了 {{count}} 处，悬停查看',
  'pages.fsc.aiDraftStatsHint': '无需求依据的要素默认不勾：勾了就变成一致性检查里的孤儿缺口',
  'pages.fsc.aiStatUnlinked': '{{count}} 项无需求依据',
  'pages.fsc.aiStatReused': '{{count}} 项复用已有',
  'pages.fsc.aiStatUnassigned': '{{count}} 条 FSR 未分配',
  'pages.fsc.aiDraftApplied': '已合并 {{elements}} 个要素、{{allocations}} 条分配，记得点「保存」',
  'pages.fsc.diagramBoundary': '相关项边界',
  'pages.fsc.diagramEmpty': '还没有架构要素：先在左侧把要素建起来',
  'pages.fsc.diagramLink': '连线',
  'pages.fsc.diagramLinkOn': '连线中…点终点',
  'pages.fsc.diagramLinkHint':
    '点起点要素，再点终点要素。连线两端必须是已存在的要素——图上不会出现库里没有的块',
  'pages.fsc.diagramRelayout': '自动布局',
  'pages.fsc.diagramRemoveEdge': '删除连线',
  'pages.fsc.diagramClearEdges': '清空连线',
  'pages.fsc.diagramClearHint': '只删连线，要素与它们的位置都保留',
  'pages.fsc.diagramFlowLegend': '流向',
  'pages.fsc.diagramDangling':
    '有 {{count}} 条连线的端点要素已被删除，未画出；下一次保存会自动清理',
  'pages.fsc.diagramEdgeTitle': '连线：{{from}} → {{to}}',
  'pages.fsc.diagramEdgeFlow': '流向类型',
  'pages.fsc.diagramEdgeLabel': '标注（如信号名）',
  'pages.fsc.diagramEdgeLabelPlaceholder': '如：轮速信号 / 制动力矩指令',
  'pages.fsc.diagramEdgeAdd': '添加连线',
  'pages.fsc.diagramEdgeExists': '这两个要素之间已经有同流向的连线',
  'pages.fsc.diagramEdgeAdded': '已加一条连线',
  'pages.fsc.edgeFlow.SIGNAL': '信号',
  'pages.fsc.edgeFlow.ENERGY': '能量',
  'pages.fsc.edgeFlow.DATA': '数据',
  'pages.fsc.edgeFlow.HUMAN': '人机',
  'pages.fsc.drawerTitle': '{{id}} 的分配',
  'pages.fsc.drawerSubtitle':
    '初步架构要素（ISO 26262-3:2018 7.4.2.8）。勾上的要素即承载这条需求；等级只读跟随需求，要降级请回主表用「分解」。',
  'pages.fsc.drawerPick': '勾选承载要素',
  'pages.fsc.drawerNewElement': '+ 新建要素',
  'pages.fsc.drawerRoot': '挂在根下',
  'pages.fsc.drawerCreate': '创建',
  'pages.fsc.drawerTarget': '在 {{id}} 上的实现',
  'pages.fsc.drawerAsilHint': '实现等级跟随需求，不可在此修改（降级只能走 ASIL 分解）',
  'pages.fsc.drawerNote': '分配说明',
  'pages.fsc.drawerNotePlaceholder': '为什么落在这一要素上（评审会问）',
  'pages.fsc.drawerCarried': '该要素还承载 {{count}} 条需求',
  'pages.fsc.drawerOrphan': '这个要素一条需求都不承载——是多余，还是漏分配？',
  'pages.fsc.drawerSelectHint': '先勾选左侧要素，再在这里写分配说明',
  'pages.fsc.drawerElementEmpty': '本需求 0',
  'pages.fsc.drawerFooterHint': '改动已记入页面，点顶部「保存」才落库',
  'pages.fsc.drawerDone': '完成',
  'pages.fsc.generateTitle': '由 {{id}} 生成功能安全需求',
  'pages.fsc.generateConfirm': '生成 FSR',
  'pages.fsc.generateAlertTitle': 'ISO 26262-3:2018 7.4.2.3 的策略清单（if applicable）',
  'pages.fsc.generateAlertDesc':
    '不是固定四条：按这个安全目标的实际情况勾选，勾几条就生成几条草稿，生成后可逐条改写。已生成过的策略会标灰。',
  'pages.fsc.strategyUsed': '已生成',
  'pages.fsc.strategyLabel.a': '故障避免',
  'pages.fsc.strategyLabel.b': '故障探测与控制',
  'pages.fsc.strategyLabel.c': '进入 / 退出安全状态',
  'pages.fsc.strategyLabel.d': '故障容错',

  'pages.fsc.strategyLabel.e': '故障下功能降级（含与警告的联动）',

  'pages.fsc.strategyLabel.f': '驾驶员警告（缩短暴露时间）',
  'pages.fsc.strategyLabel.g': '驾驶员警告（提高可控性）',

  'pages.fsc.strategyLabel.h': '时间要求（FTTI → FHTI）',
  'pages.fsc.strategyLabel.i': '多请求仲裁（避免不当仲裁）',

  'pages.fsc.strategyGroupFallback': '该类危害',
  'pages.fsc.strategySafeStateFallback': '（待定义安全状态）',
  'pages.fsc.strategyFttiFallback': '（待定义 FTTI）',
  'pages.fsc.childTag': '分解',
  'pages.fsc.decomposed': '已分解',
  'pages.fsc.decomposeHint': '按 ISO 26262-9 拆成两条子需求，各落在独立要素上',
  'pages.fsc.decomposeBase': '分解基准 ASIL（取自需求）',
  'pages.fsc.decomposeNeedElements':
    '请选择两个相互独立的架构要素：ASIL 分解只在两个独立要素上成立',
  'pages.fsc.cancelDecomposeTitle': '取消分解 {{id}}？',
  'pages.fsc.cancelDecomposeContent':
    '两条子需求（及其分配）会被删除，父需求恢复为普通需求。此操作需重新保存才生效。',
  'pages.fsc.delete': '删除',
  'pages.fsc.deleteRequirementTitle': '删除需求 {{id}}？',
  'pages.fsc.deleteRequirementContent': '相关分配也会一并删除，需重新保存才生效。',
  'pages.fsc.deleteRequirementWithChildren': '它的 {{count}} 条分解子需求与相关分配会一并删除。',
  'pages.fsc.parentNotAllocatable': '已分解的需求不再直接分配：功能由两条子需求分别承载',
  'pages.fsc.clearRequirements': '清空功能安全需求',
  'pages.fsc.clearRequirementsTitle': '清空全部功能安全需求？',
  'pages.fsc.clearRequirementsContent':
    '含分解子需求与相关分配；安全目标（HARA）不受影响。清空后可用「生成 FSR」重新按策略生成。',
  'pages.fsc.gapDecomposeCombination': '分解组合不合法',
  'pages.fsc.gapDecomposeParent': '已分解需求仍被分配',
  'pages.fsc.gapDecomposeIndependence': '分解要素不独立',
  'pages.fsc.gapDecomposeStale': '分解标注已过期',

  'pages.fsc.gapUnallocated': '需求未分配',
  'pages.fsc.gapUnallocatedDetail': 'ASIL {{asil}} 的需求还没有落到任何架构要素上',
  'pages.fsc.gapUncoveredGoal': '安全目标无需求',
  'pages.fsc.gapUncoveredGoalDetail': '「{{group}}」这个安全目标没有任何功能安全需求覆盖它',
  'pages.fsc.gapAsil': 'ASIL 降级未分解',
  'pages.fsc.gapAsilDetail': '需求 {{from}} 在 {{element}} 上被实现为 {{to}}：{{reason}}',
  'pages.fsc.gapCapability': '要素能力不足',
  'pages.fsc.gapCapabilityDetail':
    '{{element}} 的 ASIL 能力是 {{capability}}，低于分配上去的 {{asil}}',
  'pages.fsc.gapDangling': '悬空引用',
  'pages.fsc.gapSafeState': '缺安全状态 / FTTI',
  'pages.fsc.gapSafeStateDetail':
    '安全目标「{{group}}」缺少：{{missing}}（在 HARA 的安全目标页补）',
  'pages.fsc.gapVerification': '缺验证方法',
  'pages.fsc.gapVerificationDetail': '这条需求没有写明怎么验证它',
  'pages.fsc.gapKind': '缺口类型',
  'pages.fsc.gapTarget': '对象',
  'pages.fsc.gapDetail': '说明',
  'pages.fsc.gotoFix': '去处理',
  'pages.fsc.consistencyOk': '没有致命缺口：每条需求都已分配、每个安全目标都有需求覆盖',
  'pages.fsc.gapList': '缺口清单',
  'pages.fsc.noGaps': '没有检查到缺口',
  'pages.fsc.traceTitle': '追溯链',
  'pages.fsc.traceEmpty': '还没有可展示的追溯链',
  'pages.fsc.traceEmptyHint': '追溯链由 HARA 的安全目标出发，先完成 HARA 才有内容',
  'pages.fsc.traceSafeState': '安全状态 {{value}}',
  'pages.fsc.traceNoSafeState': '未定义安全状态',
  'pages.fsc.traceVerification': '验证：{{value}}',
  'pages.fsc.traceNoVerification': '未定验证方法',
  'pages.fsc.kpiRequirements': '需求总数',
  'pages.fsc.kpiAllocated': '已分配',
  'pages.fsc.kpiConfirmed': '已确认',
  'pages.fsc.kpiElements': '架构要素',
  'pages.fsc.kpiGaps': '缺口',

  'pages.fsc.externalName': '外部措施 / 依赖',
  'pages.fsc.externalNamePlaceholder': '如：驾驶员踩下制动踏板',
  'pages.fsc.externalOwnerLabel': '归属方',
  'pages.fsc.externalAssumption': '假设条件',
  'pages.fsc.externalAssumptionPlaceholder': '如：驾驶员在收到告警后 1 秒内采取动作',
  'pages.fsc.externalRelated': '关联需求',
  'pages.fsc.addExternal': '新增外部措施',
  'pages.fsc.externalAlertTitle': '外部措施与假设条件要写得能自证（ISO 26262-3 7.4.2.8）',
  'pages.fsc.externalAlertDesc':
    '凡是安全概念依赖的相关项外部的措施（驾驶员、其他系统、基础设施、生产与售后过程），都要在此列出并写明成立前提；这些依赖不会因为「大家都知道」就可以不写。',
  'pages.fsc.externalMissingAssumptionShort': '有 {{count}} 条缺少假设条件',
  'pages.fsc.externalMissingAssumption': '有外部措施没写假设条件，评审时无法确认它成立的前提',

  'pages.fsc.statRequirements': '需求',
  'pages.fsc.statAllocated': '已分配',
  'pages.fsc.statElements': '要素',
  'pages.fsc.statMaxAsil': '最高 ASIL',
  'pages.fsc.statOk': '没有致命缺口',
  'pages.fsc.statGaps': '存在 {{count}} 项缺口',
  'pages.fsc.statDetail':
    '未分配需求 {{unallocated}} 条 · 缺口 {{gaps}} 项 · 最高 ASIL {{maxAsil}}',
  'pages.fsc.save': '保存',
  'pages.fsc.saveSuccess': '保存成功',
  'pages.fsc.saveFailed': '保存失败',
  'pages.fsc.saveConflict': '服务端数据已被他人更新，为避免覆盖请重新加载后再改',
  'pages.fsc.saveBlockedByLoadError': '数据未能加载，为避免覆盖库里的内容已阻止保存，请先重新加载',
  'pages.fsc.unsaved': '有未保存的修改',
  'pages.fsc.allSaved': '已保存，无待保存修改',
  'pages.fsc.preservedWarning': '部分表本次未提交内容，已保留服务端原值：{{tables}}',
  'pages.fsc.export': '导出 Excel',
  'pages.fsc.exportFailed': '导出失败',
  'pages.fsc.publishTip': '生成后挂到本过程的工作产品下，具备版本、评审、基线、导出等全套能力',
  'pages.fsc.refreshDoc': '刷新工作产品',
  'pages.fsc.publishDoc': '生成工作产品',
  'pages.fsc.publishCreated': '已生成工作产品文档',
  'pages.fsc.publishUpdated': '已刷新现有文档内容',
  'pages.fsc.publishUpgraded': '已升版并写入新版本',
  'pages.fsc.publishFailed': '生成工作产品文档失败',
  'pages.fsc.publishBeforeSave': '有未保存的修改，请先保存再生成工作产品',
  'pages.fsc.publishedStale': '此后数据又有变更，工作产品已落后，建议重新生成',
  'pages.fsc.publishedFresh': '工作产品与当前数据一致',
  'pages.fsc.notPublished': '未生成工作产品文档',
  'pages.fsc.reload': '重新加载',
  'pages.fsc.resetAll': '清空全部',
  'pages.fsc.resetTitle': '清空整份功能安全概念？',
  'pages.fsc.resetContent':
    '架构要素、需求分配、ASIL 分解与外部措施都会清空（清空前自动归档一版）。HARA 的数据不受影响。',
  'pages.fsc.resetConfirm': '清空',
  'pages.fsc.resetDone': '已清空',
  'pages.fsc.clearAllocations': '清空需求分配',
  'pages.fsc.loadErrorTitle': '没有加载到服务端的功能安全概念数据',
  'pages.fsc.loadErrorDesc':
    '此时界面上的空表并不代表库里是空的。为避免保存时覆盖掉已有内容，已暂时禁止保存。请重新加载后再录入。',
  'pages.fsc.noHaraTitle': '还没有 HARA 数据，安全目标与需求为空',
  'pages.fsc.noHaraDesc':
    '功能安全概念的输入是「相关项定义 + 危害分析与风险评估」。可以先把初步架构要素建起来，等 HARA 评出安全目标后再做分配。',
  'pages.fsc.scopeNote':
    '本页覆盖 ISO 26262-3:2018 第 7 章：每个安全目标至少一条功能安全要求（7.4.2.2）、实现策略 a)~i)（7.4.2.3）、需求属性（运行模式 / FTTI / 安全状态 / 紧急运行 / 功能冗余，7.4.2.4）、安全状态与紧急运行（7.4.2.5 / 7.4.2.6）、驾驶员动作假设（7.4.2.7）、需求分配到架构要素（7.4.2.8）、其他技术要素与外部措施（7.4.2.9 / 7.4.2.10）、安全确认准则与概念验证（7.4.3 / 7.4.4）；ASIL 分解按 ISO 26262-9:2018 第 5 章。安全机制属技术安全概念（ISO 26262-4:2018 6.4.2），不在本页。安全目标、安全状态与 FTTI 由 HARA 侧维护，本页只读引用。',

  'pages.fscReport.filePrefix': 'FSC',
  'pages.fscReport.docTitle': '功能安全概念',
  'pages.fscReport.sheetGoals': '1 安全目标',
  'pages.fscReport.sheetRequirements': '2 功能安全需求',
  'pages.fscReport.sheetElements': '3.1 初步架构要素',
  'pages.fscReport.sheetEdges': '3.2 初步架构接口',
  'pages.fscReport.sheetDiagram': '3 初步架构框图',
  'pages.fscReport.sheetAllocations': '4 需求分配',
  'pages.fscReport.sheetDecompositions': '5 ASIL 分解',
  'pages.fscReport.sheetExternal': '6 外部措施与假设',
  'pages.fscReport.sheetGaps': '7 一致性缺口',
  'pages.fscReport.sheetTrace': '8 追溯链',
  'pages.fscReport.colRequirementId': '需求编号',
  'pages.fscReport.colGoalId': '安全目标',
  'pages.fscReport.colKind': '派生策略',

  'pages.fscReport.colDescription': '需求描述',
  'pages.fscReport.colAsil': 'ASIL',
  'pages.fscReport.colSafeState': '安全状态',
  'pages.fscReport.colFtti': 'FTTI',
  'pages.fscReport.colVerification': '验证方法',
  'pages.fscReport.colConfirmed': '状态',
  'pages.fscReport.colHazardGroup': '危害归类',
  'pages.fscReport.colSourceHazards': '来源危害事件',
  'pages.fscReport.colElementId': '要素编号',
  'pages.fscReport.colElementName': '要素名称',
  'pages.fscReport.colElementType': '类型',
  'pages.fscReport.colParent': '父要素',
  'pages.fscReport.colCapability': 'ASIL 能力',
  'pages.fscReport.colDcTarget': '诊断覆盖目标',
  'pages.fscReport.colTarget': '承载要素',
  'pages.fscReport.colParts': '分解组合',
  'pages.fscReport.colChild': '子需求',
  'pages.fscReport.colDecomposed': '分解',
  'pages.fscReport.decomposedTag': '已分解',
  'pages.fscReport.childOf': '分解自 {{id}}',
  'pages.fscReport.colReason': '分解理由',
  'pages.fscReport.colOwner': '归属方',
  'pages.fscReport.colAssumption': '假设条件',
  'pages.fscReport.colRelatedRequirement': '关联需求',
  'pages.fscReport.colGapKind': '缺口类型',
  'pages.fscReport.colGapTarget': '对象',
  'pages.fscReport.colGapDetail': '说明',
  'pages.fscReport.colNote': '备注',
  'pages.fscReport.none': '（无）',

  // ---- 统一需求仓库（P1-b：SYS.2 需求规格等多来源录入） ----
  'pages.requirements.title': '系统需求规格',
  'pages.requirements.titleSwe': '软件需求规格',
  'pages.requirements.titleHwe': '硬件需求规格',
  'pages.requirements.add': '新增需求',
  'pages.requirements.reload': '刷新',
  'pages.requirements.colId': '编号',
  'pages.requirements.colDomain': '需求域',
  'pages.requirements.colText': '需求内容',
  'pages.requirements.colRating': '评级',
  'pages.requirements.colOrigin': '来源',
  'pages.requirements.colUpstream': '上游引用',
  'pages.requirements.colStatus': '状态',
  'pages.requirements.colVerification': '验证方法',
  'pages.requirements.colNote': '备注',
  'pages.requirements.colAction': '操作',
  'pages.requirements.colPriority': '优先级',
  'pages.requirements.colMilestone': '实现目标',
  'pages.requirements.addChild': '加子项',
  'pages.requirements.noParent': '无（根需求）',
  'pages.requirements.envImpactTag': '环评',
  'pages.requirements.envImpactPrefix': '运行环境影响',
  'pages.requirements.outline': '需求大纲（按层级）',
  'pages.requirements.consistencyTitle': '{{count}} 项层级一致性提示',
  'pages.requirements.priority.HIGH': '高',
  'pages.requirements.priority.MEDIUM': '中',
  'pages.requirements.priority.LOW': '低',
  'pages.requirements.milestone.A': 'A 样件',
  'pages.requirements.milestone.B': 'B 样件',
  'pages.requirements.milestone.C': 'C 样件',
  'pages.requirements.milestone.OTS': 'OTS 样件',
  'pages.requirements.milestone.SOP': 'SOP',
  'pages.requirements.domain.SAFETY': '功能安全',
  'pages.requirements.domain.CYBERSECURITY': '网络安全',
  'pages.requirements.domain.FUNCTIONAL': '一般功能',
  'pages.requirements.origin.INTERNAL': '系统内上游',
  'pages.requirements.origin.EXTERNAL': '外部输入',
  'pages.requirements.origin.MANUAL': '手工录入',
  'pages.requirements.semantics.derive': '派生',
  'pages.requirements.semantics.satisfy': '满足',
  'pages.requirements.semantics.verify': '验证',
  'pages.requirements.semantics.allocate': '分配',
  'pages.requirements.status.DRAFT': '草稿',
  'pages.requirements.status.IN_REVIEW': '评审中',
  'pages.requirements.status.APPROVED': '已批准',
  'pages.requirements.unlinked': '未挂接上游',
  'pages.requirements.editTitle.new': '新增需求',
  'pages.requirements.editTitle.edit': '编辑 {{id}}',
  'pages.requirements.field.domain': '需求域',
  'pages.requirements.field.text': '需求内容',
  'pages.requirements.field.rationale': '理由说明',
  'pages.requirements.field.acceptanceCriteria': '验收准则',
  'pages.requirements.field.verificationMethod': '验证方法',
  'pages.requirements.field.asil': 'ASIL',
  'pages.requirements.field.cal': 'CAL',
  'pages.requirements.field.originType': '来源类型',
  'pages.requirements.field.upstreamRefs': '上游引用（可多选）',
  'pages.requirements.field.upstreamSemantics': '链语义',
  'pages.requirements.field.externalDocument': '外部文档名',
  'pages.requirements.field.externalVersion': '版本',
  'pages.requirements.field.externalClause': '条款号 / 页码',
  'pages.requirements.field.status': '状态',
  'pages.requirements.field.note': '备注',
  'pages.requirements.field.parentId': '父需求',
  'pages.requirements.field.priority': '优先级',
  'pages.requirements.field.milestone': '实现目标',
  'pages.requirements.field.envImpact': '运行环境影响分析',
  'pages.requirements.hint.envImpact':
    '选填：低温、高原、EMC 等环境限定；有值时表格中以「环评」标记，并写入发布文档',
  'pages.requirements.hint.asilInherit': '从安全需求继承，禁止静默降级',
  'pages.requirements.hint.calMissing': '网络安全概念缺失时允许为空，请提示补齐',
  'pages.requirements.hint.originExternal': '外部输入必须填写出处（文档名或条款号）',
  'pages.requirements.hint.originManual': '手工录入无上游',
  'pages.requirements.hint.unlinkedNeutral': '未挂接上游是合法状态，追溯矩阵中以中性标签呈现',
  'pages.requirements.empty': '还没有需求条目，点击「新增需求」开始录入',
  'pages.requirements.saveConflict': '以下需求已被其他页面或同事修改，请刷新后再保存',
  'pages.requirements.saveFailed': '保存失败',
  'pages.requirements.saved': '保存成功',
  'pages.requirements.deleteConfirm': '确认删除需求 {{id}}？删除后可从历史版本找回',
  'pages.requirements.resetConfirm': '确认清空本过程的全部需求行？',
  'pages.requirements.deleted': '已删除（保存后生效）',
  'pages.requirements.pendingDeleteTag': '待删除',
  'pages.requirements.upstreamCount': '{{count}} 条上游',
  'pages.requirements.ownerScope':
    '本页只展示并编辑 {process} 名下的需求；其他过程的行在追溯矩阵页聚合展示',
  'pages.requirements.export': '导出 Excel',
  'pages.requirements.publish': '发布到工作成果',
  'pages.requirements.republish': '重新生成工作成果',
  'pages.requirements.publishedTag': '已发布 {{version}}',
  'pages.requirements.stale': '数据已变更，请重新生成',
  'pages.requirements.publishDone': '已{{action}}工作成果文档（版本 {{version}}）',
  'pages.requirements.publishAction.created': '生成',
  'pages.requirements.publishAction.updated': '更新',
  'pages.requirements.publishAction.upgraded': '升版',
  'pages.requirementsReport.filePrefix': '需求规格',
  'pages.requirementsReport.docTitle': '需求规格',
  'pages.requirementsReport.sheetRequirements': '1 需求清单',
  'pages.requirementsReport.none': '（无）',

  // ---- SYS.3 架构设计与概念基线（P1-d） ----
  'pages.sys3.title': '架构设计',
  'pages.sys3.conceptTitle': '概念基线',
  'pages.sys3.tabElements': '架构树',
  'pages.sys3.tabElementsSw': '软件组件',
  'pages.sys3.tabInterfaces': '接口清单',
  'pages.sys3.tabAllocations': '需求分配矩阵',
  'pages.sys3.tabMechanisms': '安全机制清单',
  'pages.sys3.tabSafeStates': '安全状态与转换',
  'pages.sys3.elementsTitle': '架构树：系统 → 硬件 / 软件 / 机械 / 外部 要素',
  'pages.sys3.elementsTitleSw': '软件架构树：应用层 → 服务 / 中间件 / 基础软件 组件',
  'pages.sys3.interfacesTitle': '接口清单：要素之间的信号、电源、总线等接口',
  'pages.sys3.interfacesTitleSw': '软件接口清单：软件组件之间的信号、服务等接口',
  'pages.sys3.allocationsTitle': '需求分配矩阵：SYS.2 需求 × 架构要素的落点',
  'pages.sys3.allocationsTitleSw': '需求分配矩阵：SWE.1 软件需求 × 软件组件的落点',
  'pages.sys3.mechanismsTitle': '安全机制清单：检测对象、方式、响应动作与故障处理时间',
  'pages.sys3.safeStatesTitle': '安全状态与转换：进入 / 退出条件与关联安全目标（HARA 只读引用）',
  'pages.sys3.colId': '编号',
  'pages.sys3.colName': '名称',
  'pages.sys3.colType': '类型',
  'pages.sys3.colParent': '父要素',
  'pages.sys3.colAsil': 'ASIL',
  'pages.sys3.colDescription': '描述',
  'pages.sys3.colSource': '源要素',
  'pages.sys3.colTarget': '目标要素',
  'pages.sys3.colRequirement': '需求',
  'pages.sys3.colElement': '架构要素',
  'pages.sys3.colElementSw': '软件组件',
  'pages.sys3.colMechanisms': '安全机制',
  'pages.sys3.colNote': '备注',
  'pages.sys3.colDetectionTarget': '检测对象',
  'pages.sys3.colDetectionMethod': '检测方式',
  'pages.sys3.colResponseAction': '响应动作',
  'pages.sys3.colFaultHandlingTime': '故障处理时间',
  'pages.sys3.colRelatedTsr': '关联 TSR',
  'pages.sys3.colStatus': '状态',
  'pages.sys3.colEntryCondition': '进入条件',
  'pages.sys3.colExitCondition': '退出条件',
  'pages.sys3.colRelatedSg': '关联安全目标',
  'pages.sys3.colTransitionDeadline': '转换时限',
  'pages.sys3.colSafeState': '安全状态',
  'pages.sys3.addRow': '新增',
  'pages.sys3.editRow': '编辑',
  'pages.sys3.deleteRowConfirm': '确认删除该行？保存后生效，可从历史版本找回',
  'pages.sys3.colActions': '操作',
  'pages.sys3.emptyTable': '暂无{{title}}，点击「新增」开始录入',
  'pages.sys3.loading': '加载中…',
  'pages.sys3.save': '保存',
  'pages.sys3.saved': '保存成功',
  'pages.sys3.saveFailed': '保存失败',
  'pages.sys3.reload': '刷新',
  'pages.sys3.reset': '清空',
  'pages.sys3.resetConfirm': '确认清空架构设计数据？清空前会自动归档，可从历史版本找回',
  'pages.sys3.conflictTitle': '数据已被其他人修改',
  'pages.sys3.conflictContent': '服务端数据比当前页面新，为避免覆盖请刷新后再编辑',
  'pages.sys3.conflictReload': '刷新页面',
  'pages.sys3.consistencyErrors': '一致性问题',
  'pages.sys3.consistencyWarnings': '提示',
  'pages.sys3.consistencyBanner': '一致性检查发现 {{count}} 条提示（只报事实，不阻断保存）',
  'pages.sys3.fhtHint': '如：100ms（对齐 FTTI）',
  'pages.sys3.deadlineHint': '如：200ms（对齐 FTTI）',
  'pages.sys3.noSg': '未关联',
  'pages.sys3.sgInvalidHint': '关联的安全目标在 HARA 中不存在，请核对编号',
  'pages.sys3.enum.SYSTEM': '系统',
  'pages.sys3.enum.HARDWARE': '硬件',
  'pages.sys3.enum.SOFTWARE': '软件',
  'pages.sys3.enum.MECHANICAL': '机械',
  'pages.sys3.enum.EXTERNAL': '外部',
  'pages.sys3.enum.OTHER_TECH': '其他技术',
  'pages.sys3.enum.SIGNAL': '信号',
  'pages.sys3.enum.POWER': '电源',
  'pages.sys3.enum.BUS': '总线',
  'pages.sys3.enum.DIAGNOSTIC': '诊断',
  'pages.sys3.enum.OTHER': '其他',
  'pages.sys3.enum.PLANNED': '规划中',
  'pages.sys3.enum.IN_DESIGN': '设计中',
  'pages.sys3.enum.IMPLEMENTED': '已实现',
  'pages.sys3.enum.VERIFIED': '已验证',
  'pages.sys3.enum.IN': '输入',
  'pages.sys3.enum.OUT': '输出',
  'pages.sys3.enum.BIDIR': '双向',
  // S3：管脚 I/O 与接插件/内设枚举
  'pages.sys3.enum.DI': '数字输入',
  'pages.sys3.enum.DO': '数字输出',
  'pages.sys3.enum.AI': '模拟输入',
  'pages.sys3.enum.AO': '模拟输出',
  'pages.sys3.enum.PWM': 'PWM',
  'pages.sys3.enum.GND': '地',
  'pages.sys3.enum.MIXED': '混合',
  'pages.sys3.enum.INTERNAL': '内设',
  'pages.sys3.enum.ACTIVE': '在用',
  'pages.sys3.enum.RETIRED': '已归档',
  'pages.sys3.enum.STRUCTURE': '分层结构',
  'pages.sys3.enum.CONTEXT': '上下文',
  'pages.sys3.enum.DEPLOY': '部署',
  'pages.sys3.enum.DATAFLOW': '数据流',
  'pages.sys3.enum.STATE': '状态机',
  'pages.sys3.conceptTabBaseline': '概念基线引用',
  'pages.sys3.conceptTabTsc': 'TSC 聚合',
  'pages.sys3.conceptReadonlyHint':
    '概念基线为只读引用：初步架构来自 FSC，安全目标与 FSR 来自 HARA，均不在此页编辑。',
  'pages.sys3.tscReadonlyHint':
    '技术安全概念聚合视图（只读）：安全需求来自 SYS.2，机制与状态来自本页架构设计，可导出不可编辑。',
  'pages.sys3.conceptArchitecture': 'FSC 初步架构要素',
  'pages.sys3.conceptGoals': '安全目标（HARA）',
  'pages.sys3.conceptFsrs': '功能安全需求（FSR）',
  'pages.sys3.conceptNoFsc': 'FSC 过程还没有录入初步架构，本视图为空是合法状态',
  'pages.sys3.tscRequirements': '安全相关需求（SYS.2）',
  'pages.sys3.tscMechanisms': '安全机制',
  'pages.sys3.tscSafeStates': '安全状态与转换',
  'pages.sys3.tscFilePrefix': '技术安全概念',
  'pages.sys3.exportExcel': '导出 Excel',

  // ---- 架构工作台（S1：图文同屏，树 / 画布 / 属性 / 联动表） ----
  'pages.sys3.ws.modeWorkspace': '架构工作台',
  'pages.sys3.ws.modeTable': '明细表',
  'pages.sys3.ws.modeHint':
    '工作台里图与表是同一份数据的两种投影：树与属性面板改数据，画布只决定摆放，保存时一起落库。',
  'pages.sys3.ws.unnamed': '未命名',
  'pages.sys3.ws.searchPlaceholder': '搜索编号或名称',
  'pages.sys3.ws.treeEmpty': '还没有架构要素，先到「明细表」录入或由需求生成',
  'pages.sys3.ws.inspectorEmpty': '在左侧选择一个要素，这里显示并可编辑它的属性',
  'pages.sys3.ws.linkedTitle': '关联记录',
  'pages.sys3.ws.linkedInterfaces': '接口',
  'pages.sys3.ws.linkedAllocations': '需求分配',
  'pages.sys3.ws.linkedMechanisms': '安全机制',
  'pages.sys3.ws.linkedEmpty': '暂无记录',
  'pages.sys3.ws.pickElementHint': '当前显示全部记录；选中一个要素后只看与它相关的行',
  'pages.sys3.ws.parentNone': '无（顶层）',
  'pages.sys3.ws.dirty': '有未保存的修改',
  'pages.sys3.ws.savedAll': '架构数据与架构图已保存',
  'pages.sys3.ws.exportFailed': '图上改动未能导出，本次只保存了属性',
  'pages.sys3.ws.canvasHint':
    '画布只决定摆放位置；要素的编号 / 名称 / 类型 / ASIL 一律以左侧树和右侧属性为准',
  'pages.sys3.ws.needEngine': '绘图引擎还没就绪，请稍后再试',
  'pages.sys3.ws.conflict': '数据已被其他人修改，请刷新后再编辑',

  // ---- 架构工作台 S2：双编号 / 多视图 / 软删除 ----
  'pages.sys3.ws.code': '要素编号',
  'pages.sys3.ws.codeHint': '对外编号，可随时改；内部 ID 不变，已有引用不会断',
  'pages.sys3.ws.idImmutable': '内部 ID，创建后不可更改——接口、分配与图上图形都按它挂接',
  'pages.sys3.ws.groupExplain': '说明',
  'pages.sys3.ws.layer': '层级',
  'pages.sys3.ws.layerPlaceholder': '如 系统 / 子系统 / 组件',
  'pages.sys3.ws.summary': '一句话摘要',
  'pages.sys3.ws.summaryPlaceholder': '一句话说清它负责什么',
  'pages.sys3.ws.decompNote': '分解说明',
  'pages.sys3.ws.decompHint': '为什么这样拆分（评审时最先被问到的就是这条）',
  'pages.sys3.ws.remark': '备注',
  'pages.sys3.ws.archive': '归档',
  'pages.sys3.ws.archiveConfirm': '归档这个要素？',
  'pages.sys3.ws.archiveConfirmDesc':
    '归档后默认不显示，可随时恢复；历史接口与需求分配不会断，也不会被物理删除。',
  'pages.sys3.ws.archived': '已归档，可随时恢复',
  'pages.sys3.ws.restore': '恢复使用',
  'pages.sys3.ws.restored': '已恢复',
  'pages.sys3.ws.retired': '已归档',
  'pages.sys3.ws.showRetired': '显示已归档 {{count}}',
  'pages.sys3.ws.hideRetired': '隐藏已归档',
  'pages.sys3.ws.createChild': '在 {{name}} 下新建要素',
  'pages.sys3.ws.createRoot': '新建顶层要素',
  'pages.sys3.ws.newElement': '新建要素',
  'pages.sys3.ws.noView': '还没有视图',
  'pages.sys3.ws.noViewDesc': '还没有架构图：点「一键生成」按要素树画一张，或先新建一个视图',
  'pages.sys3.ws.noViewHint': '建议按分层 / 部署 / 数据流各建一张',
  'pages.sys3.ws.newView': '新建视图',
  'pages.sys3.ws.newViewName': '视图 {{index}}',
  'pages.sys3.ws.defaultView': '默认视图',
  'pages.sys3.ws.renameView': '重命名视图',
  'pages.sys3.ws.deleteView': '删除视图',
  'pages.sys3.ws.deleteViewTitle': '删除视图「{{name}}」？',
  'pages.sys3.ws.deleteViewDesc': '只删这张图，要素数据和其他视图都不受影响。',
  'pages.sys3.ws.keepOneView': '至少要保留一个视图',
  'pages.sys3.ws.viewNameRequired': '视图名称不能为空',
  'pages.sys3.ws.viewNamePlaceholder': '视图名称',
  'pages.sys3.ws.viewCount': '共 {{count}} 个视图',
  'pages.sys3.ws.saveBeforeSwitch': '有未保存的改动，先保存再切换视图',
  'pages.sys3.ws.colProtocol': '协议',
  'pages.sys3.ws.colSignal': '信号名',
  'pages.sys3.ws.colDirection': '方向',
  'pages.sys3.ws.dataElement': '数据元素',
  'pages.sys3.ws.internalId': '内部 ID',

  // ---- 架构工作台 S3：接口设计（5.x）+ 非功能性需求（6） ----
  'pages.sys3.ws.modeInterfaces': '接口设计',
  'pages.sys3.ws.modeNfr': '非功能需求',
  'pages.sys3.ws.saveBeforeLeave': '有未保存的修改，先保存再切换',
  // S3.5：静态 / 动态视图分族
  'pages.sys3.ws.groupStatic': '静态架构',
  'pages.sys3.ws.groupDynamic': '动态架构',
  'pages.sys3.ws.kind.FBD': '功能框图',
  'pages.sys3.ws.kind.ELECTRICAL': '电气架构图',
  'pages.sys3.ws.kind.PHYSICAL': '物理架构图',
  'pages.sys3.ws.kind.CONTEXT': '上下文图',
  'pages.sys3.ws.kind.DEPLOY': '部署图',
  'pages.sys3.ws.kind.DATAFLOW': '数据流图',
  'pages.sys3.ws.kind.STATE': '状态机图',
  'pages.sys3.ws.kind.SEQUENCE': '时序图',
  'pages.sys3.ws.kind.OTHER': '其他',
  'pages.sys3.ws.viewKind': '视图类别',
  'pages.sys3.ws.createView': '新建视图',
  'pages.sys3.ws.viewNameIndexed': '{{name}} {{index}}',
  'pages.sys3.ws.staticKindTip': '静态图由要素表投影而来，可一键生成初版、可做图形同步',
  'pages.sys3.ws.dynamicViewHint':
    '这是行为视图：手动绘制状态流转与交互时序，不参与要素同步（图上的编号会与要素表对照）',
  'pages.sys3.ws.dynamicEmptyDesc':
    '行为图没有可生成的初版，直接开始画；框里写上要素编号即可与表格对应',
  'pages.sys3.ws.dynamicNoGenerate': '动态视图只能手绘：它画的不是要素清单，没有可生成的初版',
  'pages.sys3.ws.bindStat': '已绑定 {{bound}}/{{total}}',
  'pages.sys3.ws.bindTip':
    '图上有 {{unbound}} 个图形没挂要素编号、{{unknown}} 个编号在表里还不存在；编号写在图形标签首行即可绑定',
  'pages.sys3.ws.onCanvas': '该要素已画在图上',
  'pages.sys3.ws.toggleTree': '收起 / 展开要素树',
  'pages.sys3.ws.toggleInspector': '收起 / 展开属性面板',
  'pages.sys3.ws.toggleLinked': '收起 / 展开联动表',
  'pages.sys3.ws.fullscreen': '全屏绘图',
  'pages.sys3.ws.exitFullscreen': '退出全屏',
  'pages.sys3.io.hint':
    '模板第 5 章的四张表本来就来自 Excel（原理图、引脚分配表、线束表）：优先用「导入 Excel」搬运，空白表才手填。导入只是填表，仍需点「保存」才写入。',
  'pages.sys3.io.tabSignals': '信号接口',
  'pages.sys3.io.tabConnectors': '接插件管脚',
  'pages.sys3.io.tabChipPins': '芯片管脚',
  'pages.sys3.io.tabPeripherals': 'CPU 配置',
  'pages.sys3.io.signalsTitle': '信号接口：源 → 目标，含协议 / 信号名 / 方向',
  'pages.sys3.io.connectorsTitle': '接插件清单（5.1 的分组维度）',
  'pages.sys3.io.pinsTitle': '接插件管脚明细（管脚号在同一接插件内唯一）',
  'pages.sys3.io.chipPinsTitle': '芯片管脚定义（基本信息 · 硬件识别 · 软件识别）',
  'pages.sys3.io.internal': '内设（5.3）',
  'pages.sys3.io.external': '外设（5.4）',
  'pages.sys3.io.internalTitle': 'CPU 内设配置（5.3）',
  'pages.sys3.io.externalTitle': 'CPU 外设配置（5.4）',
  'pages.sys3.io.nfrTitle': '非功能性需求（6）',
  'pages.sys3.io.nfrHint':
    '性能 / 可靠性 / 资源这类指标由哪个要素承载、怎么实现。与需求分配矩阵分工不同：那张表管功能需求落到哪个要素。',
  'pages.sys3.io.colConnectorName': '接插件名称',
  'pages.sys3.io.colLocation': '安装位置',
  'pages.sys3.io.colMate': '对接件',
  'pages.sys3.io.colConnector': '所属接插件',
  'pages.sys3.io.colIo': 'I/O',
  'pages.sys3.io.colPinNo': '管脚号',
  'pages.sys3.io.colPinName': '管脚名称',
  'pages.sys3.io.colFunction': '功能说明',
  'pages.sys3.io.colElectrical': '电气特性',
  'pages.sys3.io.colDefault': '默认值',
  'pages.sys3.io.colConnectTo': '连接对象',
  'pages.sys3.io.colChip': '所属芯片',
  'pages.sys3.io.colOwner': '所属要素',
  'pages.sys3.io.colHwId': 'HW 识别号',
  'pages.sys3.io.colHwIdShort': 'HW ID',
  'pages.sys3.io.colHwChar': '输入输出特性',
  'pages.sys3.io.colHwDefault': '初始默认状态',
  'pages.sys3.io.colSwId': 'SW 识别号',
  'pages.sys3.io.colSwConfig': '功能配置',
  'pages.sys3.io.colConfigPath': '配置途径',
  'pages.sys3.io.colParam1': '配置参数 1',
  'pages.sys3.io.colParam2': '配置参数 2',
  'pages.sys3.io.colParam3': '配置参数 3',
  'pages.sys3.io.colParam4': '配置参数 4',
  'pages.sys3.io.colNfrCode': 'NFR 编号',
  'pages.sys3.io.colNfrText': '需求描述',
  'pages.sys3.io.colNfrElements': '承载要素',
  'pages.sys3.io.colNfrMethod': '实现方法',
  'pages.sys3.io.importConnectors': '导入接插件',
  'pages.sys3.io.importPins': '导入管脚',
  'pages.sys3.io.importChipPins': '导入芯片管脚',
  'pages.sys3.io.importPeripherals': '导入配置',
  'pages.sys3.io.importNfrs': '导入 NFR',
  'pages.sys3.io.title': '导入 Excel · {{label}}',
  'pages.sys3.io.uploadHint': '把 Excel 拖到这里，或点击选择文件',
  'pages.sys3.io.uploadSubHint': '只支持 .xlsx；先下载模板可保证列名被正确识别',
  'pages.sys3.io.parsing': '解析中…',
  'pages.sys3.io.parseFailed': '解析失败：请确认文件是 .xlsx 且包含表头行',
  'pages.sys3.io.templateFailed': '模板下载失败',
  'pages.sys3.io.rechoose': '重新选择文件',
  'pages.sys3.io.sheet': '工作表',
  'pages.sys3.io.headerRow': '表头行',
  'pages.sys3.io.parsed': '可导入',
  'pages.sys3.io.skipped': '已跳过',
  'pages.sys3.io.mapped': '识别到的列',
  'pages.sys3.io.unmapped': '未识别（忽略）',
  'pages.sys3.io.missingRequired': '缺少必填列：{{fields}}，请改表头或下载模板对照',
  'pages.sys3.io.unresolvedConnectors': '以下接插件不存在：{{names}}',
  'pages.sys3.io.unresolvedBlocked':
    '还有接插件没解析：勾选「自动创建缺失接插件」，或先在接插件表里建好再导入',
  'pages.sys3.io.issues': '校验提示（{{count}} 条，最多显示 30 条）',
  'pages.sys3.io.rowLabel': '第 {{row}} 行',
  'pages.sys3.io.preview': '数据预览（前 {{count}} 行）',
  'pages.sys3.io.downloadTemplate': '下载模板',
  'pages.sys3.io.modeAppend': '追加到现有数据',
  'pages.sys3.io.modeReplace': '覆盖现有数据（旧行归档）',
  'pages.sys3.io.autoCreateConnectors': '自动创建缺失的接插件（按名称）',
  'pages.sys3.io.applyCount': '导入 {{count}} 条',
  'pages.sys3.io.applied': '已导入 {{count}} 条，点「保存」写入',

  // ---- SWE.3 软件详细设计（P2-c：单元清单 / 详细设计 / 需求分配） ----
  'pages.swe3.tabTitle': '详细设计',
  'pages.swe3.tabUnits': '软件单元清单',
  'pages.swe3.tabDesigns': '详细设计',
  'pages.swe3.tabAllocations': '需求分配',
  'pages.swe3.unitsTitle': '软件单元清单',
  'pages.swe3.designsTitle': '详细设计',
  'pages.swe3.allocationsTitle': '需求分配',
  'pages.swe3.colId': '编号',
  'pages.swe3.colName': '名称',
  'pages.swe3.colComponent': '所属组件',
  'pages.swe3.colUnitType': '单元类型',
  'pages.swe3.colLanguage': '实现语言',
  'pages.swe3.colAsil': 'ASIL 能力',
  'pages.swe3.colFilePath': '实现文件',
  'pages.swe3.colDescription': '职责描述',
  'pages.swe3.colUnit': '软件单元',
  'pages.swe3.colDesignType': '设计类型',
  'pages.swe3.colDesignDescription': '设计描述',
  'pages.swe3.colInterfaceSpec': '接口与依赖',
  'pages.swe3.colErrorHandling': '错误处理',
  'pages.swe3.colResourceConstraint': '资源约束',
  'pages.swe3.colReviewStatus': '评审状态',
  'pages.swe3.colRequirement': '软件需求',
  'pages.swe3.colNote': '备注',
  'pages.swe3.addRow': '新增',
  'pages.swe3.editRow': '编辑',
  'pages.swe3.deleteRowConfirm': '确定删除这一行吗？',
  'pages.swe3.colActions': '操作',
  'pages.swe3.emptyTable': '「{{title}}」还没有内容',
  'pages.swe3.loading': '加载中…',
  'pages.swe3.save': '保存',
  'pages.swe3.reload': '刷新',
  'pages.swe3.reset': '清空',
  'pages.swe3.saved': '已保存',
  'pages.swe3.saveFailed': '保存失败',
  'pages.swe3.conflictTitle': '数据已被更新',
  'pages.swe3.conflictContent': '服务端数据已被其他页面或同事更新，为避免覆盖请刷新后再改。',
  'pages.swe3.conflictReload': '刷新',
  'pages.swe3.resetConfirm': '确定清空 SWE.3 详细设计的全部数据吗？（清空前会归档）',
  'pages.swe3.consistencyErrors': '一致性问题',
  'pages.swe3.consistencyWarnings': '提示',
  'pages.swe3.consistencyBanner': '一致性检查发现 {{count}} 条提示（只报事实，不阻断保存）',
  'pages.swe3.summaryLine': '单元 {{units}} · 详细设计 {{designs}} · 需求分配 {{allocations}}',
  'pages.swe3.unitWithoutDesign': '{{count}} 个单元未设计',
  'pages.swe3.unitWithoutAllocation': '{{count}} 个单元未分配需求',
  'pages.swe3.noComponents': 'SWE.2 还没有软件组件：单元可以先录入，之后再补「所属组件」。',
  'pages.swe3.enum.FUNCTION': '函数',
  'pages.swe3.enum.CLASS': '类',
  'pages.swe3.enum.MODULE': '模块',
  'pages.swe3.enum.ISR': '中断',
  'pages.swe3.enum.LIBRARY': '库',
  'pages.swe3.enum.OTHER': '其他',
  'pages.swe3.enum.STATE_MACHINE': '状态机',
  'pages.swe3.enum.SEQUENCE': '时序',
  'pages.swe3.enum.ALGORITHM': '算法',
  'pages.swe3.enum.DATA_STRUCTURE': '数据结构',
  'pages.swe3.enum.DRAFT': '草稿',
  'pages.swe3.enum.IN_REVIEW': '评审中',
  'pages.swe3.enum.REVIEWED': '已评审',
  'pages.swe3.enum.APPROVED': '已批准',
  // P2-d：HWE.2 硬件设计（硬件架构 / 元器件选型 / 安全机制 / 需求分配）
  'pages.hwe2.tabTitle': '硬件设计',
  'pages.hwe2.loading': '加载硬件设计数据…',
  'pages.hwe2.tabElements': '硬件架构',
  'pages.hwe2.tabComponents': '元器件选型',
  'pages.hwe2.tabMechanisms': '安全机制',
  'pages.hwe2.tabAllocations': '需求分配',
  'pages.hwe2.elementsTitle': '硬件架构要素',
  'pages.hwe2.componentsTitle': '元器件选型清单',
  'pages.hwe2.mechanismsTitle': '硬件安全机制清单',
  'pages.hwe2.allocationsTitle': '硬件需求分配',
  'pages.hwe2.colId': '编号',
  'pages.hwe2.colName': '名称',
  'pages.hwe2.colElementType': '要素类型',
  'pages.hwe2.colParent': '父要素',
  'pages.hwe2.colSystemElement': '系统架构要素',
  'pages.hwe2.colAsil': 'ASIL 能力',
  'pages.hwe2.colDescription': '说明',
  'pages.hwe2.colCategory': '器件类别',
  'pages.hwe2.colElement': '所属要素',
  'pages.hwe2.colManufacturer': '厂商',
  'pages.hwe2.colPartNumber': '料号',
  'pages.hwe2.colPackage': '封装',
  'pages.hwe2.colKeySpec': '关键参数',
  'pages.hwe2.colTempRange': '工作温度',
  'pages.hwe2.colQualification': '车规认证',
  'pages.hwe2.colFailureRate': '失效率（FIT）',
  'pages.hwe2.colComponentStatus': '选型状态',
  'pages.hwe2.colDetectionTarget': '检测对象',
  'pages.hwe2.colDetectionMethod': '检测方式',
  'pages.hwe2.colResponseAction': '响应动作',
  'pages.hwe2.colFaultHandlingTime': '故障处理时间',
  'pages.hwe2.colRelatedRequirement': '关联硬件需求',
  'pages.hwe2.colMechanismStatus': '状态',
  'pages.hwe2.colRequirement': '需求编号',
  'pages.hwe2.colMechanisms': '安全机制',
  'pages.hwe2.colNote': '备注',
  'pages.hwe2.addRow': '新增',
  'pages.hwe2.editRow': '编辑',
  'pages.hwe2.deleteRowConfirm': '确定删除这一行吗？',
  'pages.hwe2.colActions': '操作',
  'pages.hwe2.emptyTable': '{{title}}还没有内容，点右上角「新增」开始录入。',
  'pages.hwe2.save': '保存',
  'pages.hwe2.saved': '硬件设计已保存',
  'pages.hwe2.saveFailed': '保存失败',
  'pages.hwe2.reset': '清空',
  'pages.hwe2.reload': '刷新',
  'pages.hwe2.conflictTitle': '数据已被更新',
  'pages.hwe2.conflictContent': '服务端数据已被其他页面或同事更新，为避免覆盖请刷新后再改。',
  'pages.hwe2.conflictReload': '刷新',
  'pages.hwe2.resetConfirm': '确定清空 HWE.2 硬件设计的全部数据吗？（清空前会归档）',
  'pages.hwe2.consistencyErrors': '一致性问题',
  'pages.hwe2.consistencyWarnings': '提示',
  'pages.hwe2.consistencyBanner': '一致性检查发现 {{count}} 条提示（只报事实，不阻断保存）',
  'pages.hwe2.summaryLine':
    '要素 {{elements}} · 元器件 {{components}} · 安全机制 {{mechanisms}} · 需求分配 {{allocations}}',
  'pages.hwe2.elementWithoutComponent': '{{count}} 个要素无元器件',
  'pages.hwe2.elementWithoutAllocation': '{{count}} 个要素未分配需求',
  'pages.hwe2.selectedWithoutPart': '{{count}} 个已选型器件缺料号',
  'pages.hwe2.noRequirements': 'HWE.1 还没有硬件需求：要素与元器件可以先录入，分配之后再补。',
  'pages.hwe2.enum.SUBSYSTEM': '子系统',
  'pages.hwe2.enum.CIRCUIT': '电路',
  'pages.hwe2.enum.MODULE': '模块',
  'pages.hwe2.enum.SENSOR': '传感器',
  'pages.hwe2.enum.ACTUATOR': '执行器',
  'pages.hwe2.enum.POWER': '电源',
  'pages.hwe2.enum.PCB': '电路板',
  'pages.hwe2.enum.CONNECTOR': '连接器',
  'pages.hwe2.enum.OTHER': '其他',
  'pages.hwe2.enum.MCU': 'MCU',
  'pages.hwe2.enum.SOC': 'SoC',
  'pages.hwe2.enum.POWER_IC': '电源芯片',
  'pages.hwe2.enum.ANALOG_IC': '模拟芯片',
  'pages.hwe2.enum.DIGITAL_IC': '数字芯片',
  'pages.hwe2.enum.PASSIVE': '无源器件',
  'pages.hwe2.enum.AEC_Q100': 'AEC-Q100',
  'pages.hwe2.enum.AEC_Q101': 'AEC-Q101',
  'pages.hwe2.enum.AEC_Q200': 'AEC-Q200',
  'pages.hwe2.enum.NONE': '非车规',
  'pages.hwe2.enum.TBD': '待确认',
  'pages.hwe2.enum.CANDIDATE': '候选',
  'pages.hwe2.enum.SELECTED': '已选定',
  'pages.hwe2.enum.OBSOLETE': '已停产',
  'pages.hwe2.enum.REJECTED': '已弃用',
  'pages.hwe2.enum.PLANNED': '规划中',
  'pages.hwe2.enum.IN_DESIGN': '设计中',
  'pages.hwe2.enum.IMPLEMENTED': '已实现',
  'pages.hwe2.enum.VERIFIED': '已验证',

  // ---- P2-e 架构图形编辑器（V2.4 规划第 10 章）----
  'pages.archDiagram.viewList': '列表视图',
  'pages.archDiagram.viewDiagram': '图形视图',
  'pages.archDiagram.generate': '一键生成初版图',
  'pages.archDiagram.blank': '空白画布',
  'pages.archDiagram.save': '保存图',
  'pages.archDiagram.sync': '同步',
  'pages.archDiagram.refresh': '刷新',
  'pages.archDiagram.elementCount': '图面要素 {{count}}',
  'pages.archDiagram.generateDone': '已生成初版图，共 {{count}} 个要素；保存后可继续编辑',
  'pages.archDiagram.generateFailed': '生成初版图失败',
  'pages.archDiagram.loadFailed': '加载架构图失败',
  'pages.archDiagram.notReady': '绘图引擎还没加载完成，请稍后再试',
  'pages.archDiagram.saved': '架构图已保存',
  'pages.archDiagram.saveFailed': '保存架构图失败',
  'pages.archDiagram.syncFailed': '同步比对失败',
  'pages.archDiagram.exportEmpty': '没有取到图形数据，请稍后重试',
  'pages.archDiagram.syncApplied': '已按确认结果写回，共处理 {{count}} 项',
  'pages.archDiagram.syncApplyFailed': '同步写回失败',
  'pages.archDiagram.degradedTitle': '图形编辑器不可用，已切回列表视图',
  'pages.archDiagram.degradedDesc':
    '项目或全局未启用图形架构编辑器（ARCH_DIAGRAM_ENABLED），列表视图功能不受影响。',
  'pages.archDiagram.timeoutTitle': '绘图服务响应超时，已切回列表视图',
  'pages.archDiagram.timeoutDesc':
    '绘图引擎首次加载较慢或当前网络不可达，可以点「重试」重新打开图形视图。列表视图功能不受影响。',
  'pages.archDiagram.unavailableTitle': '本地绘图资源未安装，已切回列表视图',
  'pages.archDiagram.unavailableDesc':
    '同源绘图服务（/drawio/）还没有就位。请在项目根目录运行 python tools/setup_drawio.py 安装后再试。列表视图功能不受影响。',
  'pages.archDiagram.retry': '重试',
  'pages.archDiagram.engineLoading': '绘图引擎加载中，请稍候…',
  'pages.archDiagram.emptyTitle': '还没有架构图',
  'pages.archDiagram.emptyDesc':
    '可以从当前数据一键生成初版图（要素与层级自动摆好，编号自动带上），也可以从空白画布开始画',
  'pages.archDiagram.diffTitle': '同步差异确认',
  'pages.archDiagram.diffApply': '执行同步',
  'pages.archDiagram.diffCancel': '取消',
  'pages.archDiagram.diffScope':
    '图面 {{shapes}} 个图形 / {{edges}} 条连线；确认前不会写入任何数据',
  'pages.archDiagram.diffEmpty': '图与数据完全一致，没有需要同步的差异',
  'pages.archDiagram.colType': '差异类型',
  'pages.archDiagram.colSysId': '系统编号',
  'pages.archDiagram.colDiagram': '图上显示',
  'pages.archDiagram.colData': '数据集',
  'pages.archDiagram.colDetail': '说明',
  'pages.archDiagram.colAction': '处理方式',
  'pages.archDiagram.action.import': '导入为新要素',
  'pages.archDiagram.action.ignore': '忽略',
  'pages.archDiagram.action.keepData': '以数据为准',
  'pages.archDiagram.action.useDiagram': '以图为准改名',
  'pages.archDiagram.action.keep': '保留数据',
  'pages.archDiagram.action.acknowledge': '已知悉',
  'pages.archDiagram.kind.ELEMENT': '架构要素',
  'pages.archDiagram.kind.MECHANISM': '安全机制',
  'pages.archDiagram.kind.INTERFACE': '接口',
  'pages.archDiagram.kind.COMPONENT': '元器件',
  'pages.archDiagram.kind.UNIT': '软件单元',
  'pages.archDiagram.kind.MEASURE': '外部措施',
  'pages.sys3.doc.title': '架构设计文档',
  'pages.sys3.doc.save': '保存',
  'pages.sys3.doc.reload': '重新加载',
  'pages.sys3.doc.unsaved': '未保存',
  'pages.sys3.doc.issueCount': '{{count}} 条待确认',
  'pages.sys3.doc.issueBanner': '有 {{count}} 条一致性提示，保存不受影响',
  'pages.sys3.doc.newSection': '新增章节',
  'pages.sys3.doc.newSectionHint': '模板章节已预置，可继续按需添加',
  'pages.sys3.doc.emptyTab': '该页签还没有章节',
  'pages.sys3.doc.tab.STATIC': '系统静态设计',
  'pages.sys3.doc.tab.DYNAMIC': '系统动态设计',
  'pages.sys3.doc.tab.INTERFACE': '接口设计',
  'pages.sys3.doc.tab.NFR': '非功能需求设计',
  'pages.sys3.doc.tab.ALLOCATION': '需求分配',
  'pages.sys3.doc.tableOnly': '仅表格',
  'pages.sys3.doc.toggleCollapse': '折叠/展开本章',
  'pages.sys3.doc.moveUp': '上移',
  'pages.sys3.doc.moveDown': '下移',
  'pages.sys3.doc.removeSection': '删除本章',
  'pages.sys3.doc.removeConfirm': '确认删除这一章？',
  'pages.sys3.doc.removeHint': '只删章节与这张图，表格里的数据行不会被删除。',
  'pages.sys3.doc.renameSection': '修改章节标题',
  'pages.sys3.doc.sectionNamePlaceholder': '例如：系统电子电气图',
  'pages.sys3.doc.boundRatio': '已绑定 {{bound}}/{{total}}',
  'pages.sys3.doc.bindingTip': '图上写了编号的图形数 / 本章要素总数',
  'pages.sys3.doc.noTableBinding': '本章未绑定表格',
  'pages.sys3.doc.tableOf': '表格：{{name}}',
  'pages.sys3.doc.rowCount': '共 {{count}} 行',
  'pages.sys3.doc.onlyBound': '只看本图绑定（{{count}}）',
  'pages.sys3.doc.colLayer': '分层',
  'pages.sys3.doc.colDataElement': '数据元素',
  'pages.sys3.doc.rowBelongsToTable':
    '这里编辑的是主表记录：同一行在本图和其他章节看到的是同一条数据。',
  'pages.sys3.doc.hintElements': '还没有要素：点「新增」建一个，或在图上画框后写编号',
  'pages.sys3.doc.hintInterfaces': '还没有接口：先新增一条，或在图上连线后写接口编号',
  'pages.sys3.doc.hintConnectorPins': '还没有管脚行：按接插件逐个录入管脚号与连接对象',
  'pages.sys3.doc.hintChipPins': '还没有管脚行：按芯片录入管脚号、硬件资源与软件配置',
  'pages.sys3.doc.hintPeripherals': '还没有配置项：按内设/外设逐个录入配置参数',
  'pages.sys3.doc.hintNfrs': '还没有非功能需求：按「需求 → 承载要素 → 实现方法」录入',
  'pages.sys3.doc.hintAllocations': '还没有分配行：按「需求 → 要素」建立矩阵',
  'pages.sys3.doc.hintTransitions': '还没有状态迁移：按「源状态 → 目标状态 → 触发条件」录入',
  'pages.sys3.doc.hintSteps': '还没有时序动作：按「序号 / 执行组件 / 动作说明 / 使用接口」录入',
  'pages.sys3.doc.colConnector': '接插件',
  'pages.sys3.doc.colPinNo': '管脚号',
  'pages.sys3.doc.colPinName': '管脚名称',
  'pages.sys3.doc.colFunction': '功能说明',
  'pages.sys3.doc.colElectrical': '电气特性',
  'pages.sys3.doc.colConnectTo': '连接对象',
  'pages.sys3.doc.colDefault': '默认值',
  'pages.sys3.doc.colHwId': '硬件识别号',
  'pages.sys3.doc.colHwChar': '硬件输入输出特性',
  'pages.sys3.doc.colHwDefault': '初始默认状态',
  'pages.sys3.doc.colSwId': '软件识别号',
  'pages.sys3.doc.colSwConfig': '功能配置',
  'pages.sys3.doc.colConfigPath': '配置途径',
  'pages.sys3.doc.colParam1': '配置参数1',
  'pages.sys3.doc.colParam2': '配置参数2',
  'pages.sys3.doc.colParam3': '配置参数3',
  'pages.sys3.doc.colParam4': '配置参数4',
  'pages.sys3.doc.colNfrText': '需求描述',
  'pages.sys3.doc.colCarrier': '承载要素',
  'pages.sys3.doc.colMethod': '实现方法',
  'pages.sys3.doc.colFromState': '源状态',
  'pages.sys3.doc.colToState': '目标状态',
  'pages.sys3.doc.colTrigger': '触发条件',
  'pages.sys3.doc.colAction': '动作',
  'pages.sys3.doc.colStep': '序号',
  'pages.sys3.doc.colComponent': '执行组件',
  'pages.sys3.doc.colActionText': '动作说明',
  'pages.sys3.doc.colUseInterface': '使用接口',
  'pages.sys3.doc.kindInternal': '内设',
  'pages.sys3.doc.kindExternal': '外设',
  'pages.sys3.doc.engineDegraded': '画布降级',
  'pages.sys3.doc.generate': '生成初版',
  'pages.sys3.doc.generateHint': '按要素表重新生成这张图（会覆盖当前图面）',
  'pages.sys3.doc.bindingCheck': '绑定检查',
  'pages.sys3.doc.engineFallback': '图形引擎未能就绪，可重试或稍后再打开',
  'pages.sys3.doc.retry': '重试',
  'pages.sys3.doc.openToEdit': '点击打开画布继续编辑',
  'pages.sys3.doc.openCanvas': '打开画布',
  'pages.sys3.doc.emptyCanvas': '还没有图：打开画布手绘，或按要素一键生成',
  'pages.sys3.doc.noDiagram': '本章尚未出图',
  'pages.sys3.ws.colCode': '编号',
  'pages.sys3.fieldRequired': '此项必填',
  'pages.sys3.doc.tab.CONTROL': '控制策略设计',
  'pages.sys3.doc.tab.RESOURCE': '资源预估',
  'pages.sys3.doc.tab.SWE2.STATIC': '软件静态设计',
  'pages.sys3.doc.tab.SWE2.INTERFACE': '组件接口设计',
  'pages.sys3.doc.tab.SWE2.DYNAMIC': '软件动态设计',
  'pages.sys3.doc.tab.SWE2.NFR': '非功能性需求设计',
  'pages.sys3.doc.tab.SWE2.CONTROL': '软件控制策略',
  'pages.sys3.doc.tab.SWE2.RESOURCE': '资源预估',
  'pages.sys3.doc.tab.SWE2.ALLOCATION': '需求分配',
  'pages.sys3.doc.boundTable': '绑定表格',
  'pages.sys3.table.elements': '架构要素表',
  'pages.sys3.table.interfaces': '接口清单',
  'pages.sys3.table.modules': '模块清单',
  'pages.sys3.table.functions': '组件接口',
  'pages.sys3.table.signals': '接口信号',
  'pages.sys3.table.stateTransitions': '状态迁移',
  'pages.sys3.table.sequenceSteps': '时序动作',
  'pages.sys3.table.dataFlows': '功能数据流',
  'pages.sys3.table.nfrs': '非功能性需求',
  'pages.sys3.table.controlTimings': '响应时间设计',
  'pages.sys3.table.osTasks': '任务管理',
  'pages.sys3.table.isrs': '中断服务程序',
  'pages.sys3.table.memoryRegions': '内存管理',
  'pages.sys3.table.resourceBudgets': '内存预估',
  'pages.sys3.table.cpuLoads': 'CPU 负载率',
  'pages.sys3.table.allocations': '需求分配矩阵',
  'pages.sys3.table.connectors': '外部接插件',
  'pages.sys3.table.connectorPins': '接插件管脚',
  'pages.sys3.table.chipPins': '芯片管脚',
  'pages.sys3.table.peripherals': 'CPU 内设与外设',
  'pages.sys3.swe2.colSummary': '功能概要',
  'pages.sys3.swe2.colDevMode': '开发方式',
  'pages.sys3.swe2.colOwnerElement': '所属组件',
  'pages.sys3.swe2.colModule': '所属模块',
  'pages.sys3.swe2.colFunctionName': '函数名',
  'pages.sys3.swe2.colPrototype': '函数原型',
  'pages.sys3.swe2.colSyncMode': '调用形态',
  'pages.sys3.swe2.colReturnType': '返回值类型',
  'pages.sys3.swe2.colReentrant': '可重入',
  'pages.sys3.swe2.colTiming': '时序约束',
  'pages.sys3.swe2.colDataType': '数据类型',
  'pages.sys3.swe2.colValueRange': '值域范围',
  'pages.sys3.swe2.colRangeNote': '值域说明',
  'pages.sys3.swe2.colUnit': '单位',
  'pages.sys3.swe2.colInitialValue': '初始值',
  'pages.sys3.swe2.colFunctionOwner': '所属接口',
  'pages.sys3.swe2.colDataFlowDesc': '数据流说明',
  'pages.sys3.swe2.colBehaviorId': '动态行为 ID',
  'pages.sys3.swe2.colRequired': '必要性能/时间',
  'pages.sys3.swe2.colEstimated': '预估性能/时间',
  'pages.sys3.swe2.colBehaviorRef': '关联动态行为',
  'pages.sys3.swe2.colTaskName': '任务名',
  'pages.sys3.swe2.colPeriod': '周期',
  'pages.sys3.swe2.colPriority': '优先级',
  'pages.sys3.swe2.colRuntime': '运行时长',
  'pages.sys3.swe2.colCpuLoad': 'CPU 占用',
  'pages.sys3.swe2.colIsrName': '中断名称',
  'pages.sys3.swe2.colIsrSource': '中断源',
  'pages.sys3.swe2.colFrequency': '中断频率/事件',
  'pages.sys3.swe2.colDuty': '职责',
  'pages.sys3.swe2.colStartAddr': '起始地址',
  'pages.sys3.swe2.colEndAddr': '结束地址',
  'pages.sys3.swe2.colSize': '存储空间',
  'pages.sys3.swe2.colMemType': '存储类型',
  'pages.sys3.swe2.colAccess': '访问方式',
  'pages.sys3.swe2.colUsage': '项目中的用途',
  'pages.sys3.swe2.colTarget': '对象',
  'pages.sys3.swe2.colRom': 'ROM',
  'pages.sys3.swe2.colRamStatic': 'RAM·静态数据',
  'pages.sys3.swe2.colRamStack': 'RAM·栈',
  'pages.sys3.swe2.colRamHeap': 'RAM·堆',
  'pages.sys3.swe2.colFlash': 'Flash',
  'pages.sys3.swe2.colNvm': 'NVM',
  'pages.sys3.swe2.colScenario': '最糟糕工况',
  'pages.sys3.swe2.colBehaviors': '包含动态行为',
  'pages.sys3.swe2.colLoadTarget': '目标负载率',
  'pages.sys3.swe2.colLoadEstimate': '预估负载率',
  'pages.sys3.swe2.ramTotal': 'RAM 合计',
  'pages.sys3.swe2.summaryTotal': '合计',
  'pages.sys3.swe2.devMode.NEW': '新研',
  'pages.sys3.swe2.devMode.REUSE': '复用',
  'pages.sys3.swe2.devMode.CHANGE': '变更',
  'pages.sys3.swe2.devMode.PURCHASE': '采购',
  'pages.sys3.swe2.devMode.OUTSOURCE': '外包',
  'pages.sys3.swe2.syncMode.SYNC': '同步调用',
  'pages.sys3.swe2.syncMode.ASYNC': '异步回调',
  'pages.sys3.swe2.syncMode.ISR': '中断上下文',
  'pages.sys3.swe2.treeInput': '输入信号（{{count}}）',
  'pages.sys3.swe2.treeOutput': '输出信号（{{count}}）',
  'pages.sys3.swe2.treeFunctions': '{{count}} 个接口',
  'pages.sys3.swe2.treeOrphanFunctions': '未归属模块的接口（{{count}}）',
  'pages.sys3.swe2.treeOrphanSignals': '未归属接口的信号（{{count}}）',
  'pages.sys3.swe2.treeEmpty': '还没有模块与接口：先在本页签录入模块清单，再逐个模块加接口',
  'pages.sys3.swe2.hintModules': '这一章还没有模块，先按「模块 ID / 模块名 / 功能概要」录入',
  'pages.sys3.swe2.hintFunctions': '这一章还没有接口，按「函数原型 + 所属模块 + 接口功能说明」录入',
  'pages.sys3.swe2.hintSignals': '这一章还没有信号，按「信号名 / 数据类型 / 值域范围」录入',
  'pages.sys3.swe2.hintDataFlows':
    '这一章还没有数据流，按「序号 / 执行组件 / 数据流说明 / 调用接口」录入',
  'pages.sys3.swe2.hintControlTimings':
    '这一章还没有响应时间条目，按「动态行为 → 必要性能 → 预估性能」录入',
  'pages.sys3.swe2.hintTasks': '这一章还没有任务，按「任务名 / 周期 / 优先级」录入',
  'pages.sys3.swe2.hintIsrs': '这一章还没有中断，按「中断名称 / 中断源 / 优先级 / 职责」录入',
  'pages.sys3.swe2.hintMemoryRegions':
    '这一章还没有内存分区，按「起始地址 / 结束地址 / 存储类型」录入',
  'pages.sys3.swe2.hintResourceBudgets':
    '这一章还没有预估行，按「对象 / ROM / RAM / Flash」逐项估算',
  'pages.sys3.swe2.hintCpuLoads':
    '这一章还没有工况，按「最糟糕工况 / 目标负载率 / 预估负载率」录入',

  // ═══ S5：HWE.2 硬件架构（四层要素 / 供电·接地·EMC / FIT·SPFM·LFM·PMHF）═══
  'pages.sys3.hwTitle': '硬件架构设计',
  'pages.sys3.doc.tab.HWE2.STATIC': '硬件静态设计',
  'pages.sys3.doc.tab.HWE2.POWER': '供电与接地设计',
  'pages.sys3.doc.tab.HWE2.INTERFACE': '硬件接口设计',
  'pages.sys3.doc.tab.HWE2.SAFETY': '安全机制与度量',
  'pages.sys3.doc.tab.HWE2.ALLOCATION': '需求分配',
  'pages.sys3.doc.hwLevels': '硬件层级',
  'pages.sys3.doc.colHwLevel': '硬件层级',
  'pages.sys3.doc.hwLevelEmpty': '该层级还没有要素',
  'pages.sys3.table.hwComponents': '元器件清单',
  'pages.sys3.table.hwPowerNets': '供电与接地网络',
  'pages.sys3.table.hwEmcMeasures': 'EMC 措施',
  'pages.sys3.table.hwMetrics': '硬件架构度量',
  'pages.sys3.table.hwPinRefs': '管脚使用',
  // 四层坐标与硬件要素类型（沿用 pages.sys3.enum.*：要素表的类型列会按值取词）
  'pages.sys3.enum.ECU': '控制器',
  'pages.sys3.enum.BOARD': '板卡',
  'pages.sys3.enum.COMPONENT': '元器件',
  'pages.sys3.enum.GROUND': '地',
  'pages.sys3.enum.SUBSYSTEM': '子系统',
  'pages.sys3.enum.CIRCUIT': '电路',
  'pages.sys3.enum.MODULE': '模块',
  'pages.sys3.enum.SENSOR': '传感器',
  'pages.sys3.enum.ACTUATOR': '执行器',
  'pages.sys3.enum.PCB': 'PCB',
  'pages.sys3.enum.CONNECTOR': '接插件',
  'pages.sys3.hw.colCategory': '类别',
  'pages.sys3.hw.colPartNumber': '料号',
  'pages.sys3.hw.colManufacturer': '厂商',
  'pages.sys3.hw.colKeySpec': '关键参数',
  'pages.sys3.hw.colQualification': '车规认证',
  'pages.sys3.hw.colSelectStatus': '选型状态',
  'pages.sys3.hw.colOwnerElement': '所属要素',
  'pages.sys3.hw.colPackage': '封装',
  'pages.sys3.hw.colTempRange': '温度范围',
  'pages.sys3.hw.colNetName': '网络名',
  'pages.sys3.hw.colNetNameShort': '本板网络',
  'pages.sys3.hw.colNetKind': '类型',
  'pages.sys3.hw.colRail': '电源轨',
  'pages.sys3.hw.colVoltage': '电压',
  'pages.sys3.hw.colSource': '源 / 接地点',
  'pages.sys3.hw.colSourceElement': '源要素',
  'pages.sys3.hw.colConsumers': '负载',
  'pages.sys3.hw.colProtection': '保护',
  'pages.sys3.hw.colWireSpec': '线径 / 走线',
  'pages.sys3.hw.colGroundPoint': '接地点',
  'pages.sys3.hw.colEmcSource': '干扰源',
  'pages.sys3.hw.colCouplingPath': '耦合路径',
  'pages.sys3.hw.colEmcType': '措施类型',
  'pages.sys3.hw.colEmcMeasure': '具体措施',
  'pages.sys3.hw.colEmcResult': '验证结果',
  'pages.sys3.hw.colVerify': '验证方法',
  'pages.sys3.hw.colMetricTarget': '度量对象',
  'pages.sys3.hw.colMetricKind': '度量类型',
  'pages.sys3.hw.colMetricGoal': '目标值',
  'pages.sys3.hw.colMetricActual': '实际值',
  'pages.sys3.hw.colUnit': '单位',
  'pages.sys3.hw.colVerdict': '判定',
  'pages.sys3.hw.colDataSource': '数据来源',
  'pages.sys3.hw.colRefCode': 'SYS.3 管脚编号',
  'pages.sys3.hw.colPinSource': '来源',
  'pages.sys3.hw.colPinNo': '管脚号',
  'pages.sys3.hw.hintComponents': '这一章还没有元器件，按「料号 / 厂商 / 类别 / 关键参数」录入',
  'pages.sys3.hw.hintPowerNets':
    '这一章还没有网络，按「网络名 / 源 / 负载 / 电压」录入；供电与接地共用这张表，用类型区分',
  'pages.sys3.hw.hintEmc':
    '这一章还没有 EMC 措施，按「干扰源 / 耦合路径 / 措施类型 / 具体措施」录入',
  'pages.sys3.hw.hintMetrics':
    '这一章还没有度量行，按「度量对象 / 类型（SPFM、LFM、PMHF、FIT）/ 目标 / 实际」录入',
  'pages.sys3.hw.hintPinRefs':
    '这一章还没有管脚使用，按「引用 SYS.3 管脚编号 / 所属要素 / 网络」录入',
  'pages.sys3.hw.category.MCU': 'MCU',
  'pages.sys3.hw.category.SOC': 'SOC',
  'pages.sys3.hw.category.SENSOR': '传感器',
  'pages.sys3.hw.category.ACTUATOR': '执行器',
  'pages.sys3.hw.category.POWER_IC': '电源芯片',
  'pages.sys3.hw.category.ANALOG_IC': '模拟芯片',
  'pages.sys3.hw.category.DIGITAL_IC': '数字芯片',
  'pages.sys3.hw.category.PASSIVE': '阻容感',
  'pages.sys3.hw.category.CONNECTOR': '接插件',
  'pages.sys3.hw.category.PCB': 'PCB',
  'pages.sys3.hw.category.OTHER': '其他',
  'pages.sys3.hw.qualification.AEC_Q100': 'AEC-Q100（芯片）',
  'pages.sys3.hw.qualification.AEC_Q101': 'AEC-Q101（分立）',
  'pages.sys3.hw.qualification.AEC_Q200': 'AEC-Q200（被动）',
  'pages.sys3.hw.qualification.NONE': '未做车规',
  'pages.sys3.hw.qualification.TBD': '待确认',
  'pages.sys3.hw.status.CANDIDATE': '候选',
  'pages.sys3.hw.status.SELECTED': '已选定',
  'pages.sys3.hw.status.OBSOLETE': '已停产',
  'pages.sys3.hw.status.REJECTED': '已否决',
  'pages.sys3.hw.rail.KL30': 'KL30 常电',
  'pages.sys3.hw.rail.KL15': 'KL15 点火',
  'pages.sys3.hw.rail.KL31': 'KL31 地',
  'pages.sys3.hw.rail.VBAT': 'VBAT',
  'pages.sys3.hw.rail.5V': '5V',
  'pages.sys3.hw.rail.3V3': '3V3',
  'pages.sys3.hw.rail.1V8': '1V8',
  'pages.sys3.hw.rail.VREF': 'VREF',
  'pages.sys3.hw.rail.OTHER': '其他',
  'pages.sys3.hw.emcType.SHIELD': '屏蔽',
  'pages.sys3.hw.emcType.FILTER': '滤波',
  'pages.sys3.hw.emcType.TVS': 'TVS 管',
  'pages.sys3.hw.emcType.FERRITE': '磁珠',
  'pages.sys3.hw.emcType.CAP': '电容',
  'pages.sys3.hw.emcType.LAYOUT': '布局布线',
  'pages.sys3.hw.emcType.GROUNDING': '接地',
  'pages.sys3.hw.emcType.OTHER': '其他',
  'pages.sys3.hw.metric.FIT': 'FIT（失效率）',
  'pages.sys3.hw.metric.SPFM': 'SPFM（单点故障度量）',
  'pages.sys3.hw.metric.LFM': 'LFM（潜伏故障度量）',
  'pages.sys3.hw.metric.PMHF': 'PMHF（随机硬件失效概率）',
  'pages.sys3.hw.metric.DIAG_COVERAGE': '诊断覆盖率',
  'pages.sys3.hw.verdict.PASS': '通过',
  'pages.sys3.hw.verdict.CONDITIONAL': '有条件通过',
  'pages.sys3.hw.verdict.FAIL': '不通过',
  'pages.sys3.hw.verdict.TBD': '待定',
  'pages.sys3.hw.pinSource.CONNECTOR': '接插件管脚',
  'pages.sys3.hw.pinSource.CHIP_PIN': '芯片管脚',
  'pages.sys3.hw.pinSource.LOCAL': '板内管脚',

  // ---- S6：SWE.3 软件详细设计（PAM SWE.3-T-0002 + ISO 26262-6 §8） ----
  'pages.sys3.swe3Title': '软件详细设计',
  'pages.sys3.doc.tab.SWE3.STATIC': '软件静态设计',
  'pages.sys3.doc.tab.SWE3.INTERFACE': '组件接口设计',
  'pages.sys3.doc.tab.SWE3.DYNAMIC': '软件动态设计',
  'pages.sys3.doc.tab.SWE3.UNIT': '单元详细设计',
  'pages.sys3.doc.tab.SWE3.ALLOCATION': '需求分配',
  'pages.sys3.ws.groupUnit': '单元详细设计',
  'pages.sys3.ws.kind.CLASS': '类图',
  'pages.sys3.ws.kind.ACTIVITY': '活动图',
  'pages.sys3.ws.kind.FLOWCHART': '单元流程图',
  'pages.sys3.table.units': '软件单元清单',
  'pages.sys3.table.designs': '单元设计说明',
  'pages.sys3.table.classes': '类清单',
  'pages.sys3.table.componentNotes': '组件（函数）描述',
  'pages.sys3.table.unitInterfaces': '单元接口',
  'pages.sys3.table.dataStructures': '数据结构',
  'pages.sys3.table.globalVars': '全局变量',
  'pages.sys3.table.parameters': '常量与应用参数',
  'pages.sys3.table.externalFunctions': '外部函数定义',
  'pages.sys3.table.unitFunctions': '函数设计',
  'pages.sys3.table.codeUnits': '代码单元映射',
  'pages.sys3.table.activitySteps': '活动步骤',
  // 空表提示（模板里这一章该填什么）
  'pages.sys3.swe3.hintUnits':
    '这一章还没有软件单元，按「单元名 / 所属组件 / 类型 / 规模」录入；单元要能对上 SWE.2 的组件',
  'pages.sys3.swe3.hintDesigns':
    '这一章还没有单元设计说明，按「单元 / 设计类型 / 设计描述 / 错误处理」录入',
  'pages.sys3.swe3.hintClasses':
    '这一章还没有类，按「类名 / 种类 / 基类 / 成员」录入；纯 C 项目可以跳过本章',
  'pages.sys3.swe3.hintComponentNotes':
    '这一章还没有组件描述；组件本身来自 SWE.2，这里只补「目标 / 输入 / 输出」',
  'pages.sys3.swe3.hintUnitInterfaces':
    '这一章还没有单元接口；每条接口必须写「数据类型 + 取值范围 + 单位」（PAM SWE.3.BP1）',
  'pages.sys3.swe3.hintDataStructures':
    '这一章还没有数据结构；按「结构名 / 种类 / 字段组成 / 占用字节」录入',
  'pages.sys3.swe3.hintGlobalVars':
    '这一章还没有全局变量；每个全局变量都必须写「使用理由」（ISO 26262-6 表 6）',
  'pages.sys3.swe3.hintParameters':
    '这一章还没有参数；常量给「值」，应用参数必须给「范围 + 换算 + 默认值」',
  'pages.sys3.swe3.hintExternalFunctions':
    '这一章还没有外部函数；按「原型 / 来源 / 参数 / 返回值 / 调用约束」录入',
  'pages.sys3.swe3.hintUnitFunctions':
    '这一章还没有函数设计；每个函数要写到「前置 / 后置条件 + 算法步骤 + 异常处理」都清楚',
  'pages.sys3.swe3.hintCodeUnits':
    '这一章还没有代码映射；按「单元 / 文件 / 函数 / 行数」录入，单元格是 SWE.4 的测试对象',
  'pages.sys3.swe3.hintActivitySteps':
    '这一章还没有活动步骤；按「序号 / 动作 / 类型 / 条件 / 下一步」录入',
  // 列名
  'pages.sys3.swe3.colUnit': '软件单元',
  'pages.sys3.swe3.colUnitType': '单元类型',
  'pages.sys3.swe3.colComponent': '所属组件',
  'pages.sys3.swe3.colLanguage': '语言',
  'pages.sys3.swe3.colPlannedLoc': '预计行数',
  'pages.sys3.swe3.colComplexity': '圈复杂度',
  'pages.sys3.swe3.colDescription': '说明',
  'pages.sys3.swe3.colAsil': 'ASIL 能力',
  'pages.sys3.swe3.colFilePath': '实现文件',
  'pages.sys3.swe3.colDesignType': '设计类型',
  'pages.sys3.swe3.colDesignDescription': '设计描述',
  'pages.sys3.swe3.colErrorHandling': '错误处理',
  'pages.sys3.swe3.colReviewStatus': '评审状态',
  'pages.sys3.swe3.colInterfaceSpec': '接口与依赖',
  'pages.sys3.swe3.colResourceConstraint': '资源约束',
  'pages.sys3.swe3.colClassKind': '种类',
  'pages.sys3.swe3.colVisibility': '可见性',
  'pages.sys3.swe3.colBaseClass': '基类',
  'pages.sys3.swe3.colMembers': '成员',
  'pages.sys3.swe3.colRelation': '类关系',
  'pages.sys3.swe3.colRelatedClass': '关联类',
  'pages.sys3.swe3.colMethods': '方法',
  'pages.sys3.swe3.colGoal': '目标',
  'pages.sys3.swe3.colInputs': '输入',
  'pages.sys3.swe3.colOutputs': '输出',
  'pages.sys3.swe3.colProvider': '提供方',
  'pages.sys3.swe3.colConsumer': '使用方',
  'pages.sys3.swe3.colDataType': '数据类型',
  'pages.sys3.swe3.colValueRange': '取值范围',
  'pages.sys3.swe3.colMeasureUnit': '单位',
  'pages.sys3.swe3.colDefault': '默认值',
  'pages.sys3.swe3.colDirection': '方向',
  'pages.sys3.swe3.colStructKind': '种类',
  'pages.sys3.swe3.colSizeBytes': '占用字节',
  'pages.sys3.swe3.colScope': '作用域',
  'pages.sys3.swe3.colInitialValue': '初值',
  'pages.sys3.swe3.colReason': '使用理由',
  'pages.sys3.swe3.colWriters': '写入方',
  'pages.sys3.swe3.colReaders': '读取方',
  'pages.sys3.swe3.colParamKind': '参数种类',
  'pages.sys3.swe3.colValue': '值',
  'pages.sys3.swe3.colScale': '换算关系',
  'pages.sys3.swe3.colPrototype': '原型',
  'pages.sys3.swe3.colSource': '来源',
  'pages.sys3.swe3.colLibrary': '所属库',
  'pages.sys3.swe3.colConstraint': '调用约束',
  'pages.sys3.swe3.colParams': '参数',
  'pages.sys3.swe3.colReturnType': '返回值',
  'pages.sys3.swe3.colPurpose': '用途',
  'pages.sys3.swe3.colFunctionName': '函数名',
  'pages.sys3.swe3.colBranches': '分支数',
  'pages.sys3.swe3.colFunctionKind': '函数种类',
  'pages.sys3.swe3.colPreCondition': '前置条件',
  'pages.sys3.swe3.colPostCondition': '后置条件',
  'pages.sys3.swe3.colAlgorithm': '算法步骤',
  'pages.sys3.swe3.colCodeFile': '实现文件',
  'pages.sys3.swe3.colLines': '代码行数',
  'pages.sys3.swe3.colGenerated': '自动生成',
  'pages.sys3.swe3.colStaticAnalysis': '静态分析',
  'pages.sys3.swe3.colSeq': '序号',
  'pages.sys3.swe3.colAction': '动作',
  'pages.sys3.swe3.colStepKind': '节点类型',
  'pages.sys3.swe3.colCondition': '条件',
  'pages.sys3.swe3.colNextStep': '下一步',
  // 枚举（不同 group 共用一套词条：CLASS / OTHER / STRUCT 这些值语义一致）
  'pages.sys3.swe3.enum.FUNCTION': '函数',
  'pages.sys3.swe3.enum.CLASS': '类',
  'pages.sys3.swe3.enum.MODULE': '模块',
  'pages.sys3.swe3.enum.ISR': '中断服务程序',
  'pages.sys3.swe3.enum.LIBRARY': '库',
  'pages.sys3.swe3.enum.OTHER': '其它',
  'pages.sys3.swe3.enum.ALGORITHM': '算法',
  'pages.sys3.swe3.enum.STATE_MACHINE': '状态机',
  'pages.sys3.swe3.enum.SEQUENCE': '时序',
  'pages.sys3.swe3.enum.DATA_STRUCTURE': '数据结构',
  'pages.sys3.swe3.enum.DRAFT': '草稿',
  'pages.sys3.swe3.enum.IN_REVIEW': '评审中',
  'pages.sys3.swe3.enum.REVIEWED': '已评审',
  'pages.sys3.swe3.enum.APPROVED': '已批准',
  'pages.sys3.swe3.enum.ABSTRACT': '抽象类',
  'pages.sys3.swe3.enum.INTERFACE': '接口',
  'pages.sys3.swe3.enum.STRUCT': '结构体',
  'pages.sys3.swe3.enum.ENUM': '枚举',
  'pages.sys3.swe3.enum.UNION': '联合体',
  'pages.sys3.swe3.enum.TYPEDEF': '类型定义',
  'pages.sys3.swe3.enum.PUBLIC': '公有',
  'pages.sys3.swe3.enum.PROTECTED': '保护',
  'pages.sys3.swe3.enum.PRIVATE': '私有',
  'pages.sys3.swe3.enum.PACKAGE': '包内',
  'pages.sys3.swe3.enum.INHERIT': '继承',
  'pages.sys3.swe3.enum.REALIZE': '实现',
  'pages.sys3.swe3.enum.COMPOSE': '组合',
  'pages.sys3.swe3.enum.AGGREGATE': '聚合',
  'pages.sys3.swe3.enum.ASSOCIATE': '关联',
  'pages.sys3.swe3.enum.DEPEND': '依赖',
  'pages.sys3.swe3.enum.NONE': '无',
  'pages.sys3.swe3.enum.IN': '输入',
  'pages.sys3.swe3.enum.OUT': '输出',
  'pages.sys3.swe3.enum.INOUT': '双向',
  'pages.sys3.swe3.enum.ARRAY': '数组',
  'pages.sys3.swe3.enum.BITFIELD': '位域',
  'pages.sys3.swe3.enum.GLOBAL': '全局',
  'pages.sys3.swe3.enum.FILE_STATIC': '文件内静态',
  'pages.sys3.swe3.enum.EXTERN': '外部声明',
  'pages.sys3.swe3.enum.CONST': '常量',
  'pages.sys3.swe3.enum.APP': '应用参数',
  'pages.sys3.swe3.enum.BSW': '基础软件',
  'pages.sys3.swe3.enum.OS': '操作系统',
  'pages.sys3.swe3.enum.DRIVER': '驱动',
  'pages.sys3.swe3.enum.THIRD_PARTY': '第三方',
  'pages.sys3.swe3.enum.CALLBACK': '回调',
  'pages.sys3.swe3.enum.UTILITY': '工具',
  'pages.sys3.swe3.enum.YES': '是',
  'pages.sys3.swe3.enum.NO': '否',
  'pages.sys3.swe3.enum.START': '开始',
  'pages.sys3.swe3.enum.ACTION': '动作',
  'pages.sys3.swe3.enum.DECISION': '判断',
  'pages.sys3.swe3.enum.MERGE': '汇合',
  'pages.sys3.swe3.enum.CALL': '调用',
  'pages.sys3.swe3.enum.WAIT': '等待',
  'pages.sys3.swe3.enum.END': '结束',
  // ===== S6-a：SWE.4/5/6 验证侧 =====
  'pages.sys3.verTitle': '验证文档',
  'pages.sys3.doc.tab.VER.PLAN': '验证计划',
  'pages.sys3.doc.tab.VER.INTEGRATION': '软件集成',
  'pages.sys3.doc.tab.VER.INTEGRATION_SYS': '系统集成',
  'pages.sys3.doc.tab.VER.INTEGRATION_HW': '硬件集成',
  'pages.sys3.doc.tab.VER.SPECS': '验证规范',
  'pages.sys3.doc.tab.VER.RESULTS': '验证结果',
  'pages.sys3.doc.tab.VER.COVERAGE': '覆盖度',
  'pages.sys3.table.strategies': '验证策略',
  'pages.sys3.table.assumptions': '假设与约束',
  'pages.sys3.table.testCases': '测试用例',
  'pages.sys3.table.codeReviews': '代码评审',
  'pages.sys3.table.integrationItems': '集成项',
  'pages.sys3.table.coverage': '覆盖度',
  'pages.sys3.ver.colName': '名称',
  'pages.sys3.ver.colMethod': '方法',
  'pages.sys3.ver.colTool': '工具',
  'pages.sys3.ver.colEnvironment': '环境',
  'pages.sys3.ver.colEntryCriteria': '准入准则',
  'pages.sys3.ver.colNote': '说明',
  'pages.sys3.ver.colCategory': '种类',
  'pages.sys3.ver.colStatus': '状态',
  'pages.sys3.ver.colContent': '内容',
  'pages.sys3.ver.colImpact': '影响与对策',
  'pages.sys3.ver.colTitle': '标题',
  'pages.sys3.ver.colLevel': '测试等级',
  'pages.sys3.ver.colRequirement': '关联需求',
  'pages.sys3.ver.colCaseStatus': '执行状态',
  'pages.sys3.ver.colTestDate': '测试日期',
  'pages.sys3.ver.colEnv': '测试环境',
  'pages.sys3.ver.colPath': '代码路径',
  'pages.sys3.ver.colStubs': '桩函数',
  'pages.sys3.ver.colInputs': '输入',
  'pages.sys3.ver.colPrecondition': '前提条件',
  'pages.sys3.ver.colSteps': '测试步骤',
  'pages.sys3.ver.colExpected': '预期结果',
  'pages.sys3.ver.colActual': '实际结果',
  'pages.sys3.ver.colProblem': '问题描述',
  'pages.sys3.ver.colRefs': '参考',
  'pages.sys3.ver.colExecutor': '测试者',
  'pages.sys3.ver.colModule': '模块',
  'pages.sys3.ver.colSubModule': '子模块',
  'pages.sys3.ver.colUnit': '被测单元',
  'pages.sys3.ver.colComponent': '被测组件',
  'pages.sys3.ver.colElement': '被测要素',
  'pages.sys3.ver.colVerdict': '结论',
  'pages.sys3.ver.colReviewer': '评审人',
  'pages.sys3.ver.colReviewDate': '评审日期',
  'pages.sys3.ver.colChecklistItem': '检查清单条目',
  'pages.sys3.ver.colRule': '规则',
  'pages.sys3.ver.colFinding': '发现',
  'pages.sys3.ver.colSeq': '顺序',
  'pages.sys3.ver.colComposition': '组成单元',
  'pages.sys3.ver.colCriteria': '集成准则',
  'pages.sys3.ver.colKind': '覆盖种类',
  'pages.sys3.ver.colTarget': '目标',
  'pages.sys3.ver.hintStrategies':
    '这一章还没有验证策略，按「单元测试 / 静态检查 / 评审」等方式逐条录入',
  'pages.sys3.ver.hintAssumptions':
    '这一章还没有假设与约束，计划里「前提不成立时怎么办」的结论录在这里',
  'pages.sys3.ver.hintTestCases':
    '这一章还没有测试用例，按规范模板的列逐条录入（方法 / 步骤 / 预期结果）',
  'pages.sys3.ver.hintCodeReviews':
    '这一章还没有代码评审记录，按代码评审检查清单（C-0004）的条目录入',
  'pages.sys3.ver.hintIntegrationItems':
    '这一章还没有集成项，按集成顺序逐层录入（组成单元 + 集成准则）',
  'pages.sys3.ver.hintCoverage':
    '这一章还没有覆盖度数据，录「需求覆盖 / 语句覆盖 / 分支覆盖 / MC-DC」的目标值与实际值',
  'pages.sys3.ver.enum.UNIT_TEST': '单元测试',
  'pages.sys3.ver.enum.STATIC_CHECK': '静态检查',
  'pages.sys3.ver.enum.REVIEW': '评审',
  'pages.sys3.ver.enum.INTEGRATION': '集成',
  'pages.sys3.ver.enum.INTERFACE_TEST': '接口测试',
  'pages.sys3.ver.enum.PERFORMANCE_TEST': '性能测试',
  'pages.sys3.ver.enum.QUALIFICATION_TEST': '认可测试',
  'pages.sys3.ver.enum.TEST': '测试',
  'pages.sys3.ver.enum.ANALYSIS': '分析',
  'pages.sys3.ver.enum.SIMULATION': '仿真',
  'pages.sys3.ver.enum.INSPECTION': '走查',
  'pages.sys3.ver.enum.OTHER': '其它',
  'pages.sys3.ver.enum.UNIT': '单元级',
  'pages.sys3.ver.enum.COMPONENT': '组件级',
  'pages.sys3.ver.enum.QUALIFICATION': '认可级',
  'pages.sys3.ver.enum.NOT_RUN': '未执行',
  'pages.sys3.ver.enum.PASS': '通过',
  'pages.sys3.ver.enum.FAIL': '失败',
  'pages.sys3.ver.enum.BLOCKED': '阻塞',
  'pages.sys3.ver.enum.NA': '不适用',
  'pages.sys3.ver.enum.CONDITIONAL': '有条件通过',
  'pages.sys3.ver.enum.TBD': '待定',
  'pages.sys3.ver.enum.PLANNED': '计划',
  'pages.sys3.ver.enum.INTEGRATED': '已集成',
  'pages.sys3.ver.enum.VERIFIED': '已验证',
  'pages.sys3.ver.enum.FAILED': '失败',
  'pages.sys3.ver.enum.REQUIREMENT': '需求覆盖',
  'pages.sys3.ver.enum.STATEMENT': '语句覆盖',
  'pages.sys3.ver.enum.BRANCH': '分支覆盖',
  'pages.sys3.ver.enum.MCDC': 'MC/DC 覆盖',
  'pages.sys3.ver.enum.CALL': '调用覆盖',
  'pages.sys3.ver.enum.FUNCTION': '函数覆盖',
  'pages.sys3.ver.enum.ASSUMPTION': '假设',
  'pages.sys3.ver.enum.CONSTRAINT': '约束',
  'pages.sys3.ver.enum.OPEN': '打开',
  'pages.sys3.ver.enum.CLOSED': '关闭',
  'pages.safety.title': '安全分析工作台',
  'pages.safety.loadFailed': '获取安全分析数据失败',
  'pages.safety.saveFailed': '保存失败',
  'pages.safety.saved': '已保存',
  'pages.safety.save': '保存',
  'pages.safety.reload': '刷新',
  'pages.safety.edit': '编辑',
  'pages.safety.delete': '删除',
  'pages.safety.unsaved': '有未保存的修改',
  'pages.safety.summary': '分析对象 {{a}} · 分析项 {{i}} · 不适用 {{n}}',
  'pages.safety.consistency.title': '一致性检查：{{e}} 个错误 · {{w}} 个提示',
  'pages.safety.tab.analyses': '分析对象',
  'pages.safety.tab.items': '分析项明细',
  'pages.safety.tab.metrics': '架构度量看板',
  'pages.safety.tab.na': '不适用论证',
  'pages.safety.analysis.id': '编号',
  'pages.safety.analysis.type': '方法',
  'pages.safety.analysis.title': '分析对象',
  'pages.safety.analysis.titleHint': '例：域控制器系统 FMEA / 制动扭矩安全目标故障树',
  'pages.safety.analysis.objective': '分析目标与边界',
  'pages.safety.analysis.refs': '关联安全目标 / 需求 / 要素（逗号分隔）',
  'pages.safety.analysis.applicable': '适用性',
  'pages.safety.analysis.applicableYes': '适用',
  'pages.safety.analysis.na': '不适用',
  'pages.safety.analysis.naMissing': '未填写理由',
  'pages.safety.analysis.status': '状态',
  'pages.safety.analysis.add': '新增分析对象',
  'pages.safety.analysis.empty': '还没有分析对象：先从安全目标起一棵 FTA，或建一张 FMEA',
  'pages.safety.analysis.modalTitle': '分析对象',
  'pages.safety.analysis.note': '备注',
  'pages.safety.analysis.confirmDelete': '删除这个分析对象及其分析项？',
  'pages.safety.item.id': '编号',
  'pages.safety.item.name': '名称 / 分析对象',
  'pages.safety.item.parent': '父节点',
  'pages.safety.item.gate': '门',
  'pages.safety.item.seq': '顺序',
  'pages.safety.item.voteK': '表决 k',
  'pages.safety.item.voteKHint':
    '仅 VOTE 门有效：n 个输入中任意 k 个失效即顶事件成立（如 2/3 填 2）。留空按「全部输入都失效」处理。',
  'pages.safety.item.event': '底事件 / 失效描述',
  'pages.safety.item.failureMode': '失效模式',
  'pages.safety.item.effect': '影响',
  'pages.safety.item.faultClass': '故障类别',
  'pages.safety.item.dc': 'DC（0–1）',
  'pages.safety.item.fit': '失效率（FIT）',
  'pages.safety.item.coupling': '耦合因子',
  'pages.safety.item.couplingHint': '共享供电 / 时钟 / 硅片 / PCB / 编译器 / 开发团队…',
  'pages.safety.item.measure': '措施',
  'pages.safety.item.refs': '关联需求 / 要素编号（逗号分隔）',
  'pages.safety.item.status': '状态',
  'pages.safety.item.note': '备注',
  'pages.safety.item.actions': '操作',
  'pages.safety.item.add': '新增分析项',
  'pages.safety.item.empty': '这个分析还没有分析项',
  'pages.safety.item.modalTitle': '分析项',
  'pages.safety.item.pickAnalysis': '分析对象',
  'pages.safety.item.ftaReadonly': 'FTA 树真源在 SYS.3，这里只读',
  'pages.safety.item.noAnalysis': '先建一个分析对象',
  'pages.safety.item.confirmDelete': '删除这条分析项？',
  // —— S6-c-2 措施处置与落点 ——
  'pages.safety.item.disposition': '处置',
  'pages.safety.item.target': '落点',
  'pages.safety.item.targetMissing': '未给落点',
  'pages.safety.item.targetKind': '落点类别',
  'pages.safety.item.targetId': '落点编号',
  'pages.safety.item.targetRequired': '已采纳的措施必须给落点（要素 / 需求 / 验证措施编号）',
  'pages.safety.item.rejectReason': '拒绝理由',
  'pages.safety.item.rejectReasonRequired': '拒绝措施必须写理由，评审要能看懂为什么不采纳',
  'pages.safety.item.rejectReasonHint': '已有设计约束覆盖 / 成本不可接受 / 归入下一阶段…',
  'pages.safety.item.owner': '责任人',
  'pages.safety.item.due': '期限',
  'pages.safety.item.changeRef': '变更单 / 设计决策号',
  'pages.safety.disposition.PENDING': '待处理',
  'pages.safety.disposition.ADOPTED': '已采纳',
  'pages.safety.disposition.REJECTED': '已拒绝',
  'pages.safety.disposition.DEFERRED': '延期',
  'pages.safety.targetKind.ELEMENT': '架构要素',
  'pages.safety.targetKind.REQUIREMENT': '需求',
  'pages.safety.targetKind.VERIFICATION': '验证措施',
  'pages.safety.targetKind.NONE': '不落设计',
  // —— S6-c-3 FMEA 五步 / FMEDA 模板 ——
  'pages.safety.item.function': '功能',
  'pages.safety.item.functionHint': 'P3 功能分析：这个要素 / 组件应该完成什么',
  'pages.safety.item.partRef': '元器件（位号 / 架构要素）',
  'pages.safety.item.modeDist': '模式占比',
  'pages.safety.item.relevantFit': '相关 FIT（自动算）',
  'pages.safety.item.smRef': '安全机制 SM',
  'pages.safety.item.smRefHint': '选 SM 后自动带出可达 DC',
  'pages.safety.item.ap': '行动优先级 AP（自动查表）',
  'pages.safety.item.apPending': '三项填齐后出 AP',
  'pages.safety.item.detection': '现行控制（预防 / 探测）',
  'pages.safety.mech.add': '新增安全机制',
  'pages.safety.mech.empty': '还没有安全机制——FMEDA 行引用 SM 后可自动带出 DC',
  'pages.safety.mech.id': 'SM 编号',
  'pages.safety.mech.description': '机制描述',
  'pages.safety.mech.descriptionHint': '例：电压监测比较器（窗口 ±5%），失效进入安全状态',
  'pages.safety.mech.dc': '可达 DC（0–1）',
  'pages.safety.mech.ref': 'ISO 26262-5 附录 D 条目',
  'pages.safety.mech.usedBy': '被引用',
  'pages.safety.mech.confirmDelete': '删除这个安全机制？引用它的行会失去 DC 默认值',
  'pages.safety.mech.modalTitle': '安全机制',
  'pages.safety.wizard.mechHint':
    '先维护安全机制清单（SM 编号 + 可达 DC，参照 ISO 26262-5 附录 D），再到上面的表里按行引用 SM。',
  'pages.safety.metrics.empty':
    '还没有 FMEDA 分析项——度量由 FMEDA 项（失效率 / DC / 故障类别）聚合计算',
  'pages.safety.metrics.asil': '安全目标 ASIL',
  'pages.safety.metrics.scope': '计入 {{n}} 项 · 总失效率 {{fit}} FIT',
  'pages.safety.metrics.spfmHint': '残余单点 / 残余故障占比越低越好',
  'pages.safety.metrics.lfmHint': '潜伏多点故障的诊断覆盖能力',
  'pages.safety.metrics.pmhfHint': '每小时概率，越低越好',
  'pages.safety.metrics.noteTitle': '度量口径',
  'pages.safety.metrics.noteBody':
    '目标值取自 ISO 26262-5:2018 表 4 / 5 / 6；ASIL A 与 QM 无量化目标。',
  'pages.safety.na.notice': '空白会被评估师判「未执行」；「不适用 + 理由」才判「已裁剪」。',
  'pages.safety.na.noticeBody':
    '纯软件项目把硬件层分析标为不适用并写清理由（如「无硬件开发」）；纯硬件项目反之。',
  'pages.safety.na.empty': '没有标记不适用的分析',
  'pages.safety.na.reason': '不适用理由（不适用时必填）',
  'pages.safety.na.placeholder': '例：本项目为纯软件产品，无硬件开发',
  'pages.safety.footnote':
    '三层归位：FTA 只建一棵树（真源在 SYS.3），其余层只读子树；FMEA / FMEDA / DFA 每层各为真源。本页数据与既有「安全分析」文档列表互不替代。',
  // —— S6-c-2 分析任务清单 ——
  'pages.safety.task.tab': '分析任务 {{n}}',
  'pages.safety.task.title': '任务名称',
  'pages.safety.task.method': '方法',
  'pages.safety.task.scope': '范围（分析谁）',
  'pages.safety.task.anchor': '起点（从哪起）',
  'pages.safety.task.progress': '进度',
  'pages.safety.task.progressText': '{{done}}/{{total}} 步 · 待处理 {{pending}}',
  'pages.safety.task.assumed': '假设',
  'pages.safety.task.assumedTip':
    '本地假设输入：没有可引用的上游 HARA / FSC，一致性检查降级为提示，不报错',
  'pages.safety.task.readonly': '只读',
  'pages.safety.task.readonlyTip': 'FTA 树真源在 SYS.3，本过程只读子树',
  'pages.safety.task.preview': '预览',
  'pages.safety.task.edit': '编辑',
  'pages.safety.task.na': '不适用',
  'pages.safety.task.allItems': '全部分析项（只读，{{n}} 条）',
  'pages.safety.task.empty': '还没有分析任务：按「应有 vs 已有」补一个必做的方法',
  // —— S6-c-2 新建 / 编辑任务 ——
  'pages.safety.form.method': '分析方法',
  'pages.safety.form.upstream': '上游输入',
  'pages.safety.form.upstreamInherited': '引用上游（HARA 安全目标 / FSC 功能安全需求）',
  'pages.safety.form.upstreamAssumed': '本地假设（本层自己起，上游暂缺）',
  'pages.safety.form.assumedStart': '假设起点描述',
  'pages.safety.form.assumedStartHint': '例：假定整车功能安全目标为「避免非预期制动扭矩」',
  'pages.safety.form.assumedWarn':
    '本地假设模式：本文档不引用真实上游，一致性检查只提示不报错；上游就绪后建议切回引用。',
  'pages.safety.form.scope': '范围（分析谁）',
  'pages.safety.form.scopeHint': '选架构要素；DFA 可留空并写耦合假设',
  'pages.safety.form.anchor': '起点（从哪起）',
  'pages.safety.form.anchorFTA': '顶事件',
  'pages.safety.form.anchorFMEA': '被分析的要素 / 功能',
  'pages.safety.form.anchorFMEDA': '被分析的硬件要素',
  'pages.safety.form.anchorDFA': '耦合假设',
  'pages.safety.form.anchorSW': '被分析的软件组件',
  'pages.safety.form.asil': 'ASIL',
  'pages.safety.form.status': '状态',
  'pages.safety.form.objective': '目标与边界',
  'pages.safety.form.refs': '关联清单（逗号分隔）',
  'pages.safety.form.note': '备注',
  // —— S6-c-2 应有 vs 已有矩阵 ——
  'pages.safety.matrix.title': '应有 vs 已有',
  'pages.safety.matrix.subtitle':
    '按 ISO 26262-4 表 1 / -5 §8 / -9 §7 推导「本层应当有哪些分析」，与实际已建任务比对',
  'pages.safety.matrix.rowGoal': '按安全目标',
  'pages.safety.matrix.rowElement': '按架构要素',
  'pages.safety.matrix.have': '已有',
  'pages.safety.matrix.missing': '缺口',
  'pages.safety.matrix.na': '不适用',
  'pages.safety.matrix.waived': '已关闭',
  'pages.safety.matrix.waive': '关闭这一格',
  'pages.safety.matrix.waiveReason': '为什么不适用？（关闭理由必填，评审要能看懂）',
  'pages.safety.matrix.restore': '恢复全部推导',
  'pages.safety.matrix.waivedList': '已关闭的推导（{{n}} 条）',
  'pages.safety.matrix.basis': '推导依据（标准原文）',
  'pages.safety.matrix.create': '建任务',
  'pages.safety.matrix.emptyGoals': '没有可用的安全目标 / 需求：请先在 FSC 完成安全目标',
  'pages.safety.matrix.emptyElements': '没有架构要素：请先在架构页建立要素清单',
  'pages.safety.matrix.noAsil': '未定 ASIL：按 QM 处理，只推 FMEA 必做',
  // —— S6-c-2 措施指标条 / 提交评审 ——
  'pages.safety.strip.total': '措施 {{n}}',
  'pages.safety.strip.adopted': '已采纳 {{n}}',
  'pages.safety.strip.pending': '待处理 {{n}}',
  'pages.safety.strip.rejected': '已拒绝 {{n}}',
  'pages.safety.strip.deferred': '延期 {{n}}',
  'pages.safety.strip.assumed': '假设输入 {{n}}',
  'pages.safety.strip.gap': '未给落点 {{n}}',
  'pages.safety.review.submit': '提交评审',
  'pages.safety.review.title': '评审预检未通过',
  'pages.safety.review.pass': '评审预检通过：没有硬缺口',
  'pages.safety.review.blockers': '有 {{n}} 项必须先处理：',
  'pages.safety.review.gapsTitle': '已采纳但未给落点（{{n}} 条）',
  'pages.safety.review.hint':
    '预检只拦三类硬缺口：没有起点、拒绝措施没理由、有措施未处置。其余一致性问题只提示，不阻断。',
  // —— S6-c-2 向导 ——
  'pages.safety.wizard.back': '返回任务清单',
  'pages.safety.wizard.modeEdit': '编辑中',
  'pages.safety.wizard.modeReadonly': '只读',
  'pages.safety.wizard.step': '步骤 {{now}} / {{total}}',
  'pages.safety.wizard.prev': '上一步',
  'pages.safety.wizard.next': '下一步',
  'pages.safety.wizard.gap': '本步还差：{{gap}}',
  'pages.safety.wizard.done': '本步已完成',
  'pages.safety.wizard.tableView': '明细表',
  'pages.safety.wizard.treeView': '树视图',
  'pages.safety.wizard.modeTable': '明细表',
  'pages.safety.wizard.modeTree': '树视图',
  'pages.safety.wizard.treeTodo': '树视图（图形化故障树）在下一版提供，本轮请用明细表',
  'pages.safety.wizard.needStart': '先回任务清单补「起点」',
  'pages.safety.wizard.measuresPending': '待处置措施 {{n}} 条',
  'pages.safety.wizard.finishHint':
    '走完全部步骤即可提交评审；「提交评审」只检查硬缺口，不替代评审记录。',
  // —— S6-c-3 故障树（图 → 表） ——
  'pages.safety.fta.empty': '还没有故障树节点：先在明细表里建顶事件与底事件',
  'pages.safety.fta.hint': '图是主视图：结构在明细表里改，这里看树形与计算结果',
  'pages.safety.fta.mission': '任务时间',
  'pages.safety.fta.recalc': '重新计算',
  'pages.safety.fta.topProb': '顶事件概率上界',
  'pages.safety.fta.topProbHint': '（割集概率和，保守）',
  'pages.safety.fta.cutCount': '最小割集',
  'pages.safety.fta.minOrder': '最小阶数',
  'pages.safety.fta.cut': '最小割集',
  'pages.safety.fta.order': '阶数',
  'pages.safety.fta.prob': '割集概率',
  'pages.safety.fta.missingRate': '有底事件未填 FIT',
  'pages.safety.fta.spf': '单点',
  'pages.safety.fta.importance': 'FV 重要度（谁对顶事件贡献最大）',
  'pages.safety.fta.event': '底事件',
  'pages.safety.fta.share': '贡献占比',
  'pages.safety.fta.needStart': '这个分析对象没有「起点」，先回任务清单指定顶事件',
  'pages.safety.fta.calcFailed': '割集计算失败',
  // —— S6-c-3c FMEDA BOM 双入口 ——
  'pages.safety.bom.hint':
    'BOM 就是这一轮 FMEDA 的分析范围（FMEDA 行本身），不是另存一张表。优先从架构要素选，导出的度量才能反挂到架构覆盖检查上。',
  'pages.safety.bom.fromArch': '从架构要素选择',
  'pages.safety.bom.import': '导入 BOM（粘贴 / CSV）',
  'pages.safety.bom.partRef': '位号 / 架构要素',
  'pages.safety.bom.noRef': '未指定',
  'pages.safety.bom.empty': '还没有元器件——从架构要素勾选，或导入本地 BOM',
  'pages.safety.bom.unmatched': '{{n}} 行未对上架构要素：{{list}}',
  'pages.safety.bom.unmatchedHint':
    '不影响计算，但这些行不会被架构覆盖检查统计到；若它是某要素的器件，把位号改成要素编号即可。',
  'pages.safety.bom.pickTitle': '从架构要素选择（本轮 FMEDA 范围）',
  'pages.safety.bom.pickHint':
    '只勾本轮要算的要素；已在 BOM 里的会置灰。选中后每个要素生成一行，位号写要素编号。',
  'pages.safety.bom.pickOk': '加入 BOM（{{n}}）',
  'pages.safety.bom.inBom': '（已在 BOM）',
  'pages.safety.bom.noArch':
    '本项目还没有可用的架构要素（先到 SYS.3 / HWE.2 架构页建要素），或直接用导入方式。',
  'pages.safety.bom.importTitle': '导入 BOM',
  'pages.safety.bom.importHint':
    '每行一个器件，列顺序：位号 / 名称 / 失效率(FIT) / 数量，逗号或 Tab 分隔，可直接从 Excel 复制粘贴。首行表头会被自动跳过。',
  'pages.safety.bom.chooseFile': '选文件',
  'pages.safety.bom.reparse': '重新解析',
  'pages.safety.bom.importOk': '导入（{{n}}）',
  'pages.safety.bom.importUnmatched': '{{n}} 行位号对不上架构要素，会标「未入架构」',
  'pages.safety.bom.importUnmatchedHint':
    '可继续导入（FMEDA 粒度常比架构要素细）；对不上的行不会被架构覆盖检查统计。',
  'pages.safety.bom.match': '架构对账',
  'pages.safety.bom.matched': '已关联',
  'pages.safety.bom.notInArch': '未入架构',
  'pages.safety.wizard.bomHint':
    '确定范围后，下一步给每个器件填失效模式与占比；基准 λ 也可以在这一步的表里直接改。',
};
